import React, { useState, useEffect, useRef, useMemo, useContext, useCallback } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Select, { components } from 'react-select';
import ReactDatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import UserService from '../../Services/user.service.js';
import '../../pages/OtherDocuments/OtherDocument.css';
import '../../pages/BankMatching/BankMatching.css'; // Custom animations
import backIcon from '../../assests/images/left-arrow.png';
import EnumsService from '../../Services/enums.service.js';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal.js'
import { ToastContainer, toast } from "react-toastify";
import PuffLoader from "react-spinners/PuffLoader";
import SaveIcon from '@mui/icons-material/Save'; // Save icon
import ClearIcon from '@mui/icons-material/Clear';
import AdvancedDropdown from '../../Components/AdvancedDropdown/AdvancedDropdown.js';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import CardMatchService from '../../Services/cardMatch.service.js';
import Swal from 'sweetalert2';
import { useBack } from "use-back";

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Constants from '../../assests/Constants/constants.js';
import useCaseSystemAccountSettings from '../../hooks/useCaseSystemAccountSettings.js';
import { DataGrid, useGridApiRef, GridToolbar } from '@mui/x-data-grid';
import { styled, darken, lighten } from '@mui/material/styles';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { arSD, heIL, enUS } from '@mui/x-data-grid/locales';
import CustomMonthDatePicker from '../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker.js';
import CustomDropdown from '../../Components/CustomDropdown/CustomDropdown.js';
import EditModal from '../../Components/EditModal/EditModal.js';
//table imports
import { Edit as EditIcon, Delete as DeleteIcon, Download as DownloadIconMui, Search as SearchIcon, CancelRounded, FilterAltOff as FilterAltOffIcon } from '@mui/icons-material';
import {
    Button, Dialog, DialogTitle, DialogContent, Box, DialogActions, Typography, TextField, Checkbox, InputAdornment,
    Tooltip, DialogContentText, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, MenuItem,
    Switch, CircularProgress, IconButton, Autocomplete, FormControlLabel, Card, CardContent, Grid, Divider,
    Breadcrumbs, Link as MUILink
} from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { getVatBySortCode } from '../../Utils/GetVatBySortCodes.js';
import { beautifyNumber } from '../../Utils/FormatNumber.js';
import { getReferenceLastDigits } from '../../Utils/matchingUtils.js';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import ImportDialog from '../../Components/BankMatching/ImportDialog.js';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import KeyboardShortcutsDialog from '../../Components/BankMatching/KeyboardShortcutsDialog.jsx';
import { focusFirstField, handleDialogEnterNavigation } from '../../Utils/dialogKeyboardNav.js';
import DocumentService from '../../Services/documents.service.js';
import ExternalTransactionsService from '../../Services/externalTransaction.service.js';
import NoDocumentsPdf from "../../assests/pdf/NoDocument.pdf";
import ClientService from '../../Services/client.service.js';
import ClientDocumentCountService from '../../Services/ClientDocumentCount.service.js';
import EditPaymentAcceptanceModal from '../../Components/EditPaymentAcceptanceModal/EditPaymentAcceptanceModal.js';
import EditPaymentAcceptanceModalSpecificItem from '../../Components/EditPaymentAcceptanceModal/EditPaymentAcceptanceSpecificItem.js';

import CardMatchingBottomDockBar from '../../Components/CardMatching/SubComponents/CardMatchingBottomDockBar.js';
import CustomMonthDatePickerMui from '../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePickerMui.js';
import AddExternalTransactionDialog from '../../Components/BankMatching/AddExternalTransactionDialog.js';
import AddOrEditBankDialog from '../../Components/BankMatching/AddOrEditBankDialog.js';
import AddAccountCardDialog from '../../Components/AddAccountCardDialog/AddAccountCardDialog.js';
import AutocompleteSelectFilter from '../../Components/Widgets/AutocompleteSelectFilter/AutocompleteSelectFilter.jsx';
import MetricChip, { metricBarSx } from '../../Components/Widgets/MetricChip/MetricChip.jsx';
import FilterToggleGroup from '../../Components/Widgets/FilterToggleGroup/FilterToggleGroup.jsx';
import ActionChip, { toolbarIconButtonSx } from '../../Components/Widgets/ActionChip/ActionChip.jsx';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import '../Document/Document.scss';
import '../../styles/bankWorkspace.css';
import editIconImage from "../../assests/images/Icons/editIcon.svg";
import PaymentAcceptanceCreateEditModal from "../../Components/PaymentAcceptance/SubComponents/PaymentAcceptanceCreateEditModal.jsx";
import AccountAutocomplete from "../../Components/Widgets/AccountAutocomplete/AccountAutocomplete.js";
import AddAccountCardModal from '../../Components/Widgets/AddAccountCardModal/AddAccountCardModal.jsx';
import CustomYearDatePicker from '../../Components/Widgets/CustomDates/CustomYearDatePicker/CustomYearDatePicker.js';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext.js';
import { validateDocumentBeforeProcessing, validatePaymentAcceptanceItems } from '../../Utils/documentValidation'
import { buildPaymentAcceptanceUpdatePayload } from '../../Utils/paymentAcceptanceUpdatePayload.js'
import {
    getGridStringOperatorsWithComparison,
    getGridNumericOperatorsWithNotLike,
    getGridDateOperatorsWithNotLike,
} from '../../Utils/DataGridFilterOperators';
import ChooseAsset from "../../Components/Widgets/ChooseAsset/ChooseAsset.js";
import AssetService from '../../Services/assets.service.js';
import AddAssetGroup from '../../Components/Assets/SubComponents/AddAssetGroup.js';
import AssetFoundDialog from '../../Components/Widgets/AssetFoundDialog/AssetFoundDialog.js';
import DateFilterBar from '../../Components/CardMatching/DateFilterBar.jsx'; // Adjust path if needed
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext.js';
import { ROW_VIEW_MODES, collapseCardMatchingRows, expandSelectedIds } from '../../Utils/reconciliationSummary';
import SummaryRowLabel, { SummaryChildLabel } from '../../Components/Widgets/SummaryRowLabel/SummaryRowLabel.jsx';
import {
    buildUnmatchedCardsFlatSection,
    buildUnmatchedCardsSummary,
    buildUnmatchedSection,
    downloadUnmatchedExcel,
    downloadUnmatchedPdf,
} from '../../Utils/unmatchedExport';
import UnmatchedReportModal from '../../Components/Widgets/UnmatchedReportModal/UnmatchedReportModal.jsx';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import SummarizeIcon from '@mui/icons-material/Summarize';
registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it





// Create rtl cache
const cacheRtl = createCache({
    key: 'data-grid-rtl-demo',
    stylisPlugins: [prefixer, rtlPlugin],
});

// Maps a numeric ForeignCurrencyCode (enum value) back to its name (e.g. 0 -> "USD").
const currencyCodeToName = Object.fromEntries(
    Object.entries(Constants.ForeignCurrencyCode).map(([name, value]) => [value, name])
);

const MANUAL_RATE_DECIMALS = 10;

// Foreign currency is saved as a snapshot: the code, the foreign amount and the exact rate
// that produced the shekel amount, flagged Manual - the same contract EditModal uses.
// Without the rate the server re-converts with the representative rate of the save date,
// which can land on a shekel amount that no longer matches the card transaction.
// Returns null when the two amounts can't produce a meaningful rate.
const resolveManualRate = (shekelAmount, foreignAmount) => {
    const nis = Math.abs(Number(shekelAmount));
    const fc = Math.abs(Number(foreignAmount));
    if (!isFinite(nis) || !isFinite(fc) || nis <= 0 || fc <= 0) return null;
    return parseFloat((nis / fc).toFixed(MANUAL_RATE_DECIMALS));
};

// Builds a human-readable currency label such as "USD ($)".
const buildCurrencyLabel = (code) => {
    if (code === null || code === undefined) return '';
    const name = currencyCodeToName[code];
    if (!name) return String(code);
    const symbol = Constants.ForeignCurrencySymbol[name];
    return symbol ? `${name} (${symbol})` : name;
};
// Utility to generate n number of absolutely distinct colors
const generateDistinctColors = (n, alpha = 0.5) => {
    const colors = [];
    const goldenRatio = 0.618033988749895;  // To generate distinct hues
    let hue = Math.random();  // Start with a random initial hue

    for (let i = 0; i < n; i++) {
        hue += goldenRatio;  // Spread hues using golden ratio for maximum distinctness
        hue %= 1;  // Keep hue within [0, 1] range
        const saturation = 50 + Math.random() * 50;  // Saturation between 50% and 100%
        const lightness = 40 + Math.random() * 30;  // Lightness between 40% and 70%

        // Add opacity to the color by switching to hsla
        colors.push(`hsla(${hue * 360}, ${saturation}%, ${lightness}%, ${alpha})`);
    }

    return colors;
};

// Usage example:
const numberOfColors = 50;
const matchColors = generateDistinctColors(numberOfColors);

const getBackgroundColor = (color, mode) =>
    mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);






const StyledDataGrid = styled(DataGrid)(({ theme }) => {
    // Generate styles for matched rows as an object
    const matchedRowStyles = matchColors.reduce((styles, color, index) => {
        styles[`& .MuiDataGrid-row.super-app-theme--matched-${index}`] = {
            backgroundColor: color,
            '&:hover': {
                backgroundColor: color,

            },
        };
        return styles;
    }, {});

    return {
        '& *': {
            boxSizing: 'border-box !important',
        },
        // Include the matched row styles
        ...matchedRowStyles,
        '& .super-app-theme--UnMatched': {
            backgroundColor: getBackgroundColor(
                theme.palette.info.main,
                theme.palette.mode
            ),
            '&:hover': {
                backgroundColor: getBackgroundColor(
                    theme.palette.info.main,
                    theme.palette.mode
                ),
            },
        },
        '& .super-app-theme--Matched': {
            backgroundColor: getBackgroundColor(
                theme.palette.success.main,
                theme.palette.mode
            ),
            '&:hover': {
                backgroundColor: getBackgroundColor(
                    theme.palette.success.main,
                    theme.palette.mode
                ),
            },
        },
        // Style for main matched rows (Level 0)
        '& .super-app-theme--MainRow': {
            backgroundColor: theme.palette.background.paper,
            '&:hover': {
                backgroundColor: getBackgroundColor(
                    theme.palette.action.hover,
                    theme.palette.mode
                ),
            },
        },
        // Style for header rows (Level 1)
        '& .super-app-theme--Header': {
            backgroundColor: theme.palette.grey[200],
            fontWeight: 'bold',
            '&:hover': {
                backgroundColor: getBackgroundColor(
                    theme.palette.grey[300],
                    theme.palette.mode
                ),
            },
        },
        // Style for transaction sub-rows (Level 2)
        '& .super-app-theme--SubRow': {
            backgroundColor: theme.palette.grey[50],
            '&:hover': {
                backgroundColor: getBackgroundColor(
                    theme.palette.action.hover,
                    theme.palette.mode
                ),
            },
        },
        '& .MuiDataGrid-scrollbar.MuiDataGrid-scrollbar--horizontal': {
            display: 'block !important',
        },
        '& .MuiDataGrid-columnHeaders': {
            // opacity: 0.7,
            backgroundColor: '#BFC8FF',
        },
        '& .MuiDataGrid-columnHeader': {
            backgroundColor: '#BFC8FF',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            color: '#304FFF',
            textAlign: 'center',
            fontFamily: 'Montserrat',
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: 'normal',
        },
        '& .MuiDataGrid-cell': {
            borderTop: '1px solid rgba(191, 191, 193, 0.56)',
            backgroundColor: 'rgba(234, 237, 255, 0.32)',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
        },
        '& .MuiDataGrid-row:hover': {
            backgroundColor: 'rgba(191, 200, 255, 0.3)',
        },
        '& .MuiDataGrid-cell:focus': {
            outline: 'none',
        },
        '& .MuiDataGrid-cell': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: "center"
        },
    };
});

/** Separates the sections of the header bar. */
const HeaderDivider = () => (
    <Divider
        orientation="vertical"
        flexItem
        sx={{ my: 0.25, borderColor: 'var(--bank-border, #e4e7f2)' }}
    />
);

const formatMonthYearDate = dateString => {
    // Parse YYYY-MM-DD as date-only to avoid timezone shifting (e.g. 2026-01-10 showing as 12/2025)
    if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}/.test(dateString)) {
        const [y, m] = dateString.split('T')[0].split('-');
        return `${m}/${y}`;
    }
    const date = new Date(dateString);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${month}/${year}`;
};

// Utility function to convert DD-MM-YYYY to YYYY-MM-DD
const parseCustomDate = (dateStr) => {
    if (!dateStr) return null;
    if (dateStr instanceof Date) return dateStr.toISOString().split('T')[0];
    const str = String(dateStr);
    if (/^\d{4}-\d{2}-\d{2}/.test(str)) return str.split('T')[0];
    const sep = str.includes('/') ? '/' : '-';
    const [day, month, year] = str.split(sep);
    return `${year}-${month}-${day}`;
};

// Normalize reporting month to UTC day 10 (same as Document.jsx) to avoid timezone shifts when sending
const setReportingMonthToDay10 = (date) => {
    if (!date) return date;
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(date)) {
        const [y, m] = date.split('T')[0].split('-').map(Number);
        return new Date(Date.UTC(y, m - 1, 10));
    }
    const d = date instanceof Date ? date : new Date(date);
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), 10));
};

const reportingMonthToISOString = (date) => {
    const d = setReportingMonthToDay10(date);
    return d ? d.toISOString() : null;
};

const formatReportingMonthDateOnly = (date) => {
    const d = setReportingMonthToDay10(date);
    if (!d) return '';
    return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
};






function CardMatching() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const direction = i18n.dir();
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    const [client, setClient] = useState(null);
    const { settings: caseSystemSettings } = useCaseSystemAccountSettings(client?.caseId, token);
    const [type, setType] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const location = useLocation();
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('language') || 'he');
    const [loading, setLoading] = useState(false);
    const [bottomDockBarLoading, setBottomDockBarLoading] = useState(false);
    const [creditMatchedRows, setCreditMatchedRows] = useState([]);
    const [debitMatchedRows, setDebitMatchedRows] = useState([]);
    const [accountCardOptions, setAccountCardOptions] = useState([]);
    const { goBack } = useContext(NavHistoryContext);
    const [isDateRange, setIsDateRange] = useState(false); // New state variable
    const { setMenuProps } = useHamburgerMenu();
    const [creditRows, setCreditRows] = useState([]);
    const [displayedRows, setDisplayedRows] = useState([]);
    const [debitRows, setDebitRows] = useState([]);
    const [isClientDataFetched, setIsClientDataFetched] = useState(false);
    const [shouldMatch, setShouldMatch] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: 'cardId', direction: 'descending', type: 'number' });
    const [focused, setFocused] = useState(false);
    const customScrollbarRef = useRef();
    const tableContainerRef = useRef();
    const [calculatedWidth, setCalculatedWidth] = useState('70%');
    const [cardIdOption, setCardIdOption] = useState(-1);
    const [openRemoveMatchDialog, setOpenRemoveMatchDialog] = useState(false);
    const [selectedMatch, setSelectedMatch] = useState(null);
    const apiRef = useGridApiRef();
    const debitApiRef = useGridApiRef();

    // Keyboard-driven matching state: which panel the keyboard controls, the
    // focused row per panel, and the Shift range-selection anchor per panel.
    const [activePanel, setActivePanel] = useState('debit');
    const [focusedDebitId, setFocusedDebitId] = useState(null);
    const [focusedCreditId, setFocusedCreditId] = useState(null);
    const [debitAnchorId, setDebitAnchorId] = useState(null);
    const [creditAnchorId, setCreditAnchorId] = useState(null);
    const [shortcutsOpen, setShortcutsOpen] = useState(false);
    const [sortedTransactions, setSortedTransactions] = useState([]);
    const [newCardId, setNewCardId] = useState(null);
    const [creditDebitSearchTerm, setCreditDebitSearchTerm] = useState('');
    const [addAccountCardType, setAddAccountCardType] = useState('main');
    const [isEditAccountCard, setIsEditAccountCard] = useState(false);
    const [newAccountCard, setNewAccountCard] = useState({ accountCodeName: '', accountCodeId: "" });
    //account cards
    const [accountCardsData, setAccountCardsData] = useState([]);
    const [startDate, setStartDate] = useState(() => {
        const stored = localStorage.getItem("StartDate");
        const date = stored ? new Date(stored) : null;
        const currentYear = new Date().getFullYear();
        return date && !isNaN(date.getTime()) ? date : new Date(Date.UTC(currentYear, 0, 1));
    });

    const [endDate, setEndDate] = useState(() => {
        const stored = localStorage.getItem("EndDate");
        const date = stored ? new Date(stored) : null;
        const currentYear = new Date().getFullYear();
        return date && !isNaN(date.getTime()) ? date : new Date(Date.UTC(currentYear, 11, 31, 23, 59, 59));
    });



    const [isMatchDate, setIsMatchDate] = useState(() => {
        const stored = localStorage.getItem('CardMatchingIsMatchDate');
        if (stored !== null) return stored === 'true';
        // Legacy: was incorrectly stored under IsRange
        return localStorage.getItem('IsRange') === 'true';
    });
    const isMatchDateRef = useRef(isMatchDate);
    useEffect(() => {
        isMatchDateRef.current = isMatchDate;
    }, [isMatchDate]);


    const [saleEquipment, setSaleEquipment] = useState(false);
    const [dateForAsset, setDateForAsset] = useState(new Date().toISOString());
    const [clickedAsset, setClickedAsset] = useState(null);

    const [showAssetFoundDialog, setShowAssetFoundDialog] = useState(false);
    const [foundAsset, setFoundAsset] = useState(null);
    const fetchEnumsNoParams = async () => {
        await fetchEnums(user, token, client);
    }
    const isPurchaseOfEquipment = (item) => {


        if (!item) return false; // If the item is not found, allow processing
        const sortCode = sortCodeIdOptions.find((option) => option.sortCodeId === item.sortCodeId);
        if (!sortCode) return false; // If the sort code is not found, allow processing



        return Boolean(Constants.depreciationAssetSortCodeType[sortCode.sortCodeVatType]);
    };



    const isDepreciationDocument = (editedItem, sortCodeId) => {



        const item = editedItem;
        const itemId = editedItem.id;
        if (!item) return false; // If the item is not found, allow processing
        setItemForAssets(item);
        setDateForAsset(item.documentDate);

        const sortCode = sortCodeIdOptionsForEditModals.find((option) => option.sortCodeId === sortCodeId);
        if (!sortCode) return false; // If the sort code is not found, allow processing

        const isItemUsedInAssets = assets.some(
            (asset) => asset.expenseId === itemId || asset.journalEntryId === itemId
        );

        const name = sortCode.sortCodeName?.trim().replace(/\s+/g, ' ') || "";
        const saleEquipmentRegex = /(מכירה|מכירת).*ציוד|ציוד.*(מכירה|מכירת)/;
        if (sortCode.sortCodeId === caseSystemSettings.fixedAssetSaleSortCode || saleEquipmentRegex.test(name)) {

            setSaleEquipment(true);
            return true;
        }


        setSaleEquipment(false);
        return Boolean(Constants.depreciationAssetSortCodeType[sortCode.sortCodeVatType]);
    };


    const [showChooseAsset, setShowChooseAsset] = useState(false);
    const [itemToAddToAsset, setItemToAddToAsset] = useState('');
    const [itemForAssets, setItemForAssets] = useState({});

    const handleAssetClicked = (asset, item) => {
        setItemToAddToAsset(item.id);
        setItemForAssets(item)
        setClickedAsset(asset);
        setShowChooseAsset(true);
    }



    const handleAssetClose = () => {
        setShowChooseAsset(false);
        setClickedAsset(null);
    }




    const [fetchType, setFetchType] = useState('NotMatched');

    const handleFetchTypeChange = async (event, newAlignment) => {

        // Prevent deselecting both options
        if (newAlignment !== null) {
            // Mark as view switching to prevent conflicts
            isViewSwitching.current = true;
            isManualFetch.current = true;
            
            // Reset ALL row states before fetching new data to prevent mixing
            setCreditRows([]);
            setDebitRows([]);
            setCreditMatchedRows([]);
            setDebitMatchedRows([]);
            setMatchData([]);
            setSelectedDebitRows([]);
            setSelectedCreditRows([]);
            setMatchedPairs([]);
            setShowingMatches(false);
            setExpandedMatchedRows({});
            setExpandedCreditRows({});
            setSortModel([]);
            
            // Set fetch type after clearing state
            setFetchType(newAlignment);
            
            // Force immediate data fetch with cleared state and correct fetchType
            setTimeout(() => {
                isViewSwitching.current = false;
                const matchDateMode = (newAlignment === 'Matched' || newAlignment === 'AllMatched')
                    ? isMatchDateRef.current
                    : undefined;
                FetchData(startDate, endDate, newAlignment, matchDateMode);
            }, 100); // Small delay to ensure state is cleared
        }


    };
    // Add a ref to track if we're manually fetching data
    const isManualFetch = useRef(false);
    const isViewSwitching = useRef(false);
    
    useEffect(() => {
        if (fetchType && !isManualFetch.current && !isViewSwitching.current) {
            FetchData();
        }
        // Reset the flag after the effect runs
        isManualFetch.current = false;
    }, [fetchType]);
    const existingTheme = useTheme();
    useEffect(() => {
        const currentLanguage = localStorage.getItem('language') || 'he';
        setSelectedLanguage(currentLanguage);
    }, [i18n.language]);




    const [oldSelectedAccountCardItem, setOldSelectedAccountCardItem] = useState({
        cardId: "",
        caseId: "",
        accountCaseId: "",
        name: "",
        palCode: '',
        client: null
    });

    const fileInputRef1 = useRef(null); // Reference to the first hidden file input


    const handleCustomScroll = (e) => {
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollLeft = e.target.scrollLeft;
        }
    };


    const [denseTableHeader, setDenseTableHeader] = useState([t("BankNumber"), t("BankName"), t("BankBranch"), t("BankAccount"), t("AccountCardNumber")]);
    const [denseTableRows, setDenseTableRows] = useState([]);
    const [tBanksData, setTBanksData] = useState([]);

    const [processedCardsData, setProcessedCardsData] = useState([]);
    const [selectedFormattedAccountCard, setSelectedFormattedAccountCard] = useState(null);

    const [mainCard, setMainCard] = useState('');
    const [cardForNewBank, setCardForNewBank] = useState('');
    const [selectedCardId, setSelectedCardId] = useState('');
    // null = shekel (default behaviour). When a foreign-currency code is selected we filter the
    // transactions to that currency, match on the *Fc columns and use the foreign-currency amount.
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [availableCurrencies, setAvailableCurrencies] = useState([]);
    const [selectedTBankIndex, setSelectedTBankIndex] = useState(-1); //used for dense table
    const [selectedTBank, setSelectedTBank] = useState('');
    // Inside your component's render/return method:
    const [openImportDialog, setOpenImportDialog] = useState(false);

    const [matchData, setMatchData] = useState([]);
    const [sortModel, setSortModel] = useState([]);
    const [addBankTransactionDialog, setAddBankTransactionDialog] = useState(false);
    const [newBankEditableItem, setNewBankEditableItem] = useState({
        caseId: '',
        accountCodeId: '',
        accountCodeName: '',
        description: '',
        reference: '',
        amount: '',
        documentDate: ''
    });

    const changeNewBankTransaction = (field, value) => {
        setNewBankEditableItem(prevState => ({
            ...prevState,
            [field]: value
        }));

    };

    const formattedAccountCardOptions = accountCardOptions.map((option) => ({
        value: option.cardId,
        label: option.value1 === 'AddItem'
            ? option.name
            : option.accountCaseId
                ? `${option.cardId} - ${option.name} - ${option?.accountCaseId || ''}`
                : `${option.cardId} - ${option.name}`,
        name: option.name,
        accountCaseId: option.accountCaseId || '',
        cardId: option.cardId,
        value1: option.value1,
        palCode: option.palCode,
        isEditable: option.isEditable
    }));

    useEffect(() => {
        if (accountCardOptions && accountCardOptions.length > 0) {
            const maxCardId = Math.max(...accountCardOptions.slice(1).map(option => parseInt(option.cardId, 10)));
            setCardIdOption(maxCardId + 1);
        }
    }, [accountCardOptions]);

    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);

    const handleAddBankTransaction = async () => {
        try {
            const updatedBankItem = {
                ...newBankEditableItem,
                caseId: client.caseId,
                accountCodeId: mainCard.cardId,
                accountCodeName: mainCard.name,
            };



            const response = await ExternalTransactionsService.CreateTransaction(updatedBankItem, token);

            if (response.ok) {

                setNewBankEditableItem({
                    caseId: '',
                    accountCodeId: '',
                    accountCodeName: '',
                    description: '',
                    reference: '',
                    amount: '',
                    documentDate: ''
                });
                handleCloseBankAddTransactionDialog();
                await FetchData();
            } else {
                const errorMessage = await response.text();

                if (errorMessage === "A transaction with the same reference already exists.") {
                    toast.error(t('TransactionWithSameReferenceExists'));
                }
                toast.error(t('TransactionWithSameReferenceExists'));
            }
        } catch (error) {

            toast.error(t('FailedToCreateBankCommand'));
        }
    };




    const handleOpenBankAddTransactionDialog = () => {
        if (!selectedTBank) {
            toast.info(t('YouNeedToSelectABankFirst'));
            return;
        }
        setAddBankTransactionDialog(true);
    };

    const handleCloseBankAddTransactionDialog = () => {
        setAddBankTransactionDialog(false);
        setNewBankEditableItem({
            caseId: '',
            accountCodeId: '',
            accountCodeName: '',
            description: '',
            reference: '',
            amount: '',
            documentDate: ''
        });
    };

    const handleOpenImportDialog = () => {
        if (!selectedTBank) {
            toast.info(t('YouNeedToSelectABankFirst'));
            return;
        }



        // Search for a matching bank entry in tBanks
        const bankEntry = tBanksData.find(bank => bank.cardId?.toString() === mainCard.cardId?.toString());


        // If a matching bank entry is found and it has a corresponding URL
        if (bankEntry && Constants.BankUrls[parseInt(bankEntry.bankCode)]) {
            // Open the bank's URL in a new tab
            window.open(Constants.BankUrls[parseInt(bankEntry.bankCode)], '_blank');
        }

        // Open the dialog
        setOpenImportDialog(true);
    };

    const handleCloseImportDialog = () => {
        setOpenImportDialog(false);
    };

    const [externalTransactions, setExternalTransactions] = useState([]);
    const handleImport = async (file, useXtramTemplate = false, useIsracardTemplate = false) => {

        setLoading(true)
        // selectedTBank is the selected bank
        const bankType = useIsracardTemplate
            ? Constants.BankTypes[102]
            : useXtramTemplate
            ? Constants.BankTypes[100]
            : Constants.BankTypes[parseInt(selectedTBank.bankCode)];
        const accountCard = accountCardsData.find(card => card.cardId === selectedCardId);


        try {
            // Call the service method to import transactions
            const response = await ExternalTransactionsService.ImportExternalTransactions(
                client.caseId,
                selectedCardId,
                accountCard.name,
                bankType,
                file,
                token
            );

            if (response.ok) {
                toast.success(t("BankDataImportSuccessful"));
                await FetchData();
            }
            else {
                toast.error(t("BankDataImportFailed"));

            }

        } catch (error) {
            toast.error(t("BankDataImportFailed"));

            console.error('Error importing file:', error);
        }
        setLoading(false)

    };

    //for opening create bank modal
    const [createBankModal, setCreateBankModal] = useState(false);
    const bankOptions = Object.keys(Constants.BankNames).map(key => ({
        value: key,
        label: `${Constants.BankNames[key]} - ${key}` // Format: BankName - BankNumber
    }));

    const [selectedBankForCreate, setSelectedBankForCreate] = useState(null);
    const [bankBranch, setBankBranch] = useState('');
    const [bankAccountNumber, setBankAccountNumber] = useState('');
    const [selectedDebitRows, setSelectedDebitRows] = useState([]);
    const [selectedMatchedRows, setSelectedMatchedRows] = useState([]);
    const [selectedCreditRows, setSelectedCreditRows] = useState([]);
    const [expandedInternalRows, setExpandedInternalRows] = useState({});
    const [expandedCreditRows, setExpandedCreditRows] = useState({});
    const [rowViewMode, setRowViewMode] = useState(
        () => localStorage.getItem('CardMatchingRowViewMode') || ROW_VIEW_MODES.FULL
    );
    const isSummaryView = rowViewMode === ROW_VIEW_MODES.SUMMARY;
    const handleRowViewModeChange = (event, newValue) => {
        if (newValue === null) return;
        localStorage.setItem('CardMatchingRowViewMode', newValue);
        setRowViewMode(newValue);
        setSelectedDebitRows([]);
        setSelectedCreditRows([]);
        setExpandedInternalRows({});
        setExpandedCreditRows({});
    };
    const summarizeRows = (rows) =>
        isSummaryView ? collapseCardMatchingRows(rows, beautifyNumber) : rows;
    const [debitSum, setDebitSum] = useState(0);
    const [creditSum, setCreditSum] = useState(0);
    // One search box over both matched lists.
    const [matchedSearch, setMatchedSearch] = useState('');
    const [matchedCreditFilterItems, setMatchedCreditFilterItems] = useState([]);
    const [matchedDebitFilterItems, setMatchedDebitFilterItems] = useState([]);
    // Many-card open-items report: which cards to cover, and whether its one fetch is still out.
    const [unmatchedCardsModalOpen, setUnmatchedCardsModalOpen] = useState(false);
    const [unmatchedCardsBusy, setUnmatchedCardsBusy] = useState(false);
    // Parallel shekel sums (debitSum/creditSum hold the FC amount when a currency is active).
    const [debitShekelSum, setDebitShekelSum] = useState(0);
    const [creditShekelSum, setCreditShekelSum] = useState(0);
    const [createJournalEntries, setCreateJournalEntries] = useState(false);
    const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
    const [usePerRowReportingMonth, setUsePerRowReportingMonth] = useState(false);


    // Matching
    const [matchedPairs, setMatchedPairs] = useState([]);
    const [matchCounter, setMatchCounter] = useState(0);
    const [formValues, setFormValues] = useState({
        confirmationNumber: '',
        accountCaseId: '',
        reference: '',
        description: '',
        documentDate: '',
        reportingMonthDate: setReportingMonthToDay10(new Date()),
        registrationMonthDate: setReportingMonthToDay10(new Date()),
        amount: '',
        foreignCurrencyAmount: '',
        vat: '',
        sortCodeId: '3',
        creditAccount: '',
        debitAccount: '',
        sortCode: '3',
        accountCard: ''
    });


    const handleInputChange = (event) => {
        const { name, value } = event.target;

        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const handleSelectChange = (field, newValue) => {
        if (newValue && (field === 'creditAccount' || field === 'debitAccount' || field === 'accountCard')) {
            if (newValue?.value1 === 'AddItem') {
                handleNoOptionCreditDebitClick('', field);
                return;
            }

            if (newValue?.cardId) {
                setFormValues((prev) => ({
                    ...prev,
                    [field]: newValue.cardId,
                }));
            } else {
                setFormValues((prev) => ({
                    ...prev,
                    [field]: newValue,
                }));
            }
            return;
        }
        if (field === 'sortCodeId') {

            if (!newValue || !sortCodeIdOptions.some((option) => option.value === newValue)) {
                // Set default values for the empty state

                setFormValues((prev) => ({
                    ...prev,
                    vat: 100, // Default VAT
                    [field]: '',
                }));
                return; // Exit early since there's no valid sortCodeId
            }

            const name = sortCodeIdOptions.find(
                (option) => option.value === newValue
            )?.label || ''

            // Extract the name without the parentheses
            const nameWithoutParentheses = name.replace(/\s*\(.*?\)\s*/, '').trim();

            // Check for a number within parentheses
            const match = name.match(/\((\d+)%?/);
            let customVat = match ? parseInt(match[1], 10) : null;


            const sortCode = sortCodeIdOptions.filter(sc => sc.value === newValue)[0];

            // Determine the VAT based on the name without parentheses
            const newVat = sortCode?.vat ?? 100;
            setFormValues((prev) => ({
                ...prev,
                vat: newVat,
                [field]: newValue,
            }));
            return;
        }

        const normalizedValue = (field === 'reportingMonthDate' || field === 'registrationMonthDate')
            ? setReportingMonthToDay10(newValue)
            : newValue;

        setFormValues((prev) => ({
            ...prev,
            [field]: normalizedValue,
        }));
    };

    // const creditAccountOptions = [
    //     { label: 'Credit Account 1', value: 1 },
    //     { label: 'Credit Account 2', value: 2 },
    //     // more options
    // ];

    // const debitAccountOptions = [
    //     { label: 'Debit Account 1', value: 1 },
    //     { label: 'Debit Account 2', value: 2 },
    //     // more options
    // ];

    const sortCodeOptions = [
        { label: 'Sort Code 1', value: 1 },
        { label: 'Sort Code 2', value: 2 },
        // more options
    ];

    const CustomPalCode = (props) => {
        return (
            <components.Option {...props}>
                <div style={{ textAlign: 'center', width: '100%' }}>{props.label}</div>
            </components.Option>
        );
    };

    // Edit Modal Vars
    const [editedItem, setEditedItem] = useState({});
    const [editedPopupItem, setEditedPopupItem] = useState(true);
    const [fade, setFade] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(-1);
    const [transactions, setTransactions] = useState(null);
    const [dataForPdf, setDataForPdf] = useState(null);
    const [sortedDataForPdf, setSortedDataForPdf] = useState(null);
    const [transactionDetailsDictionary, setTransactionDetailsDictionary] = useState({});
    const [itemToDelete, setItemToDelete] = useState({});
    const [editedJournalItem, setEditedJournalItem] = useState(true);
    const [paymentModal, setPaymentModal] = useState(false);
    const [paymentAcceptanceSpecificType, setPaymentAcceptanceSpecificType] = useState('');
    const [paymentAcceptanceSpecificId, setPaymentAcceptanceSpecificId] = useState(-1);
    const [showType, setShowType] = useState({ type: 'all', index: -1 });





    const [openInvoiceCreatorModal, setOpenInvoiceCreatorModal] = useState(false);
    const [addEditableItem, setAddEditableItem] = useState({
        checks: [],
        creditCards: [],
        cash: [],
        bankTransactions: [],
        offsets: [],
        date: new Date()
    });
    const [responseData, setResponseData] = useState({});
    const [accountCardEditDownloadOptions, setAccountCardEditDownloadOptions] = useState([]);
    const [originalAccountCardId, setOriginalAccountCardId] = useState('');
    const [editedAddAccountCard, setEditedAddAccountCard] = useState(false);
    const [isRange, setIsRange] = useState(() => localStorage.getItem('IsRange') === 'true');
    const [isClosedReportingMonth, setIsClosedReportingMonth] = useState(false);
    const [editModalsAccountCardOptions, setEditModalsAccountCardOptions] = useState([]);

    const [sortCodeIdOptions, setSortCodeIdOptions] = useState([]);
    const [sortCodeIdOptionsForEditModals, setSortCodeIdOptionsForEditModals] = useState([]);

    const [statusCheck, setStatusCheck] = useState(false);
    const [creditAccountOptions, setCreditAccountOptions] = useState([]);
    const [debitAccountOptions, setDebitAccountOptions] = useState([]);
    const [originalAccountOptions, setOriginalDebitAccountOptions] = useState([]);
    const [editingRow, setEditingRow] = useState(null);
    const [palCodeName, setPalCodeName] = useState(null);
    const [accountCardName, setAccountCardName] = useState(null);
    const [accountCardId, setAccountCardId] = useState(null);
    const [finalBalance, setFinalBalance] = useState('');
    const [isMonthly, setIsMonthly] = useState(false);
    const [firstRowDetails, setFirstRowDetails] = useState(null);
    const [palCodeDetails, setPalCodeDetails] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [deleteDialog, setDeleteDialog] = useState(false);

    const [formattedPalCodeOptions, setFormattedPalCodeOptions] = useState([]);
    const [journalEntriesList, setJournalEntriesList] = useState([]);
    const [isJournalEntriesListOpen, setIsJournalEntriesListOpen] = useState(false);
    const [expandedMatchedRows, setExpandedMatchedRows] = useState({});
    const [showingMatches, setShowingMatches] = useState(false);


    // Handle expand/collapse
    const handleMatchedExpandClick = (id) => {
        setExpandedMatchedRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const CustomInput1 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="document-custom-input1" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const handleAccountEdit = (option) => {
        setShowAccountCardInputsEdit(true);
        setAccountCodeName(option.name);
        setAccountCodeId(option.cardId);
        setCompanyId(option.caseId);
        const account = accountCardOptions.find(account => account.cardId === option.cardId);
        setPalCode(account ? account.palCode : '');
        setOldSelectedAccountCardItem({
            cardId: option.cardId,
            caseId: option.caseId,
            accountCaseId: option.accountCaseId,
            name: option.name,
            palCode: '',
            client: null

        })
        setAddNewAccountCardDocument(true);
    };

    const CustomInput2 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="edit-custom-input" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const handleCancel = () => {
        setEditingRow(null);
        setEditedItem({});
        setEditedAddAccountCard(false);
    };
    const [itemIdToDelete, setItemIdToDelete] = useState('');
    const [itemTypeToDelete, setItemTypeToDelete] = useState('');

    const handleEditDeleteClick = (itemId) => {
        // setItemTypeToDelete(editedItem.docType);

        setEditedPopupItem(false);
        setEditedItem({});
        setPaymentModal(false);
        setAddEditableItem({
            checks: [],
            creditCards: [],
            cash: [],
            bankTransactions: [],
            offsets: [],
            date: new Date()
        });
        handleDeleteClick();
    };
    const handleDeleteClick = () => {
        setIsModalVisible(true);
    };

    const handleDoneClick = async (itemId, type) => {

        setLoading(true);
        try {
            const response = await ClientDocumentCountService.removeDocumentByTypeAndId(client.caseId, client.accountantId, type, itemId, token);
            if (response.ok) {
                // await fetchDocumentsNotification(client, token);
                toast.success(t('DocumentProcessed'), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            // toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };

    const handleNotDoneClick = async (itemId, type) => {


        setLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentByTypeAndId(client.caseId, client.accountantId, type, itemId, token)
            if (response.ok) {
                // await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            // toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };

    const handleUpdate = async (itemId) => {
        setLoading(true);
        let finalResponse = null;
        setEditedPopupItem(false);
        const documentUrl = editedItem.documentUrl;
        try {
            editedItem.accountCaseId = client.accountCaseId;
            delete editedItem.documentUrl; // Ensure the document URL is not part of the update if present


            if (editedItem.docType === 'Incomes') {
                finalResponse = await DocumentService.UpdateDocument("Incomes", token, editedItem);
            }
            if (editedItem.docType === 'Expenses') {
                // If the income update fails, attempt the expense update
                finalResponse = await DocumentService.UpdateDocument("Expenses", token, editedItem);
            }
            if (editedItem.docType === 'JournalEntries') {
                finalResponse = await DocumentService.UpdateDocument("JournalEntries", token, editedItem);
            }


            if (finalResponse && finalResponse.ok) {
                // Reassign documentUrl back to editedItem after successful update
                editedItem.documentUrl = documentUrl;

                if (editedItem.status === 'done') {

                    await handleDoneClick(editedItem.id, editedItem.docType);
                    // handleSortChange('id', 'newest', 'descending');
                } else if (editedItem.status === 'notDone') {
                    await handleNotDoneClick(editedItem.id, editedItem.docType);
                }

                if (editedAddAccountCard) {
                    await handleAccountCardSave(editedItem.accountCodeId, editedItem.accountCodeName, editedItem.accountCaseId);
                    await fetchEnums(user, token, client);
                }

                setWholeDataTransactions((prevData) => {
                    const newData = { ...prevData };

                    // Check if editedItem.id exists in the previous data
                    if (newData[editedItem.id]) {
                        // Delete the existing entry
                        delete newData[editedItem.id];
                    }

                    // Return the updated object without the removed entry
                    return newData;
                });

                toast.success(t("documentUpdateSuccess"));
            } else {
                // Reassign documentUrl back to editedItem even on error to maintain state
                editedItem.documentUrl = documentUrl;

                const errorText = await finalResponse.text();
                toast.error(t("documentUpdateError") + ": " + errorText);
            }
        } catch (error) {
            // This block catches unexpected errors such as network issues, not HTTP errors which are handled above
            console.error("Unexpected error occurred: ", error);
            toast.error(t("documentUpdateError"));
            // Reassign documentUrl back to editedItem on catch error to maintain state
            editedItem.documentUrl = documentUrl;
        }
        setEditedItem({});
        setEditingRow(null);
        setEditedAddAccountCard(false);

        await fetchEnums(user, token, client);
        await FetchData();
        setLoading(false); // Always stop loading at the end of the operation
    };

    const handleEditAddAccountChange = (selectedOption, field) => {

        if (field === 'AccountCodeId') {
            type === 'Incomes' ? setEditedItem({ ...editedItem, accountCodeId: selectedOption, debitAccount: selectedOption }) : setEditedItem({ ...editedItem, accountCodeId: selectedOption, creditAccount: selectedOption });
        }
        else if (field === 'AccountCodeName') {
            setEditedItem({ ...editedItem, accountCodeName: selectedOption })
        }
        else {
            setEditedItem({ ...editedItem, accountCaseId: selectedOption })

        }
    };

    const handleCloseEditAddNewAccountCardDocument = () => {
        setEditedItem({ ...editedItem, accountCodeName: '', accountCodeId: '' })
        setEditedAddAccountCard(false);
    };

    const handleRadioChange = async (e, options = {}) => {
        if (e.target.value?.toString() === 'done' && !options?.validationAlreadyDone) {

            const isValid = await validateDocumentBeforeProcessing(editedItem, t, client, options?.forceProcess === true);
            if (!isValid) return;
        }

        if (e.target.value?.toString() === 'done') {
            setStatusCheck(true);
        }
        else if (e.target.value?.toString() === 'notDone') {
            setStatusCheck(false);
        }

        setEditedItem({ ...editedItem, status: e.target.value });
    };

    const handleRadioPAChange = async (e) => {
        if (e.target.value?.toString() === 'done') {
            const isValid = await validatePaymentAcceptanceItems(addEditableItem, t, client);
            if (!isValid) return;

            setStatusCheck(true);
        }
        else if (e.target.value?.toString() === 'notDone') {
            setStatusCheck(false);
        }
        setAddEditableItem({ ...addEditableItem, ["status"]: e.target.value });
    };

    const handleAccountCardSave = async (AccountCodeId, AccountCodeName, AccountCaseId) => {
        const response2 = await EnumsService.AddAccountCard(client.caseId, AccountCodeId, AccountCodeName, AccountCaseId, token);
        if (!response2.ok) {
            throw new Error(`HTTP error! status: ${response2.status}`);
        }
    };

    const updateAccountFields = (newValue, accountType) => {


        const isIncomesDebit = editedItem.docType === 'Incomes' && accountType === 'debitAccount';
        const isExpensesCredit = editedItem.docType === 'Expenses' && accountType === 'creditAccount';

        const updatedFields = {
            accountCodeId: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.cardId : '') : '',
            accountCodeName: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.name : '') : '',
            accountCaseId: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.accountCaseId : '') : '',
        };

        // Update the edited item with the new fields
        setEditedItem((prev) => ({
            ...prev,
            [accountType]: newValue ? newValue.cardId : '',
            ...(isIncomesDebit || isExpensesCredit ? updatedFields : {}),
        }));
    };

    // const getVatBySortCode = (value) => {
    //     if (!value || !sortCodeIdOptions.some((option) => option.sortCodeId === value)) {
    //         return;
    //     }
    //     let newVat = 100;
    //     const name = sortCodeIdOptions.find(
    //         (option) => option.sortCodeId === value
    //     )?.sortCodeName || ''

    //     const nameWithoutParentheses = name.replace(/\s*\(.*?\)\s*/, '').trim();

    //     const match = name.match(/\((\d+)%?/);
    //     let customVat = match ? parseInt(match[1], 10) : null;


    //     const sortCode = sortCodeIdOptions.filter(sc => sc.sortCodeId === updatedValue)[0];

    //     // Determine the VAT based on the name without parentheses
    //     if (Constants.SortCodesWith66Vat.includes(nameWithoutParentheses)) {
    //         newVat = 66;
    //     } else if (Constants.SortCodesWithZeroVat.includes(nameWithoutParentheses) || sortCode?.sortCodeVatType === 0) {
    //         newVat = 0;

    //     } else if (Constants.SortCodesWith16Vat.includes(nameWithoutParentheses)) {
    //         newVat = 16;
    //     } else if (customVat !== null) {
    //         // If a custom VAT was found, use it
    //         newVat = customVat === 66 ? 66 : customVat;
    //     } else {
    //         // Default VAT if no special conditions are met
    //         newVat = 100;
    //     }
    //     return newVat;
    // }



    const handleChange = (field, value) => {

        const updatedValue = value;

        if (field === 'sortCodeId') {


            let depreciation = false;


            if (isDepreciationDocument(editedItem, value)) {
                depreciation = true;
                setItemToAddToAsset(editedItem.id);
                setShowChooseAsset(true);
            }

            if (isPurchaseOfEquipment(editedItem) && !depreciation) {
                if (assets) {
                    const assetFound = assets.find(
                        (asset) => asset.expenseId === editedItem.id || asset.journalEntryId === editedItem.id
                    );
                    if (assetFound) {

                        setFoundAsset(assetFound);
                        setShowAssetFoundDialog(true);
                    }
                }
            }

            if (!value || !sortCodeIdOptions.some((option) => option.value === value)) {
                // Set default values for the empty state
                setEditedItem({
                    ...editedItem,
                    vat: 100, // Default VAT
                    [field]: '',
                });
                return; // Exit early since there's no valid sortCodeId
            }

            const name = sortCodeIdOptions.find(
                (option) => option.value === value
            )?.sortCodeName || ''

            // Extract the name without the parentheses
            const nameWithoutParentheses = name.replace(/\s*\(.*?\)\s*/, '').trim();

            // Check for a number within parentheses
            const match = name.match(/\((\d+)%?/);
            let customVat = match ? parseInt(match[1], 10) : null;


            const sortCode = sortCodeIdOptions.filter(sc => sc.value === updatedValue)[0];

            // Determine the VAT based on the name without parentheses
            const newVat = sortCode?.vat ?? 100;




            const accountCard = accountCardOptions.find(
                (item) => item.cardId === (type === 'Incomes' ? sortCode?.debitAccount : sortCode?.creditAccount)
            );
            setEditedItem({
                ...editedItem,
                vat: newVat,
                [field]: updatedValue,
                // [type === 'Incomes' ? 'debitAccount' : 'creditAccount']:
                //     editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount']
                //         ? (accountCard ? accountCard.cardId : editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount'])
                //         : editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount'],
                accountCodeName: accountCard ? accountCard.name : editedItem.accountCodeName,
                accountCodeId: accountCard ? accountCard.cardId : editedItem.accountCodeId,
                accountCaseId: accountCard ? accountCard.accountCaseId : editedItem.accountCaseId,
            });

        }
        else if (field === 'creditAccount' || field === 'debitAccount') {

            // Use the helper function to update account fields for credit or debit account
            const newValue = accountCardOptions.find(option => option.cardId === updatedValue) || null;
            updateAccountFields(newValue, field);
        }
        else if (field === 'reportingMonthDate' || field === 'registrationMonthDate') {
            if (!updatedValue) return;
            const newDate = new Date(Date.UTC(updatedValue.getFullYear(), updatedValue.getMonth(), 10));
            setEditedItem({
                ...editedItem,
                [field]: newDate,
            });
        }
        else {
            // For fields other than sortCodeId, just update the edited item
            setEditedItem({
                ...editedItem,
                [field]: updatedValue,
            });
        }
    };
    const [journalReportingMonthDate, setJournalReportingMonthDate] = useState(() => setReportingMonthToDay10(new Date()));
    const [journalRegistrationMonthDate, setJournalRegistrationMonthDate] = useState(() => setReportingMonthToDay10(new Date()));

    const setReportingMonthDate = async (selectedDate, field) => {
        if (!selectedDate) {
            return;
        }
        const newDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10));
        const response1 = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);
        if (response1.ok) {
            const isClosedReportingMonth = await response1.json();
            if (isClosedReportingMonth) {
                toast.info(t('MonthReportAlreadyClosedTryAgain'));
                return;
            }
            setEditedItem({ ...editedItem, [field]: newDate });
        }
    };

    const handleVatRadioChange = (e) => {
        setEditedItem({ ...editedItem, ["vat"]: parseFloat(e.target.value) });
    };

    const handleDateChange = (e, field) => {
        setEditedItem({ ...editedItem, [field]: e });
    };

    const getAccountCardName = (accountId) => {
        const accountCard = formattedAccountCardOptions.find(
            (option) => option.cardId === accountId
        );
        return accountCard ? accountCard.name : "--"; // Fallback to 'Unknown Account' if not found
    };
    const getSortCodeName = (sortCodeId) => {
        const sortCode = sortCodeIdOptions.find(option => option.value === sortCodeId);
        return sortCode ? sortCode.label : '--'; // Fallback to 'Unknown Account' if not found
    };
    const handleReopenEdit = async (item, index) => {
        await fetchEnums(user, token, client);
        item.key = item.id;
        handleEdit(item);
    };

    const handleAccountChange = (selectedOption, field) => {
        if (field === 'debitAccount' || field === 'creditAccount') {
            const accountCardEditDownload = accountCardEditDownloadOptions.find(option => option.cardId === selectedOption.value);
            const name = accountCardEditDownload?.name;
            const accountCaseId = accountCardEditDownload?.accountCaseId;
            if (selectedOption.value < 0) {

                setOriginalAccountCardId(editedItem.cardId)
            }
            if (editedItem.docType === 'Incomes') {
                setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: selectedOption.value, debitAccount: selectedOption.value, accountCaseId: accountCaseId })
            }
            else if (editedItem.docType === 'Expenses') {
                setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: selectedOption.value, creditAccount: selectedOption.value, accountCaseId: accountCaseId });
            }
            else if (editedItem.docType === 'JournalEntries') {
                setEditedItem({
                    ...editedItem,
                    [field]: selectedOption.value
                });
            }
        } else if (field === 'accountCodeName') {
            if (selectedOption.value1 === 'AddItem') {
                setEditedAddAccountCard(true);
                setEditedItem({ ...editedItem, accountCodeName: '', accountCodeId: '', accountCaseId: '' })
            }
            else {
                const accountCardEdit = accountCardEditDownloadOptions.find(option =>
                    option.cardId === selectedOption.value
                );
                const name = accountCardEdit?.name;
                const accountCaseId = accountCardEdit?.accountCaseId;
                const cardId = selectedOption.value;
                if (editedItem.docType === 'Incomes') {
                    setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, debitAccount: cardId, accountCaseId: accountCaseId })
                }
                else if (editedItem.docType === 'Expenses') {
                    setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, creditAccount: cardId, accountCaseId: accountCaseId });
                }
                else if (editedItem.docType === 'JournalEntries') {
                    setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, accountCaseId: accountCaseId })
                }
            }
        }
    };


    // Function to load the surrounding items (previous and next)
    const loadSurroundingItems = (rowIndex, type, transactionArray) => {
        return new Promise((resolve, reject) => {
            const updatedDictionary = { ...transactionDetailsDictionary };
            const promises = [];

            // Load the previous transaction if it exists and is not already loaded
            if (rowIndex > 0 && !transactionDetailsDictionary[transactionArray[rowIndex - 1].id]) {
                const previousPromise = DocumentService.GetDocumentById(transactionArray[rowIndex - 1].type, client.caseId, transactionArray[rowIndex - 1].id, token)
                    .then(response => response.ok ? response.json() : null)
                    .then(data => {
                        if (data) {
                            data.docType = transactionArray[rowIndex - 1].type;
                            updatedDictionary[transactionArray[rowIndex - 1].id] = data;
                            setTransactionDetailsDictionary(updatedDictionary);
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching previous transaction:', error);
                        reject(error);
                    });

                promises.push(previousPromise);
            }

            // Load the next transaction if it exists and is not already loaded
            if (rowIndex < transactionArray.length - 1 && !transactionDetailsDictionary[transactionArray[rowIndex + 1].id]) {
                const nextPromise = DocumentService.GetDocumentById(transactionArray[rowIndex + 1].type, client.caseId, transactionArray[rowIndex + 1].id, token)
                    .then(response => response.ok ? response.json() : null)
                    .then(data => {
                        if (data) {
                            data.docType = transactionArray[rowIndex + 1].type;
                            updatedDictionary[transactionArray[rowIndex + 1].id] = data;
                            setTransactionDetailsDictionary(updatedDictionary);
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching next transaction:', error);
                        reject(error);
                    });

                promises.push(nextPromise);
            }

            // Resolve when all promises are complete
            Promise.all(promises).then(() => resolve()).catch(error => reject(error));
        });
    };
    // Which side of the match a freshly created journal entry joins. The card sits on one of the
    // entry's two accounts and that account is the side: an entry crediting the card is a credit
    // row, one debiting it a debit row. Putting the entry on the side opposite to the existing
    // selection instead breaks contra rows, where a negative amount is cancelled by an entry on
    // the same side rather than the other one.
    const journalEntryMatchSide = (entry) => {
        const cardId = String(selectedCardId ?? '');
        if (cardId) {
            if (String(entry?.creditAccount ?? '') === cardId) return 'credit';
            if (String(entry?.debitAccount ?? '') === cardId) return 'debit';
        }
        return selectedDebitRows.length > 0 && selectedCreditRows.length === 0 ? 'credit' : 'debit';
    };

    const handleFinalizeEntries = async () => {
        setLoading(true);
        setIsJournalEntriesListOpen(false);

        try {
            // Prepare the payload for uploading journal entries
            const payload = journalEntriesList.map((entry) => {
                const isEntryFc = entry.foreignCurrencyCode != null;
                const rate = isEntryFc
                    ? (entry.exchangeRate ?? resolveManualRate(entry.amount, entry.foreignCurrencyAmount))
                    : null;
                return {
                    caseId: client.caseId,
                    accountantId: client.accountantId,
                    sortCodeId: entry.sortCodeId,
                    reference: entry.reference,
                    description: entry.description,
                    amount: parseFloat(Math.abs(entry.amount).toFixed(2)),
                    foreignCurrencyCode: entry.foreignCurrencyCode ?? null,
                    // Positive magnitude: the server converts the foreign amount back to shekels,
                    // so a negative value here would produce a negative shekel amount.
                    foreignCurrencyAmount:
                        entry.foreignCurrencyAmount != null && entry.foreignCurrencyAmount !== ''
                            ? parseFloat(Math.abs(Number(entry.foreignCurrencyAmount)).toFixed(2))
                            : null,
                    exchangeRate: rate,
                    exchangeRateType: rate != null ? Constants.ExchangeRateType.Manual : null,
                    documentDate: new Date(entry.documentDate).toISOString(),
                    reportingMonthDate: reportingMonthToISOString(entry.reportingMonthDate),
                    registrationMonthDate: reportingMonthToISOString(entry.registrationMonthDate || entry.reportingMonthDate),
                    creditAccount: entry.creditAccount,
                    debitAccount: entry.debitAccount,
                    vat: returnProperVatBySortId(entry.sortCodeId),
                    IsMadeFromCardMatch: true,
                    addAsProcessed: true,
                    isLocked: true
                };
            });

            // Upload the journal entries
            const response = await DocumentService.UploadDocumentPayloads("JournalEntries", payload, token);

            if (response.ok) {
                const data = await response.json();

                const newJournalEntryIds = data.journalEntryIds; // Extract the new journal entry IDs


                // Determine where to add the new journal entries for matching
                let updatedSelectedDebitRows = [...selectedDebitRows];
                let updatedSelectedCreditRows = [...selectedCreditRows];

                newJournalEntryIds.forEach((id, index) => {
                    if (journalEntryMatchSide(journalEntriesList[index]) === 'credit') {
                        updatedSelectedCreditRows = [...updatedSelectedCreditRows, id];
                    } else {
                        updatedSelectedDebitRows = [...updatedSelectedDebitRows, id];
                    }
                });
                setSelectedDebitRows(updatedSelectedDebitRows);
                setSelectedCreditRows(updatedSelectedCreditRows);

                // Proceed to match the selected transactions with the new journal entries
                // Pass the updated selections to handleMatch
                await handleMatch(updatedSelectedDebitRows, updatedSelectedCreditRows);

                toast.success(t('documentUploadSuccess'));
            } else {
                const errorText = await response.text();
                toast.error(t('documentUploadError', { errorText }));
            }
        } catch (error) {
            console.error('Error uploading documents:', error);
            toast.error(t('documentUploadError', { errorText: 'Error uploading documents' }));
        } finally {
            setLoading(false);
        }
    };



    const getMatchedDisplayedRows = () => {
        const result = [];

        // Determine which column and direction to sort by
        let sortField = null;
        let sortDirection = 'asc'; // Default sort direction

        if (sortModel && sortModel.length > 0) {
            sortField = sortModel[0].field;
            sortDirection = sortModel[0].sort;
        }

        // Fields that are part of the parent rows
        const parentSortFields = ['matchNumber', 'documentDate', 'matchDate'];

        // Is the column being sorted a parent row field?
        const isParentSortField = parentSortFields.includes(sortField);

        // Sort parent rows if the selected column belongs to them
        const sortedMatchData = [...matchData].sort((a, b) => {
            if (isParentSortField && sortField) {
                const valueA = a[sortField];
                const valueB = b[sortField];

                if (valueA === undefined) return 1;
                if (valueB === undefined) return -1;

                if (valueA > valueB) return sortDirection === 'asc' ? 1 : -1;
                if (valueA < valueB) return sortDirection === 'asc' ? -1 : 1;
                return 0;
            } else {
                // Keep the original order if sorting by a sub-row field
                return 0;
            }
        });



        // Process each parent row
        sortedMatchData.forEach((row) => {
            // Add parent row to the result
            result.push({ ...row, level: 0, isSubRow: false });

            // Check if the row is expanded, then process sub-rows
            if (expandedMatchedRows[row.id]) {
                // Handle external transactions (sub-rows)
                if (row.externalTransactions && row.externalTransactions.length > 0) {
                    // Header for external transactions
                    result.push({
                        id: `${row.id}-external-header`,
                        parentId: row.id,
                        isSubRow: true,
                        isHeader: true,
                        level: 1,
                        transactionType: t('BankCommands'),
                    });

                    // Sort sub-rows if the selected column belongs to sub-rows
                    let sortedExternalTransactions = [...row.externalTransactions];
                    if (!isParentSortField && sortField) {
                        sortedExternalTransactions.sort((a, b) => {
                            const valueA = a[sortField];
                            const valueB = b[sortField];

                            if (valueA === undefined) return 1;
                            if (valueB === undefined) return -1;

                            if (valueA > valueB) return sortDirection === 'asc' ? 1 : -1;
                            if (valueA < valueB) return sortDirection === 'asc' ? -1 : 1;
                            return 0;
                        });
                    }

                    // Add sorted external transactions (sub-rows)
                    sortedExternalTransactions.forEach((transaction) => {
                        result.push({
                            ...transaction,
                            id: transaction.id,
                            parentId: row.id,
                            isSubRow: true,
                            isHeader: false,
                            level: 2,
                            transactionType: 'External',
                        });
                    });
                }

                // Handle internal transactions (sub-rows)
                if (row.internalTransactions && row.internalTransactions.length > 0) {
                    // Header for internal transactions
                    result.push({
                        id: `${row.id}-internal-header`,
                        parentId: row.id,
                        isSubRow: true,
                        isHeader: true,
                        level: 1,
                        transactionType: t('BookCommands'),
                    });

                    // Sort sub-rows if needed
                    let sortedInternalTransactions = [...row.internalTransactions];
                    if (!isParentSortField && sortField) {
                        sortedInternalTransactions.sort((a, b) => {
                            const valueA = a[sortField];
                            const valueB = b[sortField];

                            if (valueA === undefined) return 1;
                            if (valueB === undefined) return -1;

                            if (valueA > valueB) return sortDirection === 'asc' ? 1 : -1;
                            if (valueA < valueB) return sortDirection === 'asc' ? -1 : 1;
                            return 0;
                        });
                    }

                    // Add sorted internal transactions (sub-rows)
                    sortedInternalTransactions.forEach((transaction) => {
                        result.push({
                            ...transaction,
                            id: transaction.id,
                            parentId: row.id,
                            isSubRow: true,
                            isHeader: false,
                            level: 2,
                            transactionType: 'Internal',
                        });
                    });
                }
            }
        });

        return result;
    };

    const matchedDisplayedRows = useMemo(() => getMatchedDisplayedRows(), [matchData, expandedMatchedRows, sortModel]);


    const setCurrentItem = async (transaction, rowIndex) => {
        try {

            let type = transaction.type1


            let myItem;

            // Check if transactionDetailsDictionary has the item with the transaction ID
            if (transactionDetailsDictionary[transaction.id]) {
                myItem = transactionDetailsDictionary[transaction.id];
            } else {
                // If not, make an API call to fetch the item
                let response;
                if (transaction.type1 === 'JournalEntry') {
                    response = await DocumentService.GetDocumentById('JournalEntries', client.caseId, transaction.id, token);
                    type = transaction.type1;
                } else {
                    response = await DocumentService.GetDocumentById(type, client.caseId, transaction.id, token);
                }

                if (response.ok) {
                    myItem = await response.json();
                    myItem.docType = type;
                    // Store the fetched item in transactionDetailsDictionary with the transaction ID as key
                    const updatedDictionary = { ...transactionDetailsDictionary };
                    updatedDictionary[transaction.id] = myItem;
                    setTransactionDetailsDictionary(updatedDictionary);
                } else {
                    console.error('Error fetching document details');
                    return; // Exit the function if the API call fails
                }
            }

            // Load the previous and next items asynchronously without await
            loadSurroundingItems(rowIndex, type, filteredAndSortedTransactions);

            if (!type.includes("PaymentAcceptances")) {
                if (transaction.type1 !== 'JournalEntries') {
                    setCurrentIndex(rowIndex);
                    setItemToDelete({ id: transaction.id, type: transaction.docType });
                    setEditedItem({ ...myItem });
                    setEditedPopupItem(true);
                    setEditedJournalItem(false);
                    setPaymentModal(false);
                } else {
                    setCurrentIndex(rowIndex);
                    setItemToDelete({ id: transaction.id, type: transaction.docType });
                    setEditedItem({ ...myItem });
                    setEditedPopupItem(true);
                    setEditedJournalItem(true);
                    setPaymentModal(false);
                }
            } else {
                setCurrentIndex(rowIndex);
                setOpenInvoiceCreatorModal(true);
                setAddEditableItem({ ...myItem });
                setPaymentModal(true);
                setEditedJournalItem(false);
                setEditedPopupItem(false);
            }
        } catch (error) {
            console.error('An error occurred:', error);
        }
    };

    const getItemAtIndex = (transactions, newIndex) => {
        // Convert the object to an array of its values
        const transactionsArray = Object.values(transactions);

        // Check if the index is within the bounds of the array
        if (newIndex >= 0 && newIndex < transactionsArray.length) {
            return transactionsArray[newIndex];
        } else {
            console.error('Index out of bounds');
            return null;
        }
    };

    const filteredAndSortedTransactions = useMemo(() => {
        if (!transactions || transactions.length === 0) {
            return [];
        }

        // Filtering the transactions based on searchQuery
        const filteredData = transactions.filter((transaction) => {
            const query = searchQuery.toLowerCase();
            return (
                transaction?.description?.toLowerCase().includes(query) ||
                transaction?.reference1?.toLowerCase().includes(query) ||
                transaction?.reference2?.toLowerCase().includes(query) ||
                transaction?.debitAccount?.toString().includes(query) ||
                transaction?.creditAccount?.toString().includes(query) ||
                transaction?.balance?.toString().includes(query) ||
                new Date(transaction.documentDate).toLocaleDateString().includes(query) ||
                new Date(transaction.uploadDate).toLocaleDateString().includes(query)
            );
        });

        // Sorting the filtered transactions based on sortConfig
        if (sortConfig.key) {
            filteredData.sort((a, b) => {
                const aValue = a[sortConfig.key] || ""; // Default to empty string if null or undefined
                const bValue = b[sortConfig.key] || ""; // Default to empty string if null or undefined

                if (sortConfig.type === 'number') {
                    return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
                } else if (sortConfig.type === 'date') {
                    return sortConfig.direction === 'ascending'
                        ? new Date(aValue) - new Date(bValue)
                        : new Date(bValue) - new Date(aValue);
                } else { // default to string comparison
                    return sortConfig.direction === 'ascending'
                        ? aValue?.localeCompare(bValue)
                        : bValue?.localeCompare(aValue);
                }
            });
        }
        const updatedDataForPdf = {
            ...dataForPdf,
            transactions: filteredData,
        };
        setSortedDataForPdf(updatedDataForPdf);

        return filteredData;
    }, [sortedTransactions, searchQuery, sortConfig]);

    const handleNext = () => {
        let newIndex = currentIndex;
        if (creditOrDebitEdit === 'credit') {
            while (newIndex < creditRows.length - 1) {
                newIndex += 1;
                const nextItem = creditRows[newIndex];
                const currentItem = creditRows[currentIndex];
                if (nextItem.id !== currentItem.id) {
                    handleEdit(nextItem);
                    break;
                }
            }
        } else {
            while (newIndex < debitRows.length - 1) {
                newIndex += 1;
                const nextItem = debitRows[newIndex];
                const currentItem = debitRows[currentIndex];
                if (nextItem.id !== currentItem.id) {
                    handleEdit(nextItem);
                    break;
                }
            }
        }

    };

    const handlePrevious = () => {
        let newIndex = currentIndex;

        if (creditOrDebitEdit === 'credit') {
            while (newIndex > 0) {
                newIndex -= 1;
                const previousItem = creditRows[newIndex];
                const currentItem = creditRows[currentIndex];

                // Check if the previous item has a different id
                if (previousItem.id !== currentItem.id) {
                    handleEdit(previousItem);
                    break;
                }
            }
        } else {
            while (newIndex > 0) {
                newIndex -= 1;
                const previousItem = debitRows[newIndex];
                const currentItem = debitRows[currentIndex];

                // Check if the previous item has a different id
                if (previousItem.id !== currentItem.id) {
                    handleEdit(previousItem);
                    break;
                }
            }
        }

    };

    const handleInternalExpandClick = (id) => {
        // Closing a group takes its children off the grid, so let go of them together with it.
        if (expandedInternalRows[id]) {
            const hidden = new Set(childIdsOf(creditDisplayedRows, id));
            if (hidden.size > 0) {
                setSelectedCreditRows((prev) => prev.filter((rowId) => !hidden.has(rowId)));
            }
        }
        setExpandedInternalRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    // A summary row stands for several documents; editing opens the first of them.
    const editableRowOf = (row) => (row?._summary ? row._children[0] : row);

    const handleCellDoubleClick = (params) => {
        handleEdit(editableRowOf(params.row));
    };

    const stringFilterOperators = useMemo(() => getGridStringOperatorsWithComparison(t), [t]);
    const numericFilterOperators = useMemo(() => getGridNumericOperatorsWithNotLike(t), [t]);
    const dateFilterOperators = useMemo(() => getGridDateOperatorsWithNotLike(t), [t]);

    const renderSummaryDescription = (expandedRows, onToggle) => (params) => {
        const row = params.row;
        if (row._summary) {
            return (
                <SummaryRowLabel
                    row={row}
                    text={params.value}
                    t={t}
                    expanded={!!expandedRows[row.id]}
                    onToggle={() => onToggle(row.id)}
                />
            );
        }
        if (row._summaryChild) {
            return <SummaryChildLabel text={params.value} />;
        }
        return params.value;
    };

    /**
     * What a matched row carries beyond the entry itself: which match it belongs to, when it was
     * matched and under which sort code — the things an accountant checks before undoing a match.
     */
    const matchedDetailColumns = () => [
        {
            field: 'cardMatchNumber',
            headerName: t('MatchNumber'),
            flex: 0.8,
            minWidth: 80,
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            filterOperators: numericFilterOperators,
            valueFormatter: (params) => {
                const value = params;
                return value === 0 || value === -1 ? '-' : value;
            },
        },
        {
            field: 'matchDate',
            headerName: t('MatchDate'),
            flex: 0.8,
            minWidth: 90,
            headerAlign: 'center',
            align: 'center',
            type: 'string',
            filterOperators: stringFilterOperators,
        },
        {
            field: 'sortCodeId',
            headerName: t('Code ID'),
            flex: 0.6,
            minWidth: 70,
            headerAlign: 'center',
            align: 'center',
            type: 'string',
            filterOperators: stringFilterOperators,
        },
    ];

    const CreditColumns = [
        // Data columns in reverse order for RTL
        {
            field: 'description',
            headerName: t('Description'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            type: 'string',
            filterOperators: stringFilterOperators,
            renderCell: renderSummaryDescription(expandedInternalRows, handleInternalExpandClick),
        },
        {
            field: 'reference',
            headerName: t('Reference'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            type: 'string',
            filterOperators: stringFilterOperators,
        },
        {
            field: 'debitAccount',
            headerName: t('ContraAccount'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            type: 'string',
            filterOperators: stringFilterOperators,
            valueFormatter: (params) => {
                const accountCard = accountCardsData.find(c => c.cardId === params);
                return accountCard ? accountCard.name : "";
            }
        },
        {
            field: 'documentDate',
            headerName: t('Document Date'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            type: 'date',
            filterOperators: dateFilterOperators,
            valueGetter: (value) => {
                if (value == null) return null;
                if (value instanceof Date) return value;
                const str = String(value);
                if (/^\d{4}-\d{2}-\d{2}/.test(str)) return new Date(str);
                return new Date(parseCustomDate(str));
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const date = value instanceof Date ? value : new Date(value);
                if (isNaN(date.getTime())) return '';
                const day = ('0' + date.getDate()).slice(-2);
                const month = ('0' + (date.getMonth() + 1)).slice(-2);
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
            sortComparator: (v1, v2) => {
                const t1 = v1 instanceof Date ? v1.getTime() : new Date(v1).getTime();
                const t2 = v2 instanceof Date ? v2.getTime() : new Date(v2).getTime();
                return (t1 || 0) - (t2 || 0);
            },
        },
        {
            field: 'amount',
            headerName: t('Amount'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            filterOperators: numericFilterOperators,
            sortComparator: (v1, v2, param1, param2) => {
                // Helper function to parse the amount string
                const parseAmount = (value) => {
                    if (!value) return 0; // Return 0 for empty or null values

                    // Check if the value has parentheses (indicating a negative number)
                    const isNegative = value.includes('(');

                    // Remove commas and parentheses, then convert to a float
                    let cleanedValue = value.replace(/[(),]/g, '');

                    // Convert to a float. If parsing fails, return 0 as fallback
                    let amount = parseFloat(cleanedValue);
                    if (isNaN(amount)) amount = 0;

                    // Return negative if the value had parentheses
                    return isNegative ? -amount : amount;
                };

                const amount1 = parseAmount(v1);
                const amount2 = parseAmount(v2);

                // Debugging: log the parsed amounts


                // Ensure consistent sorting: return -1, 0, or 1
                return amount1 === amount2 ? 0 : amount1 < amount2 ? -1 : 1;
            },
        },
        // 'actions' column before 'expand' column
        {
            field: 'actions',
            headerName: t('Actions'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                const handleDeleteClick = () => {
                    const matchedRow = matchedDisplayedRows.find(
                        (match) => match.matchNumber === params.row.cardMatchNumber
                    );
                    if (matchedRow) {
                        handleRemoveMatchClick(matchedRow);
                    }
                };
                const hasValidCardMatchNumber = params.row.cardMatchNumber !== undefined && params.row.cardMatchNumber !== -1 && params.row.cardMatchNumber !== 0;
                const showRemoveMatch = fetchType === 'Matched' && hasValidCardMatchNumber;
                return !showRemoveMatch ? (
                    <IconButton
                        size="small"
                        onClick={() => handleEdit(editableRowOf(params.row))}
                    >
                        <img src={editIconImage} alt="Edit" />
                    </IconButton>
                ) : (
                    <Tooltip title={t("RemoveMatch")}>
                        <IconButton size="small" onClick={handleDeleteClick}>
                            <CancelRounded style={{ color: '#304FFF' }} />
                        </IconButton>
                    </Tooltip>
                );
            },
        },
    ];
    if (showingMatches) {
        CreditColumns.push(...matchedDetailColumns());
    }

    const DebitColumns = [
        // Data columns in reverse order for RTL
        {
            field: 'description',
            headerName: t('Description'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            type: 'string',
            filterOperators: stringFilterOperators,
            renderCell: renderSummaryDescription(expandedCreditRows, (id) => handleCreditExpandClick(id)),
        },
        {
            field: 'reference',
            headerName: t('Reference'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            type: 'string',
            filterOperators: stringFilterOperators,
        },
        {
            field: 'creditAccount',
            headerName: t('ContraAccount'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            type: 'string',
            filterOperators: stringFilterOperators,
            valueFormatter: (params) => {
                // Find the matching account in accountCardsData by creditAccount ID
                const accountCard = accountCardsData.find(c => c.cardId === params);
                return accountCard ? accountCard.name : "";
            }
        },
        {
            field: 'documentDate',
            headerName: t('Document Date'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            type: 'date',
            filterOperators: dateFilterOperators,
            valueGetter: (value) => {
                if (value == null) return null;
                if (value instanceof Date) return value;
                const str = String(value);
                if (/^\d{4}-\d{2}-\d{2}/.test(str)) return new Date(str);
                return new Date(parseCustomDate(str));
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const date = value instanceof Date ? value : new Date(value);
                if (isNaN(date.getTime())) return '';
                const day = ('0' + date.getDate()).slice(-2);
                const month = ('0' + (date.getMonth() + 1)).slice(-2);
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
            sortComparator: (v1, v2) => {
                const t1 = v1 instanceof Date ? v1.getTime() : new Date(v1).getTime();
                const t2 = v2 instanceof Date ? v2.getTime() : new Date(v2).getTime();
                return (t1 || 0) - (t2 || 0);
            },
        },
        {
            field: 'amount',
            headerName: t('Amount'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            filterOperators: numericFilterOperators,
            sortComparator: (v1, v2, param1, param2) => {
                // Helper function to parse the amount string
                const parseAmount = (value) => {
                    if (!value) return 0; // Return 0 for empty or null values

                    // Check if the value has parentheses (indicating a negative number)
                    const isNegative = value.includes('(');

                    // Remove commas and parentheses, then convert to a float
                    let cleanedValue = value.replace(/[(),]/g, '');

                    // Convert to a float. If parsing fails, return 0 as fallback
                    let amount = parseFloat(cleanedValue);
                    if (isNaN(amount)) amount = 0;

                    // Return negative if the value had parentheses
                    return isNegative ? -amount : amount;
                };

                const amount1 = parseAmount(v1);
                const amount2 = parseAmount(v2);

                // Debugging: log the parsed amounts


                // Ensure consistent sorting: return -1, 0, or 1
                return amount1 === amount2 ? 0 : amount1 < amount2 ? -1 : 1;
            },
        },
        // 'actions' column before 'expand' column
        {
            field: 'actions',
            headerName: t('Actions'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                const handleDeleteClick = () => {
                    const matchedRow = matchedDisplayedRows.find(
                        (match) => match.matchNumber === params.row.cardMatchNumber
                    );
                    if (matchedRow) {
                        handleRemoveMatchClick(matchedRow);
                    }
                };
                const hasValidCardMatchNumber = params.row.cardMatchNumber !== undefined && params.row.cardMatchNumber !== -1 && params.row.cardMatchNumber !== 0;
                const showRemoveMatch = fetchType === 'Matched' && hasValidCardMatchNumber;
                return !showRemoveMatch ? (
                    <IconButton
                        size="small"
                        onClick={() => handleEdit(editableRowOf(params.row))}
                    >
                        <img src={editIconImage} alt="Edit" />
                    </IconButton>
                ) : (
                    <Tooltip title={t("RemoveMatch")}>
                        <IconButton size="small" onClick={handleDeleteClick}>
                            <CancelRounded style={{ color: '#304FFF' }} />
                        </IconButton>
                    </Tooltip>
                );
            },
        },

    ];

    if (showingMatches) {
        DebitColumns.push(...matchedDetailColumns());
    }



    // Function to get the displayed rows based on expanded state
    const getDisplayedRows = () => {
        const result = [];

        const addRowAndSubRows = (row, level = 0) => {
            result.push({ ...row, level });
            if (expandedInternalRows[row.id] && row.subRows) {
                row.subRows.forEach((subRow) => {
                    addRowAndSubRows(subRow, level + 1);
                });
            }
        };

        summarizeRows(fetchType === 'Matched' ? creditMatchedRows : creditRows).forEach((row) => {
            addRowAndSubRows(row);
        });

        return result;
    };

    // useEffect to update displayedRows whenever internalRows or expandedInternalRows change
    useEffect(() => {

        const updatedDisplayedRows = getDisplayedRows();

        setDisplayedRows(updatedDisplayedRows);
    }, [creditRows, creditMatchedRows, rowViewMode, expandedInternalRows]);


    const creditDisplayedRows = getDisplayedRows();




    const getFilteredSortedRows = () => {
        // Get the sorted rows
        const sortedRows = apiRef.current.getSortedRows();

        // Access the filteredRowsLookup from the grid state
        const filteredRowsLookup = apiRef.current.state.filter.filteredRowsLookup;

        if (filteredRowsLookup) {
            // Create a Set of IDs of rows that pass the filter
            const filteredRowIdsSet = new Set(
                Object.entries(filteredRowsLookup)
                    .filter(([_, isVisible]) => isVisible)
                    .map(([id]) => id)
            );

            // Filter the sorted rows to include only those that are in the filteredRowIdsSet
            const filteredSortedRows = sortedRows.filter((row) =>
                filteredRowIdsSet.has(row.id)
            );

            return filteredSortedRows;
        } else {
            // If no filtering is applied, return the sorted rows
            return sortedRows;
        }
    };

    const handleSortModelChange = () => {
        const sortedRows = getFilteredSortedRows();

        setSortedTransactions(sortedRows);
    };



    // const DebitColumns = [

    //     {
    //         field: 'description',
    //         headerName: t('Description'),
    //         flex:1,
    //         headerAlign: 'center',
    //         align: 'center',
    //     },
    //     {
    //         field: 'reference',
    //         headerName: t('Reference'),
    //         flex:1,
    //         headerAlign: 'center',
    //         align: 'center',
    //     },
    //     {
    //         field: 'documentDate',
    //         headerName: t('Document Date'),
    //         flex:1,
    //         headerAlign: 'center',
    //         align: 'center',
    //         sortComparator: (v1, v2, param1, param2) => {
    //             const date1 = new Date(parseCustomDate(v1));
    //             const date2 = new Date(parseCustomDate(v2));
    //             return date1 - date2;
    //         },
    //     },
    //     {
    //         field: 'amount',
    //         headerName: t('Amount'),
    //         flex:1,
    //         headerAlign: 'center',
    //         align: 'center',
    //         sortComparator: (v1, v2, param1, param2) => {
    //             // Helper function to parse the amount string
    //             const parseAmount = (value) => {
    //                 if (!value) return 0; // Return 0 for empty or null values

    //                 // Check if the value has parentheses (indicating a negative number)
    //                 const isNegative = value.includes('(');

    //                 // Remove commas and parentheses, then convert to a float
    //                 let cleanedValue = value.replace(/[(),]/g, '');

    //                 // Convert to a float. If parsing fails, return 0 as fallback
    //                 let amount = parseFloat(cleanedValue);
    //                 if (isNaN(amount)) amount = 0;

    //                 // Return negative if the value had parentheses
    //                 return isNegative ? -amount : amount;
    //             };

    //             const amount1 = parseAmount(v1);
    //             const amount2 = parseAmount(v2);

    //             // Debugging: log the parsed amounts


    //             // Ensure consistent sorting: return -1, 0, or 1
    //             return amount1 === amount2 ? 0 : amount1 < amount2 ? -1 : 1;
    //         },
    //     },
    // ];
    const handleCreditExpandClick = (id) => {
        // Closing a group takes its children off the grid, so let go of them together with it.
        if (expandedCreditRows[id]) {
            const hidden = new Set(childIdsOf(debitDisplayedRows, id));
            if (hidden.size > 0) {
                setSelectedDebitRows((prev) => prev.filter((rowId) => !hidden.has(rowId)));
            }
        }
        setExpandedCreditRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };


    const getDebitDisplayedRows = () => {
        const result = [];

        const addRowAndSubRows = (row, level = 0) => {
            result.push({ ...row, level });
            if (expandedCreditRows[row.id] && row.subRows) {
                row.subRows.forEach((subRow) => {
                    addRowAndSubRows(subRow, level + 1);
                });
            }
        };

        summarizeRows(fetchType === 'Matched' ? debitMatchedRows : debitRows).forEach((row) => {
            addRowAndSubRows(row);
        });

        return result;
    };



    const debitDisplayedRows = getDebitDisplayedRows();

    // The card on the other side of the entry, carrying its number as well as its name —
    // a name alone is not enough to work a report against the books.
    const contraCardLabel = (id) => {
        if (id === null || id === undefined || id === '') return '';
        const name = accountCardsData.find((c) => c.cardId === id)?.name;
        return name ? `${id} - ${name}` : String(id);
    };

    // The number alone does not say what was booked, so a report prints the sort code's name with it.
    const sortCodeLabel = (id) => {
        if (id === null || id === undefined || id === '') return '';
        const name = sortCodeIdOptions.find((option) => option.value === id)?.sortCodeName;
        return name ? `${id} - ${name}` : String(id);
    };

    const buildUnmatchedReport = () => {
        const toSection = (title, rows) => buildUnmatchedSection({
            title,
            rows: rows.filter((row) => !row.level && !row._summaryChild),
            cardLabelOf: contraCardLabel,
            sortCodeLabelOf: sortCodeLabel,
            t,
        });
        const selectedCard = accountCardsData.find((c) => c.cardId === selectedCardId);
        return {
            title: t('UnmatchedReport'),
            clientName: client?.name,
            clientCase: client?.caseId,
            cardLabel: selectedCard ? `${selectedCard.cardId} - ${selectedCard.name}` : selectedCardId,
            startDate,
            endDate,
            fileSuffix: `Unmatched_${selectedCardId || ''}`,
            sections: [
                toSection(t('Debit'), debitDisplayedRows),
                toSection(t('Credit'), creditDisplayedRows),
            ],
            t,
        };
    };

    const handleDownloadUnmatched = async (format) => {
        const report = buildUnmatchedReport();
        if (format === 'excel') {
            downloadUnmatchedExcel(report);
            return;
        }
        setLoading(true);
        try {
            await downloadUnmatchedPdf({ ...report, token });
        } catch (err) {
            toast.error(err?.message || t('ErrorGeneratingPDF'));
        } finally {
            setLoading(false);
        }
    };

    /**
     * One card's open items split the way the two lists show them: both sides positive, in the
     * currency being matched. The rows arrive already unmatched, so only the currency is filtered here.
     */
    const splitOpenItemsBySide = (rows, cardId) => {
        const isFc = selectedCurrency !== null && selectedCurrency !== undefined;
        const currencyMatches = (row) => !isFc || row.foreignCurrencyCode === selectedCurrency;
        const rowAmount = (row) => (isFc ? (row.foreignCurrencyAmount ?? 0) : row.amount);
        const isCreditRow = (row) => (row.side ? row.side === 'credit' : row.creditAccount === cardId);
        const isDebitRow = (row) => (row.side ? row.side === 'debit' : row.debitAccount === cardId);
        const toReportRow = (row, sign) => ({
            sortCodeId: row.sortCodeId ?? '',
            debitAccount: row.debitAccount,
            creditAccount: row.creditAccount,
            documentDate: row.documentDate ? formatDate(row.documentDate) : '',
            amount1: sign * rowAmount(row),
            vat: row.vat ?? null,
            reference: row.reference,
            description: row.description,
        });

        const open = rows.filter(currencyMatches);
        return {
            debitRows: open.filter(isDebitRow).map((row) => toReportRow(row, 1)),
            creditRows: open.filter(isCreditRow).map((row) => toReportRow(row, -1)),
        };
    };

    /**
     * The many-card open-items report: one call covers every selected card, the ones with nothing open
     * are left out, and what remains is printed as a summary page followed by a page per card.
     */
    const handleDownloadUnmatchedCards = async (cards, format, period = {}) => {
        setUnmatchedCardsBusy(true);
        try {
            const formattedStartDate = (period.startDate || startDate || new Date(0)).toISOString();
            const formattedEndDate = (period.endDate || endDate || new Date()).toISOString();
            const response = await DocumentService.GetOpenItemsByAccountCodeIds(
                client.caseId, formattedStartDate, formattedEndDate,
                cards.map((card) => card.cardId), token, selectedCurrency
            );
            if (!response.ok) throw new Error(t('ErrorGeneratingPDF'));

            // The response only carries the cards that have something open, so the picked order decides
            // the order of the pages rather than whatever the server returned.
            const rowsByCard = new Map(
                (await response.json()).map((item) => [item.accountCodeId, item.transactions || []])
            );

            const cardReports = [];
            cards.forEach((card) => {
                const { debitRows, creditRows } = splitOpenItemsBySide(rowsByCard.get(card.cardId) || [], card.cardId);
                if (debitRows.length === 0 && creditRows.length === 0) return;
                cardReports.push({
                    label: `${card.cardId} - ${card.name}`,
                    sections: [
                        buildUnmatchedSection({
                            title: t('Debit'),
                            rows: debitRows,
                            cardLabelOf: contraCardLabel,
                            sortCodeLabelOf: sortCodeLabel,
                            t,
                        }),
                        buildUnmatchedSection({
                            title: t('Credit'),
                            rows: creditRows,
                            cardLabelOf: contraCardLabel,
                            sortCodeLabelOf: sortCodeLabel,
                            t,
                        }),
                    ],
                });
            });

            if (cardReports.length === 0) {
                toast.info(t('NoUnmatchedCardsFound'));
                return;
            }

            const summary = buildUnmatchedCardsSummary({ cards: cardReports, t });
            const report = {
                title: t('UnmatchedCardsReport'),
                clientName: client?.name,
                clientCase: client?.caseId,
                cardLabel: `${t('AccountCards')}: ${cardReports.length}`,
                startDate: period.startDate || startDate,
                endDate: period.endDate || endDate,
                fileSuffix: 'UnmatchedCards',
                t,
            };

            if (format === 'excel') {
                downloadUnmatchedExcel({
                    ...report,
                    sections: [summary, buildUnmatchedCardsFlatSection({ cards: cardReports, t })],
                });
            } else {
                await downloadUnmatchedPdf({
                    ...report,
                    summary,
                    groups: cardReports.map((card) => ({ title: card.label, sections: card.sections })),
                    token,
                });
            }
            setUnmatchedCardsModalOpen(false);
        } catch (err) {
            toast.error(err?.message || t('ErrorGeneratingPDF'));
        } finally {
            setUnmatchedCardsBusy(false);
        }
    };

    // Function to handle sorting, collapse all rows before sorting, and restore after sorting
    const handleSort = (columnField) => {
        // Store the current expanded rows
        const previouslyExpandedRows = { ...expandedMatchedRows };

        // Collapse all rows before sorting
        setExpandedMatchedRows({});

        // Perform the sorting
        const sortedRows = [...getMatchedDisplayedRows()].sort((a, b) => {
            const valueA = a[columnField];
            const valueB = b[columnField];

            // Example of comparing values (you can modify it based on the field type)
            if (valueA === undefined) return 1;
            if (valueB === undefined) return -1;
            return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
        });

        // After sorting, update matchData with sorted rows
        setMatchData(sortedRows);

        // Restore the expanded rows after sorting
        setTimeout(() => {
            setExpandedMatchedRows(previouslyExpandedRows);
        }, 0);
    };

    // Matched Columns
    const MatchedColumns = [
        {
            field: 'matchNumber',
            headerName: t('MatchNumber'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (!params.row.isSubRow ? params.value : ''),
            sortComparator: (v1, v2, param1, param2) => {
                const row1 = param1.row || {};
                const row2 = param2.row || {};

                if (row1.isSubRow && row2.isSubRow) {
                    return 0;
                }
                if (row1.isSubRow && !row2.isSubRow) {
                    return 1;
                }
                if (!row1.isSubRow && row2.isSubRow) {
                    return -1;
                }

                const matchNumber1 = v1 !== undefined ? v1 : 0;
                const matchNumber2 = v2 !== undefined ? v2 : 0;
                return matchNumber1 === matchNumber2 ? 0 : matchNumber1 < matchNumber2 ? -1 : 1;
            }
        },
        {
            field: 'documentDate',
            headerName: t('documentDate'),
            width: 200,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const row = params.row;
                if (row.isSubRow && !row.isHeader) {
                    return formatDate(row.documentDate);
                } else if (!row.isSubRow) {
                    return formatDate(row.documentDate);
                } else {
                    return '';
                }
            },
            sortComparator: (v1, v2, param1, param2) => {
                const date1 = new Date(v1);
                const date2 = new Date(v2);
                return date1 - date2;
            },
        },
        {
            field: 'matchDate',
            headerName: t('MatchDate'),
            width: 200,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (!params.row.isSubRow ? formatDate(params.value) : ''),
            sortComparator: (v1, v2, param1, param2) => {
                const date1 = new Date(v1);
                const date2 = new Date(v2);
                return date1 - date2;
            }
        },
        {
            field: 'description',
            headerName: t('Description'),
            width: 200,
            headerAlign: 'center',
            align: 'left',
            renderCell: (params) => {
                const row = params.row;
                const indentation = row.level * 20;
                if (row.isHeader) {
                    return (
                        <div style={{ paddingLeft: `${indentation}px`, fontWeight: 'bold' }}>
                            {t(row.transactionType)}
                        </div>
                    );
                } else if (row.isSubRow) {
                    return <div style={{ paddingLeft: `${indentation}px` }}>{row.description}</div>;
                } else {
                    return '';
                }
            },
            sortable: true,
            sortComparator: () => 0, // Disable default sorting
        },
        {
            field: 'reference',
            headerName: t('Reference'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const row = params.row;
                if (row.isSubRow && !row.isHeader) {
                    return row.reference || '';
                } else {
                    return '';
                }
            },
            sortable: true,
            sortComparator: () => 0, // Disable default sorting
        },
        {
            field: 'documentDate',
            headerName: t('Document Date'),
            width: 200,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const row = params.row;
                if (row.isSubRow && !row.isHeader) {
                    return formatDate(row.documentDate);
                } else {
                    return '';
                }
            },
            sortable: true,
            sortComparator: () => 0, // Disable default sorting
        },
        {
            field: 'amount',
            headerName: t('Amount'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const row = params.row;
                if (row.isSubRow && !row.isHeader) {
                    return beautifyNumber(row.amount);
                } else {
                    return '';
                }
            },
            sortable: true,
            sortComparator: () => 0, // Disable default sorting
        },
        {
            field: 'type',
            headerName: t('Type'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const row = params.row;
                if (row.isSubRow && !row.isHeader) {
                    const typeParts = row.type.split('-'); // Split the type by '-'
                    if (typeParts.length > 1) {
                        // Translate the second part (Checks, etc.)
                        const translatedSecondPart = t(typeParts[1]);
                        return translatedSecondPart;
                    } else {
                        return t(row.type); // If there is no hyphen, just return the type
                    }
                } else {
                    return '';
                }
            },
            sortable: true,
            sortComparator: () => 0, // Disable default sorting
        },
        {
            field: 'uploadNumber',
            headerName: t('UploadNumber'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const row = params.row;
                if (row.isSubRow && !row.isHeader) {
                    return beautifyNumber(row.uploadNumber);
                } else {
                    return '';
                }
            },
            sortable: true,
            sortComparator: () => 0, // Disable default sorting
        },
        {
            field: 'actions',
            headerName: t('Actions'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                const row = params.row;
                if (!row.isSubRow) {
                    return (
                        <Tooltip title={t("RemoveMatch")}>
                            <IconButton size="small" onClick={() => handleRemoveMatchClick(row)}>
                                <CancelRounded style={{ color: '#E57C22' }} />
                            </IconButton>
                        </Tooltip>
                    );
                } else {
                    return null;
                }
            },
        },
        {
            field: 'expand',
            headerName: '',
            width: 50,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                const row = params.row;
                if (!row.isSubRow) {
                    const isExpandable =
                        (row.externalTransactions && row.externalTransactions.length > 0) ||
                        (row.internalTransactions && row.internalTransactions.length > 0);
                    return isExpandable ? (
                        <IconButton size="small" onClick={() => handleMatchedExpandClick(row.id)}>
                            {expandedMatchedRows[row.id] ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                    ) : null;
                } else {
                    return null;
                }
            },
        },
    ];






    // Function to get displayed rows



    // const matchedDisplayedRows = getMatchedDisplayedRows();



    // Handle Create Journal Entries checkbox
    const handleCreateJournalEntries = (checked) => {
        let selectedRows = [];

        if (selectedDebitRows.length > 0) {
            selectedRows = selectedRowsOf(debitDisplayedRows, selectedDebitRows);
        } else if (selectedCreditRows.length > 0) {
            selectedRows = selectedRowsOf(creditDisplayedRows, selectedCreditRows);
        }

        // Open the create journal entries dialog
        setCreateJournalEntries(checked);
        setIsCreateDialogOpen(true);
        setUsePerRowReportingMonth(false);


        if (!checked) {
            // Case 1: Checked is false (existing behavior)
            // Find the row with the oldest documentDate
            const oldestRow = selectedRows.reduce((oldest, current) => {
                return new Date(parseCustomDate(current.documentDate)) < new Date(parseCustomDate(oldest.documentDate)) ? current : oldest;
            }, selectedRows[0]); // Initialize with the first row


            // Get the oldest documentDate and description

            const oldestDate = new Date(parseCustomDate(oldestRow.documentDate)).toISOString().split('T')[0];
            const oldestDescription = oldestRow.description;

            // Calculate the total sum. When a currency is active this is the FC balance
            // (debitSum/creditSum use amount1 = FC amount); shekelSum is the shekel balance.
            const Sum = debitSum - creditSum;
            const shekelSum = debitShekelSum - creditShekelSum;
            const isFc = selectedCurrency !== null && selectedCurrency !== undefined;

            // Direction (debit vs credit) is the same regardless of currency.
            if (Sum > 0) {
                handleSelectChange('creditAccount', selectedCardId); // Set creditAccount if externalSum is negative
                handleSelectChange('debitAccount', null);
            } else {
                handleSelectChange('debitAccount', selectedCardId); // Set debitAccount if externalSum is positive
                handleSelectChange('creditAccount', null);

            }

            // The journal entry's primary amount is always in shekels; the foreign-currency
            // amount is stored alongside it when a currency is selected.
            handleSelectChange('amount', parseFloat(Math.abs(shekelSum).toFixed(2)));
            handleSelectChange('foreignCurrencyAmount', isFc ? parseFloat(Math.abs(Sum).toFixed(2)) : '');
            handleSelectChange('description', oldestDescription);
            handleSelectChange('documentDate', oldestDate);
            const oldestReportingMonth = setReportingMonthToDay10(oldestDate);
            handleSelectChange('reportingMonthDate', oldestReportingMonth);
            handleSelectChange('registrationMonthDate', oldestReportingMonth);
        } else {
            // Case 2: Checked is true (new behavior)
            // Reset form values and sync registration month to reporting month
            const defaultMonth = setReportingMonthToDay10(new Date());
            setJournalReportingMonthDate(defaultMonth);
            setJournalRegistrationMonthDate(defaultMonth);
            setFormValues({
                confirmationNumber: '',
                accountCaseId: '',
                reference: '',
                description: '',
                documentDate: '',
                reportingMonthDate: defaultMonth,
                registrationMonthDate: defaultMonth,
                amount: '',
                foreignCurrencyAmount: '',
                vat: '',
                sortCodeId: '3',
                creditAccount: '',
                debitAccount: '',
                sortCode: '3',
                accountCard: ''
            });
        }
    };

    const handleMatchEntries = async () => {
        // Prepare the DTOs for all matches

        // Auto-match pairs are built from the raw rows, which the Summary view may have collapsed.
        const matchDebitRows = [...debitDisplayedRows, ...debitRows];
        const matchCreditRows = [...creditDisplayedRows, ...creditRows];
        const matchDTOs = matchedPairs.map(pair => {
            const debitRow = matchDebitRows.find(row => row.id === pair.debitId);
            const creditRow = matchCreditRows.find(row => row.id === pair.creditId);

            // Get the oldest transaction date between the matched debit and credit rows
            const debitDate = debitRow ? new Date(parseCustomDate(debitRow.documentDate)) : null;
            const creditDate = creditRow ? new Date(parseCustomDate(creditRow.documentDate)) : null;

            let oldestDocumentDate = new Date();
            if (debitDate && creditDate) {
                oldestDocumentDate = debitDate < creditDate ? debitDate : creditDate;
            } else if (debitDate) {
                oldestDocumentDate = debitDate;
            } else if (creditDate) {
                oldestDocumentDate = creditDate;
            }

            return {
                CaseId: client.caseId,
                AccountCodeId: selectedCardId,
                transactionDate: oldestDocumentDate.toISOString(),
                DebitTransactionIds: [{ Id: pair.debitId, Type: debitRow ? debitRow.type : 'JournalEntries' }],
                CreditTransactionIds: [{ Id: pair.creditId, Type: creditRow ? creditRow.type : 'JournalEntries' }],
                Currency: selectedCurrency
            };
        });

        try {
            // Call the API to create multiple matches
            await CardMatchService.CreateMultipleMatches(matchDTOs, token);

            handleClearMatches();
            await FetchData();
            toast.success(t('MatchesCreatedSuccessfully'));
        } catch (error) {
            console.error('Error creating matches:', error);
            toast.error(t('ErrorCreatingMatches'));
        }
    };





    // Define a set of colors for matched pairs
    const matchColors = [
        '#FFCDD2', // Light Red
        '#C8E6C9', // Light Green
        '#BBDEFB', // Light Blue
        '#FFF9C4', // Light Yellow
        '#D1C4E9', // Light Purple
        '#FFECB3', // Light Orange
        '#B2DFDB', // Light Teal
    ];

    // Function to get color based on matchId
    const getMatchColor = (matchId) => {
        const index = parseInt(matchId.split('-')[1], 10);
        return matchColors[index % matchColors.length];
    };

    const normalize = str =>
        str
            ?.toString()
            .trim()
            .toLowerCase()
            .normalize('NFKC')            // Normalize Unicode
            .replace(/\s+/g, ' ')         // Replace multiple spaces
            .replace(/[^\w\sא-ת-]/g, '');

    const parseFormattedAmount = (value) => {
        if (!value) return NaN;

        // Convert to string and trim
        const strValue = String(value).trim();

        // Check if it's wrapped in parentheses (negative number format)
        if (strValue.startsWith('(') && strValue.endsWith(')')) {
            // Remove parentheses and parse as negative number
            const cleanValue = strValue.slice(1, -1).replace(/,/g, '');
            return -parseFloat(cleanValue);
        }

        // Remove commas and parse normally
        const cleanValue = strValue.replace(/,/g, '');
        return parseFloat(cleanValue);
    };

    const computeSimilarity = (
        debitRow,
        creditRow,
        selectedColumns,
        amountTolerance = 0.01,
        referenceLastDigits = 4
    ) => {
        if (!selectedColumns?.length) return 0;

        for (const column of selectedColumns) {
            let debitValue = debitRow?.[column];
            let creditValue = creditRow?.[column];

            if (column.toLowerCase() === 'amount') {
                const debitAmt = parseFormattedAmount(debitValue);
                const creditAmt = parseFormattedAmount(creditValue);

                if (
                    isNaN(debitAmt) ||
                    isNaN(creditAmt) ||
                    Math.abs(debitAmt - creditAmt) > amountTolerance
                ) {
                    return 0; // mismatch → bail out
                }
            } else if (column === 'reference_last') {
                const debitSuffix = getReferenceLastDigits(debitRow?.reference, referenceLastDigits);
                const creditSuffix = getReferenceLastDigits(creditRow?.reference, referenceLastDigits);

                if (
                    debitSuffix.length < referenceLastDigits ||
                    creditSuffix.length < referenceLastDigits ||
                    debitSuffix !== creditSuffix
                ) {
                    return 0;
                }
            } else {
                const debitStr = normalize(debitValue ?? '');
                const creditStr = normalize(creditValue ?? '');

                if (debitStr !== creditStr) return 0; // mismatch → bail out
            }
        }

        // got through all columns → everything matches
        return 1;
    };



    const handleAutoMatchHeaders = (selectedColumns, referenceLastDigits = 4) => {
        if (!selectedColumns.includes('amount')) {
            alert('Please include the Amount column in your selection.');
            return;
        }

        const matches = [];
        const updatedDebitRows = [...debitRows];
        const updatedCreditRows = [...creditRows];
        let matchIdCounter = matchCounter;

        // Collect potential matches with similarity scores
        const potentialMatches = [];

        debitRows.forEach((debitRow, debitIndex) => {
            creditRows.forEach((creditRow, creditIndex) => {
                const score = computeSimilarity(
                    debitRow,
                    creditRow,
                    selectedColumns,
                    0.01,
                    referenceLastDigits
                );

                if (score > 0) {
                    potentialMatches.push({
                        debitRow,
                        creditRow,
                        score,
                        debitIndex: debitIndex,
                        creditIndex: creditIndex,
                    });
                }
            });
        });

        // Sort potential matches by descending similarity score
        potentialMatches.sort((a, b) => b.score - a.score);

        // Perform one-to-one matching
        const matchedDebitIds = new Set(); // To track matched debit rows
        const matchedCreditIds = new Set(); // To track matched credit rows

        for (const match of potentialMatches) {
            const { debitRow, creditRow, score, debitIndex, creditIndex } = match;

            // Define a threshold for accepting matches
            const threshold = 0.5; // Adjust as needed

            if (
                !matchedDebitIds.has(debitRow.id) && // Check if the debit row is already matched
                !matchedCreditIds.has(creditRow.id) && // Check if the credit row is already matched
                score >= threshold
            ) {
                const matchId = `match-${matchIdCounter++}`;
                const colorIndex = parseInt(matchId.split('-')[1], 10) % matchColors.length;
                const rowClassName = `super-app-theme--matched-${colorIndex}`;

                // Update debit row
                updatedDebitRows[debitIndex] = {
                    ...debitRow,
                    matchId,
                    rowClassName,
                };

                // Update credit row
                updatedCreditRows[creditIndex] = {
                    ...creditRow,
                    matchId,
                    rowClassName,
                };

                matches.push({
                    debitId: debitRow.id,
                    creditId: creditRow.id,
                    matchId,
                });

                // Mark rows as matched
                matchedDebitIds.add(debitRow.id);
                matchedCreditIds.add(creditRow.id);
            }
        }

        // Sort the rows so that matched rows are placed at the top
        const reorderRows = (rows) => {
            return rows.sort((a, b) => {
                if (a.matchId && !b.matchId) return -1; // a is matched, b is not
                if (!a.matchId && b.matchId) return 1;  // b is matched, a is not
                return 0; // Both are matched or both are unmatched, keep original order
            });
        };

        const reorderedDebitRows = reorderRows(updatedDebitRows);
        const reorderedCreditRows = reorderRows(updatedCreditRows);

        setMatchedPairs(matches);
        setDebitRows(reorderedDebitRows);
        setCreditRows(reorderedCreditRows);

        setMatchCounter(matchIdCounter);

        // Update selection state
        const debitMatchedIds = matches.map((match) => match.debitId);
        const creditMatchedIds = matches.map((match) => match.creditId);

        setSelectedDebitRows(debitMatchedIds);
        setSelectedCreditRows(creditMatchedIds);
    };









    // Function to clear matches
    const handleClearMatches = () => {
        const clearedExternalRows = debitRows.map((row) => {
            const newRow = { ...row };
            delete newRow.matchId;
            delete newRow.rowClassName;
            return newRow;
        });

        const clearedInternalRows = creditRows.map((row) => {
            const newRow = { ...row };
            delete newRow.matchId;
            delete newRow.rowClassName;
            return newRow;
        });

        setDebitRows(clearedExternalRows);
        setCreditRows(clearedInternalRows);
        setSelectedDebitRows([]);
        setSelectedCreditRows([]);
        setMatchedPairs([]);
    };


    const addNewAccountCardData = (newAccountCard) => {


        if (accountCardsData && accountCardsData.length > 0) {
            // Transform accountCardsData
            const transformedData = accountCardsData.map(card => ({
                ...card,
                value: card.cardId, // Set value to cardId
                label: card.name,   // Set label to name

            }));

            // Prepend the "AddAccountCard" option
            const combinedData = [{ name: t('AddAccountCard'), value: 'AddItem' }, ...transformedData];

            // Add the newAccountCard to combinedData with value and label
            const newAccountCardWithProps = {
                ...newAccountCard,
                value: newAccountCard.cardId,  // Set value to cardId
                label: newAccountCard.name,     // Set label to name
                index: accountCardsData.length
            };
            combinedData.push(newAccountCardWithProps);

            // Update processedCardsData
            setAccountCardsData(prevData => [...prevData, newAccountCard]);
            setProcessedCardsData(combinedData);
            setMainCard(newAccountCardWithProps);
        }

    };

    useEffect(() => {


    }, [mainCard]);



    // Function to handle Match action
    const handleMatch = async (debitRowsToMatch = selectedDebitRows, creditRowsToMatch = selectedCreditRows) => {
        if (debitRowsToMatch.length === 0 && creditRowsToMatch.length === 0) {
            alert('Please select both debit and credit transactions to match.');
            return;
        }

        // Prepare Debit / Credit Transactions (a summary row matches every row it collapses)
        const debitTransactionIds = expandSelectedIds(debitRowsToMatch, debitDisplayedRows)
            .map(({ id, type }) => ({ Id: id, Type: type }));
        const creditTransactionIds = expandSelectedIds(creditRowsToMatch, creditDisplayedRows)
            .map(({ id, type }) => ({ Id: id, Type: type }));

        // Find the oldest transaction date among all selected transactions
        const allSelectedRows = [
            ...debitDisplayedRows.filter(row => debitRowsToMatch.includes(row.id)),
            ...creditDisplayedRows.filter(row => creditRowsToMatch.includes(row.id))
        ];

        const oldestTransaction = allSelectedRows.reduce((oldest, current) => {
            return new Date(parseCustomDate(current.documentDate)) < new Date(parseCustomDate(oldest.documentDate)) ? current : oldest;
        }, allSelectedRows[0]);

        const oldestDocumentDate = oldestTransaction
            ? new Date(parseCustomDate(oldestTransaction.documentDate))
            : new Date();

        // Create the match DTO (Currency = null means a regular shekel match)
        const matchDTO = {
            CaseId: client.caseId,
            AccountCodeId: selectedCardId,
            transactionDate: oldestDocumentDate.toISOString(),
            DebitTransactionIds: debitTransactionIds,
            CreditTransactionIds: creditTransactionIds,
            Currency: selectedCurrency
        };

        try {
            const response = await CardMatchService.CreateMatch(matchDTO, token);

            if (response.ok) {
                toast.success(t("MatchCreatedSuccessfully"));
                // Clear selections and refresh data as needed
                setSelectedDebitRows([]);
                setSelectedCreditRows([]);
                await FetchData();
            } else {
                const errorText = await response.text();
                console.error('Failed to create match:', errorText);
                toast.error(t("ErrorCreatingMatch"));
            }
        } catch (error) {
            console.error('Error creating match:', error);
            toast.error(t("ErrorCreatingMatch"));
        }
    };

    const withBottomDockBarLoading = (fn) => async (...args) => {
        setBottomDockBarLoading(true);
        try {
            return await Promise.resolve(fn(...args));
        } finally {
            setBottomDockBarLoading(false);
        }
    };

    // ─────────────────────────────────────────────────────────────────────────
    // Keyboard-driven matching (same behavior as BankMatching)
    // Arrows move between rows/panels, Space toggles selection, Shift extends a
    // range, F5 matches (or opens the difference journal entry), F6 creates
    // separate journal entries per selected row, "/" searches, "?" opens guide.
    // ─────────────────────────────────────────────────────────────────────────

    // Tracks a Shift+click on a row so the selection-model callback can expand
    // it into a range (the grid itself only toggles the clicked row).
    const shiftClickRef = useRef(null);

    // Ordered visible row ids of a panel, respecting the grid's sort + filter.
    const getPanelRowIds = (panel) => {
        const gridRef = panel === 'credit' ? apiRef : debitApiRef;
        try {
            if (gridRef.current?.getSortedRowIds) {
                const sortedIds = gridRef.current.getSortedRowIds();
                const lookup = gridRef.current.state?.filter?.filteredRowsLookup;
                if (lookup) {
                    return sortedIds.filter((id) => lookup[id] !== false);
                }
                return sortedIds;
            }
        } catch (error) {
            // Grid not mounted yet; fall through to the plain row arrays.
        }
        const rows = panel === 'credit' ? creditDisplayedRows : debitDisplayedRows;
        return rows.map((row) => row.id);
    };

    // A summary row and the rows it collapses tick together: whichever one is clicked, the whole
    // group is selected (or cleared), since matching always treats the group as one unit.
    const groupMembersOf = (rows) => {
        const members = new Map();
        for (const row of rows || []) {
            if (!row._summary) continue;
            const group = [row.id, ...(row._children || []).map((child) => child.id)];
            group.forEach((id) => members.set(id, group));
        }
        return members;
    };

    const childIdsOf = (rows, rowId) => {
        const row = (rows || []).find((candidate) => candidate.id === rowId);
        return (row?._children || []).map((child) => child.id);
    };

    // Selecting a collapsed group opens it, so the rows ticked along with the summary row are
    // visible — and so the grid holds every selected row (it drops selected ids it cannot find).
    const expandGroupsForSelection = (panel, rows, ids) => {
        const selected = new Set(ids);
        const summaryIds = (rows || [])
            .filter((row) => row._summary && selected.has(row.id))
            .map((row) => row.id);
        if (summaryIds.length === 0) return;
        const setExpanded = panel === 'credit' ? setExpandedInternalRows : setExpandedCreditRows;
        setExpanded((prev) => {
            const next = { ...prev };
            let changed = false;
            summaryIds.forEach((id) => {
                if (!next[id]) {
                    next[id] = true;
                    changed = true;
                }
            });
            return changed ? next : prev;
        });
    };

    // The selected rows themselves, with each group counted once: a summary row stands for its
    // children, so the children that tick along with it are left out.
    const selectedRowsOf = (rows, selectedIds) =>
        (rows || []).filter((row) => !row._summaryChild && selectedIds.includes(row.id));

    const withGroupSelection = (rows) => (ids, previousIds) => {
        const members = groupMembersOf(rows);
        if (members.size === 0) return ids;
        const next = new Set(ids);
        const previous = new Set(previousIds);
        for (const id of ids) {
            if (!previous.has(id)) (members.get(id) || []).forEach((member) => next.add(member));
        }
        for (const id of previousIds) {
            if (!next.has(id)) (members.get(id) || []).forEach((member) => next.delete(member));
        }
        return Array.from(next);
    };

    const getPanelState = (panel) =>
        panel === 'credit'
            ? {
                focusedId: focusedCreditId,
                setFocusedId: setFocusedCreditId,
                anchorId: creditAnchorId,
                setAnchorId: setCreditAnchorId,
                selected: selectedCreditRows,
                setSelected: (ids) => {
                    expandGroupsForSelection('credit', creditDisplayedRows, ids);
                    setSelectedCreditRows((prev) => withGroupSelection(creditDisplayedRows)(ids, prev));
                },
                gridRef: apiRef,
            }
            : {
                focusedId: focusedDebitId,
                setFocusedId: setFocusedDebitId,
                anchorId: debitAnchorId,
                setAnchorId: setDebitAnchorId,
                selected: selectedDebitRows,
                setSelected: (ids) => {
                    expandGroupsForSelection('debit', debitDisplayedRows, ids);
                    setSelectedDebitRows((prev) => withGroupSelection(debitDisplayedRows)(ids, prev));
                },
                gridRef: debitApiRef,
            };

    const scrollPanelToRow = (panel, rowId, ids, skipCellFocus = false) => {
        const { gridRef } = getPanelState(panel);
        try {
            const rowIndex = ids.indexOf(rowId);
            if (rowIndex !== -1) {
                // With pagination on, jump to the page containing the row first.
                const paginationModel = gridRef.current?.state?.pagination?.paginationModel;
                let scrollIndex = rowIndex;
                if (paginationModel?.pageSize > 0) {
                    const targetPage = Math.floor(rowIndex / paginationModel.pageSize);
                    if (targetPage !== paginationModel.page) {
                        gridRef.current?.setPage?.(targetPage);
                    }
                    scrollIndex = rowIndex % paginationModel.pageSize;
                }
                gridRef.current?.scrollToIndexes({ rowIndex: scrollIndex, colIndex: 0 });
            }
            // Skipped while typing in the search box so DOM focus stays there.
            if (!skipCellFocus) {
                const visibleColumns = gridRef.current?.getVisibleColumns?.() || [];
                const firstField = visibleColumns.find((col) => col.field !== '__check__')?.field;
                if (firstField) {
                    gridRef.current?.setCellFocus?.(rowId, firstField);
                }
            }
        } catch (error) {
            // Row may not be rendered yet (virtualization); focus highlight still applies.
        }
    };

    // mode "select" adds the contiguous range to the selection, "deselect"
    // removes it.
    const selectPanelRange = (panel, fromId, toId, ids, mode = 'select') => {
        const { selected, setSelected } = getPanelState(panel);
        const fromIndex = ids.indexOf(fromId);
        const toIndex = ids.indexOf(toId);
        if (fromIndex === -1 || toIndex === -1) return;
        const [start, end] = fromIndex <= toIndex ? [fromIndex, toIndex] : [toIndex, fromIndex];
        const rangeIds = ids.slice(start, end + 1);
        if (mode === 'deselect') {
            const rangeSet = new Set(rangeIds);
            setSelected(selected.filter((id) => !rangeSet.has(id)));
            return;
        }
        setSelected(Array.from(new Set([...selected, ...rangeIds])));
    };

    // Arrow up/down inside the active panel. With Shift, the selection follows
    // the range between the anchor and the focused row: rows entering the range
    // are selected, rows leaving it (walking back over them) are deselected,
    // and a deselected anchor turns the walk into a deselect sweep.
    const moveFocus = (delta, extendSelection, panelOverride, skipCellFocus = false) => {
        const panel = panelOverride || activePanel;
        const ids = getPanelRowIds(panel);
        if (ids.length === 0) return;
        const { focusedId, setFocusedId, anchorId, setAnchorId, selected, setSelected } =
            getPanelState(panel);
        const currentIndex = ids.indexOf(focusedId);
        const nextIndex =
            currentIndex === -1
                ? delta > 0
                    ? 0
                    : ids.length - 1
                : Math.min(ids.length - 1, Math.max(0, currentIndex + delta));
        const nextId = ids[nextIndex];
        setFocusedId(nextId);
        if (extendSelection) {
            const effectiveAnchor =
                anchorId != null && ids.includes(anchorId) ? anchorId : focusedId ?? nextId;
            if (anchorId == null) setAnchorId(effectiveAnchor);
            const anchorIndex = ids.indexOf(effectiveAnchor);
            // Deselect sweep only when the anchor row was explicitly deselected
            // (e.g. toggled off with Space); a fresh anchor always selects.
            const mode =
                anchorId != null && !selected.includes(effectiveAnchor) ? 'deselect' : 'select';
            const [rangeStart, rangeEnd] =
                anchorIndex <= nextIndex ? [anchorIndex, nextIndex] : [nextIndex, anchorIndex];
            const rangeIds = ids.slice(rangeStart, rangeEnd + 1);
            const rangeSet = new Set(rangeIds);
            if (mode === 'deselect') {
                setSelected(selected.filter((id) => !rangeSet.has(id)));
            } else {
                // Rows that just left the range (the walk reversed toward the
                // anchor) are deselected again.
                const prevIndex = currentIndex === -1 ? nextIndex : currentIndex;
                const [oldStart, oldEnd] =
                    anchorIndex <= prevIndex ? [anchorIndex, prevIndex] : [prevIndex, anchorIndex];
                const exitedSet = new Set(
                    ids.slice(oldStart, oldEnd + 1).filter((id) => !rangeSet.has(id))
                );
                setSelected(
                    Array.from(new Set([...selected.filter((id) => !exitedSet.has(id)), ...rangeIds]))
                );
            }
        }
        scrollPanelToRow(panel, nextId, ids, skipCellFocus);
    };

    // Arrow left/right between the two panels, restoring that panel's last
    // focused row (or its first visible row).
    const switchPanel = (targetPanel) => {
        if (targetPanel === activePanel) return;
        setActivePanel(targetPanel);
        const ids = getPanelRowIds(targetPanel);
        if (ids.length === 0) return;
        const { focusedId, setFocusedId } = getPanelState(targetPanel);
        const restoredId = focusedId != null && ids.includes(focusedId) ? focusedId : ids[0];
        setFocusedId(restoredId);
        scrollPanelToRow(targetPanel, restoredId, ids);
    };

    // Space: toggle the focused row. Shift+Space: apply the anchor row's state
    // to the whole range - if the anchor row is selected the range is selected,
    // if the anchor row was just deselected the range is deselected too.
    const toggleFocusedRowSelection = (shiftKey) => {
        const panel = activePanel;
        const ids = getPanelRowIds(panel);
        const { focusedId, anchorId, setAnchorId, selected, setSelected } = getPanelState(panel);
        if (focusedId == null || !ids.includes(focusedId)) return;
        if (shiftKey && anchorId != null && ids.includes(anchorId)) {
            const mode = selected.includes(anchorId) ? 'select' : 'deselect';
            selectPanelRange(panel, anchorId, focusedId, ids, mode);
        } else {
            if (selected.includes(focusedId)) {
                setSelected(selected.filter((id) => id !== focusedId));
            } else {
                setSelected([...selected, focusedId]);
            }
            setAnchorId(focusedId);
        }
    };

    // "/": focus the quick-search box of the active panel's grid.
    const focusPanelSearch = () => {
        const { gridRef } = getPanelState(activePanel);
        const root = gridRef.current?.rootElementRef?.current;
        const input = root?.querySelector('.MuiDataGrid-toolbarQuickFilter input');
        if (input) {
            input.focus();
            input.select?.();
        }
    };

    // Which panel's grid contains the given DOM element (e.g. its search box).
    const getPanelForTarget = (target) => {
        if (apiRef.current?.rootElementRef?.current?.contains(target)) return 'credit';
        if (debitApiRef.current?.rootElementRef?.current?.contains(target)) return 'debit';
        return null;
    };

    const isQuickSearchTarget = (target) =>
        !!target?.closest?.('.MuiDataGrid-toolbarQuickFilter');

    // F5: when the difference is zero match the selection; otherwise open the
    // journal-entry dialog pre-filled with the remaining difference.
    const handleReconcileShortcut = () => {
        if (loading || bottomDockBarLoading) return;
        if (selectedDebitRows.length === 0 && selectedCreditRows.length === 0) {
            toast.info(t('KbdSelectRowsFirst'));
            return;
        }
        const difference = (debitSum || 0) - (creditSum || 0);
        if (Math.abs(difference) < 0.01) {
            withBottomDockBarLoading(handleMatch)();
        } else {
            handleCreateJournalEntries(false);
        }
    };

    // F6: one separate journal entry per selected row.
    const handlePerRowEntriesShortcut = () => {
        if (loading || bottomDockBarLoading) return;
        if (selectedDebitRows.length > 0 || selectedCreditRows.length > 0) {
            handleCreateJournalEntries(true);
        } else {
            toast.info(t('KbdSelectMultipleRows'));
        }
    };

    const isTypingTarget = (target) => {
        if (!target || !target.tagName) return false;
        const tag = target.tagName;
        return (
            tag === 'INPUT' ||
            tag === 'TEXTAREA' ||
            tag === 'SELECT' ||
            target.isContentEditable
        );
    };

    // Any open dialog disables the shortcuts (covers MUI dialogs and Swal).
    const isAnyOverlayOpen = () =>
        isCreateDialogOpen ||
        addBankTransactionDialog ||
        openImportDialog ||
        shortcutsOpen ||
        !!document.querySelector('.MuiDialog-root, .swal2-container');

    useEffect(() => {
        const handleKeyDown = (event) => {
            // Always neutralize F5/F6 on this screen so the browser never
            // refreshes mid-matching (global F-key navigation steps aside too).
            if (event.key === 'F5' || event.key === 'F6') {
                event.preventDefault();
                event.stopPropagation();
                if (fetchType !== 'NotMatched' || isAnyOverlayOpen() || isTypingTarget(event.target)) {
                    return;
                }
                if (event.key === 'F5') {
                    handleReconcileShortcut();
                } else {
                    handlePerRowEntriesShortcut();
                }
                return;
            }

            if (fetchType !== 'NotMatched') return;
            if (isAnyOverlayOpen()) return;

            // Escape inside the quick-search box clears the search and returns
            // control to keyboard navigation.
            if (event.key === 'Escape' && isTypingTarget(event.target)) {
                const panel = getPanelForTarget(event.target);
                if (panel && isQuickSearchTarget(event.target)) {
                    const { gridRef } = getPanelState(panel);
                    try {
                        gridRef.current?.setQuickFilterValues?.([]);
                    } catch (error) {
                        // Grid API unavailable; the box is still blurred below.
                    }
                }
                event.target.blur();
                return;
            }

            // While typing in a grid's quick-search box, Arrow Up/Down still
            // navigate the (filtered) rows of that grid; other keys type normally.
            if (isTypingTarget(event.target)) {
                if (
                    isQuickSearchTarget(event.target) &&
                    (event.key === 'ArrowDown' || event.key === 'ArrowUp')
                ) {
                    event.preventDefault();
                    event.stopPropagation();
                    const panel = getPanelForTarget(event.target) || activePanel;
                    if (panel !== activePanel) setActivePanel(panel);
                    moveFocus(event.key === 'ArrowDown' ? 1 : -1, event.shiftKey, panel, true);
                }
                return;
            }

            // Search ("/") and guide ("?") shortcuts, matched by the physical
            // slash key (event.code) and by the characters that key produces on
            // Hebrew ("." / "?") and Arabic ("ظ" / "؟") layouts, plus the Hebrew
            // layout's own slash on the Q key. Layout-independent this way.
            const isSlashKey = event.code === 'Slash' || event.key === '/' || event.key === 'ظ';
            const isQuestionKey = event.key === '?' || event.key === '؟';
            if (isSlashKey || isQuestionKey) {
                event.preventDefault();
                event.stopPropagation();
                if (isQuestionKey || event.shiftKey) {
                    setShortcutsOpen(true);
                } else {
                    focusPanelSearch();
                }
                return;
            }

            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    event.stopPropagation();
                    moveFocus(1, event.shiftKey);
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    event.stopPropagation();
                    moveFocus(-1, event.shiftKey);
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    event.stopPropagation();
                    switchPanel(direction === 'rtl' ? 'debit' : 'credit');
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    event.stopPropagation();
                    switchPanel(direction === 'rtl' ? 'credit' : 'debit');
                    break;
                case ' ':
                    event.preventDefault();
                    event.stopPropagation();
                    // Ignore auto-repeat while the key is held so the selection
                    // does not rapidly flicker on and off.
                    if (!event.repeat) toggleFocusedRowSelection(event.shiftKey);
                    break;
                default:
                    break;
            }
        };

        // Capture phase: runs before the grid's own key handling and before the
        // browser's default F5 refresh.
        window.addEventListener('keydown', handleKeyDown, true);
        return () => window.removeEventListener('keydown', handleKeyDown, true);
    });

    // Row click: focus the row, activate its panel, and remember the range
    // anchor. A Shift+click is stored so the selection callback expands it.
    const handlePanelCellClick = (panel) => (params, event) => {
        setActivePanel(panel);
        const { setFocusedId, setAnchorId } = getPanelState(panel);
        setFocusedId(params.id);
        if (event?.shiftKey) {
            shiftClickRef.current = { panel, rowId: params.id, ts: Date.now() };
        } else {
            shiftClickRef.current = null;
            setAnchorId(params.id);
        }
    };

    // Selection callback shared by both grids: expands a recent Shift+click
    // into a contiguous range, otherwise applies the grid's model as-is.
    const handlePanelSelectionChange = (panel) => (ids) => {
        const { anchorId, setSelected } = getPanelState(panel);
        const shiftClick = shiftClickRef.current;
        if (
            shiftClick &&
            shiftClick.panel === panel &&
            anchorId != null &&
            Date.now() - shiftClick.ts < 500
        ) {
            shiftClickRef.current = null;
            const ordered = getPanelRowIds(panel);
            if (ordered.includes(anchorId) && ordered.includes(shiftClick.rowId)) {
                selectPanelRange(panel, anchorId, shiftClick.rowId, ordered);
                return;
            }
        }
        setSelected(ids);
    };

    // Close dialog
    const handleCloseDialog = () => {
        setIsCreateDialogOpen(false);
    };





    const handleStartDateChangeNew = async (newValue) => {
        const newDate = new Date(newValue);
        if (isNaN(newDate.getTime())) return;

        // Normalize using UTC getters to avoid timezone-related month/year shifts.
        const updatedStartDate = new Date(Date.UTC(newDate.getUTCFullYear(), newDate.getUTCMonth(), 1));

        console.log('newDate', newDate);
        console.log('updatedStartDate', updatedStartDate);
        localStorage.setItem('StartDate', updatedStartDate.toISOString());
        setStartDate(updatedStartDate);
        const matchDateMode = (fetchType === 'Matched' || fetchType === 'AllMatched')
            ? isMatchDateRef.current
            : undefined;
        await FetchData(updatedStartDate, endDate, null, matchDateMode);
    };

    const handleEndDateChangeNew = async (newValue, isRange = false) => {
        const newDate = new Date(newValue);
        if (isNaN(newDate.getTime())) return;

        // `CustomYearDatePicker` returns a UTC-normalized Date; use UTC getters to avoid selecting the wrong year.
        const year = newDate.getUTCFullYear();

        console.log('newDate', newDate);
        console.log('year', year);
        
        let updatedStartDate;
        let updatedEndDate;

        if (isRange) {
            updatedStartDate = startDate;
            const month = newDate.getUTCMonth();
            const lastDay = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
            updatedEndDate = new Date(Date.UTC(year, month, lastDay, 23, 59, 59));
        } else {
            updatedStartDate = new Date(Date.UTC(year, 0, 1));
            updatedEndDate = new Date(Date.UTC(year, 11, 31, 23, 59, 59));
        }

        localStorage.setItem('StartDate', updatedStartDate.toISOString());
        localStorage.setItem('EndDate', updatedEndDate.toISOString());

        setStartDate(updatedStartDate);
        setEndDate(updatedEndDate);

        const matchDateMode = (fetchType === 'Matched' || fetchType === 'AllMatched')
            ? isMatchDateRef.current
            : undefined;
        await FetchData(updatedStartDate, updatedEndDate, null, matchDateMode);
    };


    const handleChangeCreateBank = (field, value) => {
        if (field === 'bankBranch') {
            setBankBranch(value);
        } else if (field === 'bankAccountNumber') {
            setBankAccountNumber(value);
        } else if (field === 'itemName') {
            // setItemName(value);
        }
    };


    const handleRangeChange = async (_event, checked) => {
        const newIsMatchDate = typeof checked === 'boolean' ? checked : !isMatchDateRef.current;
        isMatchDateRef.current = newIsMatchDate;
        setIsMatchDate(newIsMatchDate);
        localStorage.setItem('CardMatchingIsMatchDate', String(newIsMatchDate));
        if (fetchType === 'Matched' || fetchType === 'AllMatched') {
            await FetchData(startDate, endDate, null, newIsMatchDate);
        }
    };


    // keep the last range in a ref so re-renders don’t wipe it
    const lastRangeRef = useRef({ start: startDate, end: endDate });

    const handleRangeSet = async (next) => {
        if (!next) {
            lastRangeRef.current = { start: startDate, end: endDate };

            const year = endDate.getUTCFullYear();
            const start = new Date(Date.UTC(year, 0, 1));
            const end = new Date(Date.UTC(year, 11, 31, 23, 59, 59));

            localStorage.setItem('StartDate', start.toISOString());
            localStorage.setItem('EndDate', end.toISOString());
            setStartDate(start);
            setEndDate(end);
            await FetchData(start, end);
        } else {
            const { start, end } = lastRangeRef.current;
            localStorage.setItem('StartDate', start.toISOString());
            localStorage.setItem('EndDate', end.toISOString());
            setStartDate(start);
            setEndDate(end);
            await FetchData(start, end);
        }

        localStorage.setItem('IsRange', next.toString());
        setIsRange(next);
    };





    async function fetchMatchDataOnDateRangeChange(startDate, endDate, isMatchDate, mixThemTogether = false) {
        setLoading(true);
        const minStartDate = new Date(0);
        const effectiveStartDate = startDate ? startDate : minStartDate;
        const formattedStartDate = effectiveStartDate.toISOString();
        const formattedEndDate = endDate.toISOString();

        let sumCredit = 0;
        let sumDebit = 0;
        let balance = 0;

        try {
            const cardMatchResponse = await CardMatchService.GetMatchedByDateRange(
                client.caseId,
                formattedStartDate,
                formattedEndDate,
                selectedCardId,
                isMatchDate,
                token,
                selectedCurrency
            );


            if (cardMatchResponse.ok) {
                const externalMatchData = await cardMatchResponse.json();

                const isFc = selectedCurrency !== null && selectedCurrency !== undefined;
                // The matching amount: foreign-currency amount when a currency is selected, otherwise shekel.
                const rowAmount = (row) => isFc ? (row.foreignCurrencyAmount ?? 0) : row.amount;

                // Discover currencies present in matched data (so the selector keeps the option once filtered).
                const discovered = Array.from(new Set(
                    externalMatchData
                        .map(match => match.currency)
                        .filter(code => code !== null && code !== undefined)
                ));
                if (discovered.length > 0) {
                    setAvailableCurrencies(prev => Array.from(new Set([...prev, ...discovered])).sort((a, b) => a - b));
                }


                // Extract all credit and debit transactions. Each row also carries the match it belongs
                // to — its number, the day it was matched and its id — so a row can be read, searched
                // and undone without looking the match up again.
                const withMatch = (match) => (transaction) => ({
                    ...transaction,
                    cardMatchNumber: match.matchNumber,
                    matchDate: match.matchDate ? formatDate(match.matchDate) : '',
                    matchId: match.id,
                });
                const allCreditTransactions = externalMatchData.flatMap(match =>
                    match.creditTransactions.map(withMatch(match))
                );
                const allDebitTransactions = externalMatchData.flatMap(match =>
                    match.debitTransactions.map(withMatch(match))
                );


                // The server tells us which side of the card each row sits on. A VAT or withholding row is not
                // on the document's own accounts, so comparing the card against them would drop it.
                const isCreditRow = (row) => row.side ? row.side === 'credit' : row.creditAccount === selectedCardId;
                const isDebitRow = (row) => row.side ? row.side === 'debit' : row.debitAccount === selectedCardId;

                // Format the extracted credit and debit transactions
                const formattedCreditRows = allCreditTransactions
                    .filter(row => isCreditRow(row))
                    .map(row => ({
                        id: row.id,
                        paymentAcceptanceId: row.paymentAcceptanceId,
                        description: row.description,
                        reference: row.reference,
                        amount: beautifyNumber(rowAmount(row)),
                        amount1: rowAmount(row),
                        shekelAmount1: row.amount,
                        documentDate: row.documentDate ? formatDate(row.documentDate) : '',
                        subRows: row.subRows || [],
                        creditAccount: row.creditAccount,
                        debitAccount: row.debitAccount,
                        side: row.side,
                        sortCodeId: row.sortCodeId ?? '',
                        vat: row.vat ?? null,
                        type: row.type,
                        foreignCurrencyCode: row.foreignCurrencyCode,
                        foreignCurrencyAmount: row.foreignCurrencyAmount,
                        cardMatchNumber: row.cardMatchNumber ?? 0,
                        matchDate: row.matchDate ?? '',
                        matchId: row.matchId ?? null
                    }));

                const formattedDebitRows = allDebitTransactions
                    .filter(row => isDebitRow(row))
                    .map(row => ({
                        id: row.id,
                        paymentAcceptanceId: row.paymentAcceptanceId,
                        description: row.description,
                        reference: row.reference,
                        amount: beautifyNumber(rowAmount(row)),
                        amount1: rowAmount(row),
                        shekelAmount1: row.amount,
                        documentDate: row.documentDate ? formatDate(row.documentDate) : '',
                        subRows: row.subRows || [],
                        creditAccount: row.creditAccount,
                        debitAccount: row.debitAccount,
                        side: row.side,
                        sortCodeId: row.sortCodeId ?? '',
                        vat: row.vat ?? null,
                        type: row.type,
                        foreignCurrencyCode: row.foreignCurrencyCode,
                        foreignCurrencyAmount: row.foreignCurrencyAmount,
                        cardMatchNumber: row.cardMatchNumber ?? 0,
                        matchDate: row.matchDate ?? '',
                        matchId: row.matchId ?? null
                    }));




                setCreditMatchedRows(formattedCreditRows);
                setDebitMatchedRows(formattedDebitRows);
                setMatchData(externalMatchData);
                // Calculate sums
                sumCredit = formattedCreditRows.reduce((total, row) => total + row.amount1, 0);
                sumDebit = formattedDebitRows.reduce((total, row) => total + row.amount1, 0);
                balance = sumDebit - sumCredit;
            }

        } catch (error) {
            console.error('Error fetching match data:', error);
        }
        // Return the calculated sums
        setLoading(false);
        return { sumCredit, sumDebit, balance };
    }


    async function fetchNotMatchDataOnDateRangeChange(startDate, endDate, mixThemTogether = false) {
        setLoading(true);
        const minStartDate = new Date(0);
        const effectiveStartDate = startDate ? startDate : minStartDate;
        const formattedStartDate = effectiveStartDate.toISOString();
        const formattedEndDate = endDate.toISOString();
        let sumCredit = 0;
        let sumDebit = 0;
        let balance = 0;

        try {
            const internalResponse = await DocumentService.GetInternalByAccountCodeIdDateRangeWithCreditAndDebit(
                client.caseId, formattedStartDate, formattedEndDate, selectedCardId, token, selectedCurrency
            );

            if (internalResponse.ok) {
                const internalData = await internalResponse.json();

                // Discover the foreign currencies present in the unmatched data (independent of the filter).
                const discovered = Array.from(new Set(
                    internalData
                        .map(row => row.foreignCurrencyCode)
                        .filter(code => code !== null && code !== undefined)
                ));
                if (discovered.length > 0) {
                    setAvailableCurrencies(prev => Array.from(new Set([...prev, ...discovered])).sort((a, b) => a - b));
                }

                const isFc = selectedCurrency !== null && selectedCurrency !== undefined;

                // In FC mode "matched" is evaluated against the *Fc match number; in shekel mode the regular one.
                const isUnmatched = (row) => {
                    const matchNum = isFc ? row.cardMatchNumberFc : row.cardMatchNumber;
                    return matchNum == null || matchNum === 0 || matchNum === -1;
                };

                // In FC mode only keep rows of the selected currency.
                const currencyMatches = (row) => !isFc || row.foreignCurrencyCode === selectedCurrency;

                // The matching amount: foreign-currency amount when a currency is selected, otherwise shekel.
                const rowAmount = (row) => isFc ? (row.foreignCurrencyAmount ?? 0) : row.amount;

                // The server tells us which side of the card each row sits on. A VAT or withholding row is not
                // on the document's own accounts, so comparing the card against them would drop it.
                const isCreditRow = (row) => row.side ? row.side === 'credit' : row.creditAccount === selectedCardId;
                const isDebitRow = (row) => row.side ? row.side === 'debit' : row.debitAccount === selectedCardId;

                // Mapping internal rows - filter to unmatched only so they don't appear in both tables
                const formattedCreditRows = internalData
                    .filter(row => isCreditRow(row) && currencyMatches(row) && isUnmatched(row))
                    .map((row, index) => ({
                        id: row.id,
                        paymentAcceptanceId: row.paymentAcceptanceId,
                        description: row.description,
                        reference: row.reference,
                        amount: beautifyNumber(-1 * rowAmount(row)),
                        amount1: -1 * rowAmount(row),
                        shekelAmount1: -1 * row.amount,
                        documentDate: row.documentDate ? formatDate(row.documentDate) : '',
                        subRows: row.subRows || [],
                        creditAccount: row.creditAccount,
                        debitAccount: row.debitAccount,
                        side: row.side,
                        sortCodeId: row.sortCodeId ?? '',
                        vat: row.vat ?? null,
                        type: row.type,
                        foreignCurrencyCode: row.foreignCurrencyCode,
                        foreignCurrencyAmount: row.foreignCurrencyAmount,
                        cardMatchNumber: row.cardMatchNumber ?? 0,
                        cardMatchNumberFc: row.cardMatchNumberFc ?? 0,
                        groupId: row.groupId ?? null
                    }));


                const formattedDebitRows = internalData
                    .filter(row => isDebitRow(row) && currencyMatches(row) && isUnmatched(row))
                    .map(row => ({
                        id: row.id,
                        paymentAcceptanceId: row.paymentAcceptanceId,
                        description: row.description,
                        reference: row.reference,
                        amount: beautifyNumber(rowAmount(row)),
                        amount1: rowAmount(row),
                        shekelAmount1: row.amount,
                        documentDate: row.documentDate ? formatDate(row.documentDate) : '',
                        subRows: row.subRows || [],
                        creditAccount: row.creditAccount,
                        debitAccount: row.debitAccount,
                        side: row.side,
                        sortCodeId: row.sortCodeId ?? '',
                        vat: row.vat ?? null,
                        type: row.type,
                        foreignCurrencyCode: row.foreignCurrencyCode,
                        foreignCurrencyAmount: row.foreignCurrencyAmount,
                        cardMatchNumber: row.cardMatchNumber ?? 0,
                        cardMatchNumberFc: row.cardMatchNumberFc ?? 0,
                        groupId: row.groupId ?? null
                    }));





                setCreditRows(formattedCreditRows);
                setDebitRows(formattedDebitRows);
                setSortedTransactions([...formattedCreditRows, ...formattedDebitRows]);
                sumCredit = formattedCreditRows.reduce((total, row) => total + row.amount1, 0);
                sumDebit = formattedDebitRows.reduce((total, row) => total + row.amount1, 0);
                balance = sumDebit - sumCredit;

            }
        } catch (error) {
            console.error("Error fetching data: ", error);
        }
        setLoading(false);
        return { sumCredit, sumDebit, balance };
    }

    const handleChangeBankForCreate = (value) => {
        setSelectedBankForCreate(value);

    };

    const handleOpenCreateModal = () => {
        setCreateBankModal(true);
    };

    const handleCloseCreateModal = () => {
        setCreateBankModal(false);
        setSelectedBankForCreate(null);
        setBankBranch('');
        setBankAccountNumber('');
        setIsEditingBank(false);
        setCardForNewBank('');
    };

    const handleRemoveBank = async () => {
        try {

            const response = await EnumsService.DeleteTBank(client.caseId, bankAccountNumber, selectedBankForCreate.value, token);
            if (response.ok) {
                toast.success(t('BankDeletedSuccessfully'));
                fetchEnums(user, token, client);
                handleCloseCreateModal();
            } else {
                toast.error(t('FailedToAddBankAccount'));
            }
        } catch (error) {
            console.error('BankFailedToDelete');
        }
    };

    const handleAddBank = async () => {
        try {
            const bankName = Constants.BankNames[parseInt(selectedBankForCreate.value)];
            const bankCode = selectedBankForCreate.value;

            if (!selectedBankForCreate || !bankBranch || !bankAccountNumber) {
                toast.error(t('PleaseFillAllFields'));
                return;
            }

            const response = await EnumsService.AddTBank(
                client.caseId,
                bankName,
                bankCode,
                bankBranch,
                bankAccountNumber,
                cardForNewBank.cardId,
                token
            );
            if (response.ok) {
                toast.success(t('BankAccountAddedSuccessfully'));
                fetchEnums(user, token, client);
                handleCloseCreateModal();
            } else {
                toast.error(t('FailedToAddBankAccount'));
            }
        } catch (error) {
            console.error(error);
            toast.error(t('ErrorAddingBankAccount'));
        }
    };
    const [oldBank, setOldBank] = useState(null);

    const handleEditBank = async () => {
        try {

            const bankName = Constants.BankNames[parseInt(selectedBankForCreate.value)];
            const bankCode = selectedBankForCreate.value;

            if (!selectedBankForCreate || !bankBranch || !bankAccountNumber) {
                toast.error(t('PleaseFillAllFields'));
                return;
            }

            if (!oldBank) {
                toast.error(t('OldBankDataNotFound'));
                return;
            }

            const response = await EnumsService.EditTBank(
                client.caseId,                // Use the CaseId from the edited bank
                oldBank.bankCode,             // Old bank code
                oldBank.accountNumber,        // Old account number
                bankName,                     // New bank name
                bankCode,                     // New bank code
                bankBranch,                   // New branch number
                bankAccountNumber,            // New account number
                cardForNewBank.cardId,
                token                         // Authorization token
            );

            if (response.ok) {
                toast.success(t('BankAccountUpdatedSuccessfully'));
                fetchEnums(user, token, client);  // Fetch updated data
                handleCloseCreateModal();         // Close the modal
            } else {
                toast.error(t('FailedToUpdateBankAccount'));
            }
        } catch (error) {
            console.error(error);
            toast.error(t('ErrorUpdatingBankAccount'));
        }
    };


    const handleAddOrEditBank = () => {
        if (isEditingBank && editedBank) {
            handleEditBank()

        } else {
            handleAddBank();
        }
        handleCloseCreateModal(); // Close the modal after adding/editing
    };

    const handleConfirm = async () => {
        if (createJournalEntries === true) {
            // Case when the checkbox is checked (Create Journal Entries for each transaction)
            const selectedDebitRowsData = selectedRowsOf(debitDisplayedRows, selectedDebitRows)
                .map(row => ({ ...row, isDebitRow: true }));

            const selectedCreditRowsData = selectedRowsOf(creditDisplayedRows, selectedCreditRows)
                .map(row => ({ ...row, isDebitRow: false }));

            const selectedRows = [...selectedDebitRowsData, ...selectedCreditRowsData];

            const isFc = selectedCurrency !== null && selectedCurrency !== undefined;

            const journalEntries = selectedRows.map(row => {
                const amount = parseFloat(row.amount1);
                const isNegative = amount < 0;
                // The journal entry's primary amount is always in shekels; the FC amount is stored alongside.
                const hasShekelAmount = row.shekelAmount1 != null && row.shekelAmount1 !== '';
                const shekelAmount = parseFloat(hasShekelAmount ? row.shekelAmount1 : row.amount1);
                const rowFcAmount = row.foreignCurrencyAmount;
                // Only a row that carries its own shekel value gives a real rate; otherwise
                // shekelAmount is just the foreign amount and would yield a bogus rate of 1.
                const rowRate = isFc && hasShekelAmount
                    ? resolveManualRate(shekelAmount, rowFcAmount)
                    : null;

                const documentDate = new Date(parseCustomDate(row.documentDate)).toISOString().split('T')[0];
                const description = row.description;
                const reference = row.reference || '';

                let creditAccount, debitAccount;

                if (row.isDebitRow) {
                    // For debit rows
                    debitAccount = isNegative ? selectedCardId : formValues.accountCard;
                    creditAccount = isNegative ? formValues.accountCard : selectedCardId;
                } else {
                    // For credit rows
                    debitAccount = isNegative ? formValues.accountCard : selectedCardId;
                    creditAccount = isNegative ? selectedCardId : formValues.accountCard;
                }



                const perRowMonthSource = usePerRowReportingMonth
                    ? parseCustomDate(row.documentDate)
                    : null;

                return {
                    amount: parseFloat(Math.abs(shekelAmount).toFixed(2)),
                    foreignCurrencyCode: isFc ? selectedCurrency : null,
                    foreignCurrencyAmount: isFc && rowFcAmount != null ? parseFloat(Math.abs(rowFcAmount).toFixed(2)) : null,
                    exchangeRate: rowRate,
                    exchangeRateType: rowRate != null ? Constants.ExchangeRateType.Manual : null,
                    creditAccount,
                    debitAccount,
                    description,
                    reference,
                    documentDate: documentDate,
                    reportingMonthDate: (() => {
                        // When createJournalEntries is true, the month picker updates reportingMonthDate state (not formValues)
                        const source = perRowMonthSource
                            || (createJournalEntries === true
                                ? (journalReportingMonthDate || formValues.reportingMonthDate)
                                : (formValues.reportingMonthDate || journalReportingMonthDate));
                        return formatReportingMonthDateOnly(source);
                    })(),
                    registrationMonthDate: (() => {
                        const source = perRowMonthSource
                            || (createJournalEntries === true
                                ? (journalRegistrationMonthDate || formValues.registrationMonthDate)
                                : (formValues.registrationMonthDate || journalRegistrationMonthDate));
                        return formatReportingMonthDateOnly(source);
                    })(),
                    sortCodeId: formValues.sortCode || null,
                    vat: getVatBySortCode(formValues.sortCode, sortCodeIdOptions),
                };
            });

            // Show the journal entries as a card list
            setJournalEntriesList(journalEntries);
            setIsJournalEntriesListOpen(true);

            // Close the initial dialog
            setIsCreateDialogOpen(false);
        } else {
            // When the checkbox is not checked (Create a single Journal Entry)
            setIsCreateDialogOpen(false);
            await handleCreateJournalEntry();
        }
    };


    // const handleCreateJournalEntry = async () => {
    //     setLoading(true);
    //     // Prepare JSON payload
    //     const payload = {
    //         caseId: client.caseId,
    //         accountantId: client.accountantId,
    //         sortCodeId: formValues.sortCodeId,
    //         reference: formValues.reference,
    //         description: formValues.description,
    //         amount: Math.abs(formValues.amount),
    //         documentDate: new Date(formValues.documentDate).toISOString(),
    //         reportingMonthDate: new Date(formValues.reportingMonthDate).toISOString(),
    //         creditAccount: formValues.creditAccount,
    //         debitAccount: formValues.debitAccount,
    //         vat: 100,
    //     };

    //     try {
    //         const response = await DocumentService.UploadDocumentPayload("JournalEntries", payload, token);


    //         if (response.ok) {
    //             setShouldMatch(true);
    //             const data = await response.json(); // Parse the response as JSON
    //             const newJournalEntryId = data.journalEntryId; // Extract the ID from the response



    //             // Set the state for selectedInternalRows
    //             setSelectedCreditRows(prevRows => {
    //                 const updatedRows = [...prevRows, newJournalEntryId];
    //                 // After setting the state, trigger further actions
    //                 afterStateUpdate(updatedRows); // Trigger next steps
    //                 return updatedRows;
    //             });

    //             const response2 = await ClientDocumentCountService.removeDocumentByTypeAndId(client.caseId, client.accountantId, 'JournalEntries', data.journalEntryId, token);
    //             toast.success(t('documentUploadSuccess'));
    //         } else {
    //             const errorText = await response.text();
    //             toast.error(t('documentUploadError', { errorText }));
    //             return false;
    //         }
    //     } catch (error) {
    //         toast.error(t('documentUploadError', { errorText: 'Error uploading document' }));
    //         return false;
    //     }
    // };

    const returnProperVatBySortId = (mySortCodeId) => {
        let newVat = 100;

        const name = sortCodeIdOptions.find(
            (option) => option.value === mySortCodeId
        )?.label || '';
        // Extract the name without the parentheses

        const nameWithoutParentheses = name.replace(/\s*\(.*?\)\s*/, '').trim();
        // Check for a number within parentheses
        const match = name.match(/\((\d+)%?/);
        const customVat = match ? parseInt(match[1], 10) : null;

        const sortCode = sortCodeIdOptions.find(sc => sc.sortCodeId === mySortCodeId);
        // Determine the VAT based on the name without parentheses
        if (Constants.SortCodesWith66Vat.includes(nameWithoutParentheses)) {
            newVat = Constants.Vat66;
        } else if (Constants.SortCodesWithZeroVat.includes(nameWithoutParentheses) || sortCode?.sortCodeVatType === 0) {
            newVat = 0;
        } else if (Constants.SortCodesWith16Vat.includes(nameWithoutParentheses)) {
            newVat = 16;
        } else if (customVat !== null) {
            // If a custom VAT was found, use it
            newVat = customVat === Constants.Vat66 ? Constants.Vat66 : customVat;
        } else {
            // Default VAT if no special conditions are met
            newVat = 100;
        }


        return newVat; // Return the determined VAT
    };

    const handleCreateJournalEntry = async () => {
        setLoading(true);
        // Prepare JSON payload

        const isFc = selectedCurrency !== null && selectedCurrency !== undefined;
        const fcAmount = parseFloat(formValues.foreignCurrencyAmount);
        const manualRate = isFc && !isNaN(fcAmount)
            ? resolveManualRate(formValues.amount, fcAmount)
            : null;

        const payload = {
            caseId: client.caseId,
            accountantId: client.accountantId,
            sortCodeId: formValues.sortCodeId,
            reference: formValues.reference,
            description: formValues.description,
            amount: parseFloat(Math.abs(formValues.amount).toFixed(2)),
            documentDate: new Date(formValues.documentDate).toISOString(),
            reportingMonthDate: reportingMonthToISOString(formValues.reportingMonthDate),
            registrationMonthDate: reportingMonthToISOString(formValues.registrationMonthDate || formValues.reportingMonthDate),
            creditAccount: formValues.creditAccount,
            debitAccount: formValues.debitAccount,
            vat: returnProperVatBySortId(formValues.sortCodeId),
            // When a currency is selected, persist the foreign-currency amount + code alongside the shekel amount.
            foreignCurrencyCode: isFc ? selectedCurrency : null,
            foreignCurrencyAmount: isFc && !isNaN(fcAmount) ? parseFloat(Math.abs(fcAmount).toFixed(2)) : null,
            // The rate is stored as a manual snapshot so the shekel amount the user matched
            // survives the save untouched by the representative rate of the day.
            exchangeRate: manualRate,
            exchangeRateType: manualRate != null ? Constants.ExchangeRateType.Manual : null,
            IsMadeFromCardMatch: true,
            addAsProcessed: true,
            isLocked: true
        };
        try {
            const response = await DocumentService.UploadDocumentPayload("JournalEntries", payload, token);

            if (response.ok) {

                const data = await response.json(); // Parse the response as JSON
                const newJournalEntryId = data.journalEntryId; // Extract the ID from the response

                let updatedSelectedDebitRows = [...selectedDebitRows];
                let updatedSelectedCreditRows = [...selectedCreditRows];


                if (journalEntryMatchSide(formValues) === 'credit') {
                    updatedSelectedCreditRows = [...updatedSelectedCreditRows, newJournalEntryId];
                    setSelectedCreditRows(updatedSelectedCreditRows);
                } else {
                    updatedSelectedDebitRows = [...updatedSelectedDebitRows, newJournalEntryId];
                    setSelectedDebitRows(updatedSelectedDebitRows);
                }

                // Proceed to match the selected transactions with the new journal entry
                await handleMatch(updatedSelectedDebitRows, updatedSelectedCreditRows);

                // // Optionally remove the document count if needed
                // await ClientDocumentCountService.removeDocumentByTypeAndId(
                //     client.caseId,
                //     client.accountantId,
                //     'JournalEntries',
                //     data.journalEntryId,
                //     token
                // );

                toast.success(t('documentUploadSuccess'));
            } else {
                const errorText = await response.text();
                toast.error(t('documentUploadError', { errorText }));
                return false;
            }
        } catch (error) {
            console.error('Error uploading document:', error);
            toast.error(t('documentUploadError', { errorText: 'Error uploading document' }));
            return false;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (shouldMatch && displayedRows.length > 0) {
            handleMatch(selectedCreditRows); // Pass updated internal rows
            setShouldMatch(false); // Reset the flag after calling handleMatch
        }
    }, [displayedRows]);



    const [denseTableCreditDebitRows, setDenseTableCreditDebitRows] = useState([]);

    // The card's figures for the header bar. They arrive already formatted, so the balance is
    // parsed back to a number only to tell a settled card from one that still has a difference.
    const cardTotals = useMemo(() => {
        const row = denseTableCreditDebitRows?.[0] || {};
        const amount = Number(String(row.Difference ?? '').replace(/[^\d.-]/g, ''));
        return {
            debit: row.TotalDebitAccount,
            credit: row.TotalCreditAccount,
            balance: row.Difference,
            settled: Number.isFinite(amount) && Math.abs(amount) < 0.01,
        };
    }, [denseTableCreditDebitRows]);

    const afterStateUpdate = async (updatedRows) => {

        setFormValues({
            confirmationNumber: '',
            accountCaseId: '',
            reference: '',
            description: '',
            documentDate: '',
            reportingMonthDate: '',
            registrationMonthDate: '',
            amount: '',
            foreignCurrencyAmount: '',
            vat: '',
            sortCodeId: '3',
            creditAccount: '',
            debitAccount: '',
            sortCode: '3',
            accountCard: ''
        });

        // Fetch the data and wait for it to complete
        await FetchData();

        setLoading(false);
    };
    const selectedDenseTableRow = async (index) => {
        setSelectedTBank(tBanksData[index]);
        setSelectedTBankIndex(index);
        setSelectedCardId(tBanksData[index].cardId);


        const cardIndexForAdv = processedCardsData.findIndex(item => item.cardId === tBanksData[index].cardId);

        if (cardIndexForAdv !== -1) { // If cardId is found
            const updatedMainCard = { ...processedCardsData[cardIndexForAdv], index: cardIndexForAdv }; // Add the index to mainCard
            setMainCard(updatedMainCard);  // Set the updated mainCard with the index
            setSelectedFormattedAccountCard(processedCardsData[cardIndexForAdv])
        } else {
            // setMainCard(-1); 
            // toast.info(t('NonBankAccountCardSelected'));
        }

    };
    const [userFromAccountCardDashboard, setUserFromAccountCardDashboard] = useState(null);

    const handleFormattedAccountCardChange = (event, newValue) => {


        if (!newValue) {
            return
        }
        setMainCard(newValue?.cardId);
        setSelectedFormattedAccountCard(newValue);
    };


    useEffect(() => {
        if (userFromAccountCardDashboard && processedCardsData) {
            setMainCard(userFromAccountCardDashboard);
            const matchingCard = processedCardsData.find(
                (pd) => pd.cardId === userFromAccountCardDashboard
            );
            setSelectedFormattedAccountCard(matchingCard || null);
        }
    }, [userFromAccountCardDashboard, processedCardsData]);


    const [isEditingBank, setIsEditingBank] = useState(false);
    const [editedBank, setEditedBank] = useState(false);
    const [selectedBankAccount, setSelectedBankAccount] = useState(null);

    const EditAccountCard = (selectedItem, type) => {

        if (!selectedItem) {
            console.warn("No account card selected for editing.");
            return;
        }


        setPalCode(selectedItem.palCode);
        setNewAccountCard({ accountCodeName: selectedItem.name || '', accountCodeId: selectedItem.cardId, accountCaseId: selectedItem.accountCaseId || '' })
        setIsEditAccountCard(true);
        setEditedAddAccountCard(true);
        setAddAccountCardType(type);
    };


    const handleNoOptionCreditDebitClick = (searchTerm, type) => {
        const newOption = {
            ...formattedAccountCardOptions[0],
            searchTerm: searchTerm
        };
        handleCreditAccountCardForNewCommands(newOption, type)
    };

    const handleCreditAccountCardForNewCommands = (card, type) => {

        if (!card) {
            return;
        }

        if (card.value1 === 'AddItem') {
            setEditedAddAccountCard(true);
            setAddAccountCardType(type);
            setIsEditAccountCard(false);
            setNewAccountCard({ accountCodeName: card.searchTerm || '', accountCodeId: cardIdOption })
        }
    };

    useEffect(() => {
        if (accountCardOptions && accountCardOptions.length > 0 && newCardId) {
            const selectedOption = accountCardOptions.find(option => option.cardId === newCardId.cardId);
            if (newCardId) {
                handleSelectChange(
                    newCardId.type,
                    selectedOption
                )
                setNewCardId(null);
            }
        }
    }, [accountCardOptions, newCardId]);


    const handleChangeAfterAdd = (cardId, type) => {
        ///set type
        const newCard = {
            cardId,
            type
        }
        setNewCardId(newCard);
    }
    // When the user changes the selected currency, re-fetch so the tables reflect the new scope.
    // A ref lets us suppress the fetch when the change originates from an automatic reset (e.g. card change).
    const skipCurrencyFetchRef = useRef(true);
    useEffect(() => {
        if (skipCurrencyFetchRef.current) {
            skipCurrencyFetchRef.current = false;
            return;
        }
        if (selectedCardId && client) {
            FetchData();
        }
    }, [selectedCurrency]);

    // The discovered foreign-currency list belongs to the selected card, not to the active filter.
    // Filtering by a specific currency (or shekel) makes the backend return only that currency's
    // rows, so we keep the accumulated list and only clear it when the card itself changes.
    useEffect(() => {
        setAvailableCurrencies([]);
    }, [selectedCardId]);

    useEffect(() => {
        if (selectedCardId && client && !isManualFetch.current && !isViewSwitching.current) {
            // Reset currency filter for the newly-selected card without triggering an extra fetch.
            if (selectedCurrency !== null) {
                skipCurrencyFetchRef.current = true;
                setSelectedCurrency(null);
            }
            FetchData();
        }
    }, [selectedCardId]);

    const FetchData = async (start = startDate, end = endDate, overrideFetchType = null, overrideIsMatchDate = undefined) => {

        const currentFetchType = overrideFetchType || fetchType;
        const matchDateFilter = overrideIsMatchDate !== undefined ? overrideIsMatchDate : isMatchDateRef.current;

        // Clear all row states at the beginning to prevent data mixing
        setCreditRows([]);
        setDebitRows([]);
        setCreditMatchedRows([]);
        setDebitMatchedRows([]);
        setMatchData([]);
        setSelectedDebitRows([]);
        setSelectedCreditRows([]);
        setMatchedPairs([]);
        setShowingMatches(false);
        setExpandedMatchedRows({});
        setExpandedCreditRows({});
        setSortModel([]);
        // Note: availableCurrencies is intentionally NOT reset here. Each fetch function only unions
        // in the currencies it discovers, so the list grows as currencies are encountered and is
        // cleared only when the selected card changes (see the [selectedCardId] effect). This keeps a
        // foreign currency selectable even after switching back to shekel, where the filtered backend
        // result would otherwise contain no foreign-currency rows to rediscover.

        try {

            let totalSumCredit = 0;
            let totalSumDebit = 0;
            let totalBalance = 0;
            if (currentFetchType === 'Matched') {
                setShowingMatches(true);
                const { sumCredit, sumDebit, balance } = await fetchMatchDataOnDateRangeChange(start, end, matchDateFilter);
                totalSumCredit = sumCredit;
                totalSumDebit = sumDebit;
                totalBalance = balance;
            }
            if (currentFetchType === 'AllMatched') {
                setShowingMatches(true);
                // Fetch match data and get sums
                const matchSums = await fetchMatchDataOnDateRangeChange(start, end, matchDateFilter, true);

                // Fetch not matched data and get sums
                const notMatchSums = await fetchNotMatchDataOnDateRangeChange(start, end, true);

                // Combine the sums
                totalSumCredit = matchSums.sumCredit + notMatchSums.sumCredit;
                totalSumDebit = matchSums.sumDebit + notMatchSums.sumDebit;
                totalBalance = totalSumCredit - totalSumDebit;
            }
            if (currentFetchType === 'NotMatched') {
                setShowingMatches(false);
                const { sumCredit, sumDebit, balance } = await fetchNotMatchDataOnDateRangeChange(start, end);
                totalSumCredit = sumCredit;
                totalSumDebit = sumDebit;
                totalBalance = balance;
            }

            setDenseTableCreditDebitRows([{
                TotalDebitAccount: beautifyNumber(totalSumDebit),
                TotalCreditAccount: beautifyNumber(totalSumCredit),
                Difference: beautifyNumber(totalBalance),
            }]);

        } catch (error) {
            console.error("Error in FetchData:", error);
        }
    };

    useEffect(() => {
        // Extract cardId from mainCard if it's an object, otherwise use it directly
        const cardId = typeof mainCard === 'object' && mainCard !== null
            ? (mainCard.cardId || mainCard.accountCardId)
            : mainCard;
        
        setSelectedCardId(cardId);
        const cardIndex = tBanksData.findIndex(item => item.cardId === cardId);
        if (cardIndex !== -1) {
            setSelectedTBankIndex(cardIndex);
        } else {
            setSelectedTBankIndex(-1);
            // toast.info(t('NonBankAccountCardSelected'));
        }
    }, [mainCard, tBanksData]);



    // Calculate the sum of amounts from selected rows. A summary row already carries the group
    // total, so its children are skipped to keep the group counted once.
    const calculateSum = (rows, selectedIds, key = 'amount1') => {
        return rows
            .filter(row => !row._summaryChild && selectedIds.includes(row.id))
            .reduce((sum, row) => sum + (row[key] || 0), 0);
    };

    // Effect to update sums when row selection changes
    useEffect(() => {
        const externalSumValue = calculateSum(debitDisplayedRows, selectedDebitRows);
        const internalSumValue = calculateSum(displayedRows, selectedCreditRows);
        setDebitSum(externalSumValue);
        setCreditSum(internalSumValue);
        // Shekel totals stay available even while a foreign currency is active,
        // so the journal-entry dialog can show both the shekel and FC amounts.
        setDebitShekelSum(calculateSum(debitDisplayedRows, selectedDebitRows, 'shekelAmount1'));
        setCreditShekelSum(calculateSum(displayedRows, selectedCreditRows, 'shekelAmount1'));
    }, [selectedDebitRows, selectedCreditRows]);



    const [documentCount, setDocumentCount] = useState(null);


    const [assets, setAssets] = useState([]);

    const [showAddGroupModal, setShowAddGroupModal] = useState(false);
    const [assetGroups, setAssetGroups] = useState([]);

    const handleOpenGroudAdd = () => {
        setShowAddGroupModal(true);
    }


    const fetchEnums = async (user, token, client) => {
        setLoading(true);
        try {
            const tBanks = await EnumsService.GetAllTBanksByCaseId(client.caseId, token);
            const accountCardsResponse = await EnumsService.GetAccountCardsByCaseId(client.caseId, token);
            const accountCardsData = await accountCardsResponse.json();
            const documentCounts = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);

            setDocumentCount(documentCounts);

            const assetGroupResponse = await AssetService.GetAllAssetGroups(client?.caseId, token);
            if (assetGroupResponse.success) {
                setAssetGroups(assetGroupResponse.data);
            } else {
                toast.error(t('FailedToFetchAssets'));
            }


            const tBanksRows = tBanks.map(bank => [
                bank.bankCode || "-",
                bank.bankName || "-",
                bank.branchNumber || "-",
                bank.accountNumber || "-",
                bank.cardId || "-"
            ]);

            //processed account cards data
            if (accountCardsData && accountCardsData.length > 0) {
                const transformedData = accountCardsData.map(card => ({
                    ...card,
                    value: card.cardId, // Set value to cardId
                    label: `${card.name} - ${card.cardId}`,   // Set label to name
                }));

                const combinedData = [{ name: t('AddAccountCard'), value: 'AddItem' }, ...transformedData];
                setProcessedCardsData(combinedData);
            }


            setDenseTableRows(tBanksRows);
            setTBanksData(tBanks);
            setAccountCardsData(accountCardsData);

            // Fetching sortCodeIdOptions
            const codeIdResponse = await EnumsService.GetSortCodesByAccountantId(client.accountantId, token);
            if (codeIdResponse.ok) {
                const codeIdData = await codeIdResponse.json();

                const sortCodeOptions = codeIdData.map((sortCode) => ({
                    ...sortCode,
                    label: `${sortCode.sortCodeId} - ${sortCode.sortCodeName}`,
                    value: sortCode.sortCodeId, // Use cardId as the value
                }));
                setSortCodeIdOptionsForEditModals(codeIdData);
                setSortCodeIdOptions(sortCodeOptions); // Assuming codeIdData is already in the correct format
            }


            // Fetching creditAccountOptions and debitAccountOptions
            const accountsResponse = await EnumsService.GetAccountCardsByCaseId(client.caseId, token);
            if (accountsResponse.ok) {
                const accountsData = await accountsResponse.json();
                setOriginalDebitAccountOptions(accountsData)

                // Map accountsData to extract name and cardId
                const accountOptions = accountsData.map((account) => ({
                    label: `${account.cardId} - ${account.name}`,
                    value: account.cardId, // Use cardId as the value
                }));



                setCreditAccountOptions(accountOptions);
                setDebitAccountOptions(accountOptions); // Assuming both options are the same
                setAccountCardEditDownloadOptions(accountOptions);

                const accountCardOptionsEdit = [{ name: t('AddAccountCard'), value1: 'AddItem' }, ...accountsData];
                setEditModalsAccountCardOptions(accountCardOptionsEdit);

                setAccountCardOptions(accountCardOptionsEdit);
            }
            const palCodesResponse = await EnumsService.GetPalCodesByAccountantId(client.accountantId, token)
            // Process palCodes if response is okay
            if (palCodesResponse.ok) {
                const palCodesData = await palCodesResponse.json();
                const formattedPalCodes = palCodesData.map(palCode => ({
                    label: palCode.palCodeId,
                    value: palCode.palCodeId,
                    // The report's card picker orders and groups pal codes by these.
                    palCodeType: palCode.palCodeType,
                    orderNumber: palCode.orderNumber
                }));


                setFormattedPalCodeOptions(formattedPalCodes);
            }

            const assetResponse = await AssetService.GetAllAssets(client?.caseId, token);
            if (assetResponse.success) {
                setAssets(assetResponse.data);
            } else {
                toast.error(t('FailedToFetchAssets'));
            }

            setIsClientDataFetched(true);

        } catch (error) {
            console.error(error);
            toast.error(t('fetchEnumsError'), error);
            setIsClientDataFetched(false)
        }
        setLoading(false);

    };

    const handleDeleteExternalRows = async () => {

        try {

            // Summary rows carry a synthetic id, so delete the real rows behind the selection.
            const idsToDelete = expandSelectedIds(selectedDebitRows, debitDisplayedRows).map(({ id }) => id);
            const response = await ExternalTransactionsService.DeleteMultipleExternalTransactions(client.caseId, idsToDelete, token);

            if (response.ok) {
                toast.info(t('BankTransactionsDeletedSuccessfully'));
                await FetchData();
            } else {
                const errorMessage = await response.text();
                console.error('Failed to delete external transactions:', errorMessage);
                toast.error(t('FailedToDeleteBankTransactions'));
            }
        } catch (error) {
            toast.error(t('FailedToDeleteBankTransactions'));
        }
    };

    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const currentUser = await UserService.getCurrentUser();
                const currentToken = await UserService.getCurrentToken();
                if (currentUser && currentToken) {
                    setUser(currentUser);
                    setToken(currentToken);

                    // Get client data from location.state
                    if (location.state && location.state.client && location.state.type) {
                        setType(location.state.type)
                        setClient(location.state.client);
                    }
                    if (location.state.card) {
                        // location.state.card can be a cardId (string/number) or card object
                        const cardId = typeof location.state.card === 'object' && location.state.card !== null
                            ? (location.state.card.cardId || location.state.card.accountCardId)
                            : location.state.card;
                        setUserFromAccountCardDashboard(cardId);
                    }
                    await fetchEnums(currentUser, currentToken, location.state.client);
                    // Fetch financial data for the current date on initial load only
                }
                else {
                    navigate("/login");
                }


            } catch (error) {
                // Handle error - maybe navigate to login or show a message
            }
            setLoading(false);
        };
        fetchUserData();
    }, []);


    const formatDate = dateString => {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };


    const filteredAndSortedData = useMemo(() => {

        if (accountCardsData.length <= 0) {
            return [];
        }

        const query = searchQuery.toLowerCase();
        // Apply filtering and scoring
        if (accountCardsData.length <= 0) {
            return [];
        }
        const scoredData = accountCardsData
            .filter((item) => {
                // Basic filtering to remove irrelevant items
                return (
                    (item?.cardId?.toString()?.includes(query)) ||
                    (item?.caseId?.toString()?.includes(query)) ||
                    (item?.accountCaseId?.toString()?.includes(query)) ||
                    (item?.name?.toLowerCase()?.includes(query)) ||
                    (item?.palCode?.toLowerCase()?.includes(query)) ||
                    (item?.client?.toString()?.includes(query)) ||
                    (item?.phoneNumber?.toString()?.includes(query)) ||
                    (item?.location?.toLowerCase()?.includes(query)) ||
                    (item?.email?.toLowerCase()?.includes(query)) ||
                    (item?.sourceDeductionAssociation?.toString()?.includes(query))
                );
            })
            .map((item) => {
                // Calculate a relevance score based on the match
                let score = 0;

                if (item?.cardId?.toString() === query) score += 10; // Exact match on cardId
                else if (item?.cardId?.toString()?.includes(query)) score += 5; // Partial match

                if (item?.caseId?.toString() === query) score += 10; // Exact match on caseId
                else if (item?.caseId?.toString()?.includes(query)) score += 5;

                if (item?.accountCaseId?.toString() === query) score += 10;
                else if (item?.accountCaseId?.toString()?.includes(query)) score += 5;

                if (item?.name?.toLowerCase() === query) score += 15; // Give more weight to name exact match
                else if (item?.name?.toLowerCase()?.includes(query)) score += 7;

                if (item?.palCode?.toLowerCase() === query) score += 10;
                else if (item?.palCode?.toLowerCase()?.includes(query)) score += 5;

                if (item?.client?.toString() === query) score += 10;
                else if (item?.client?.toString()?.includes(query)) score += 5;

                if (item?.phoneNumber?.toString() === query) score += 10;
                else if (item?.phoneNumber?.toString()?.includes(query)) score += 5;

                if (item?.location?.toLowerCase() === query) score += 8;
                else if (item?.location?.toLowerCase()?.includes(query)) score += 4;

                if (item?.email?.toLowerCase() === query) score += 10;
                else if (item?.email?.toLowerCase()?.includes(query)) score += 5;

                if (item?.sourceDeductionAssociation?.toString() === query) score += 10;
                else if (item?.sourceDeductionAssociation?.toString()?.includes(query)) score += 5;

                // Return item along with its score
                return { ...item, score };
            });

        // Sort by relevance score (descending)
        const sortedData = scoredData.sort((a, b) => b.score - a.score);

        // Apply any additional sorting based on sortConfig
        if (sortConfig.key) {
            sortedData.sort((a, b) => {
                const aValue = a[sortConfig.key] || ""; // Default to empty string if null or undefined
                const bValue = b[sortConfig.key] || ""; // Default to empty string if null or undefined

                if (sortConfig.type === 'number') {
                    return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
                } else if (sortConfig.type === 'date') {
                    return sortConfig.direction === 'ascending' ? new Date(aValue) - new Date(bValue) : new Date(bValue) - new Date(aValue);
                } else { // default to string comparison
                    return sortConfig.direction === 'ascending' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
                }
            });
        }


        return sortedData;
    }, [accountCardsData, searchQuery, sortConfig]);






    const handleSortChange = (key, type, Direction = '') => {
        let direction = Direction || 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }

        setSortConfig({ key, direction, type });
    };

    // // table functions
    // const headerStyle = {
    //     backgroundColor: '#f7f7f7',
    //     color: 'black',
    //     fontWeight: 'bold'
    // }


    useEffect(() => {
        // Calculate the width as 70% of the container width minus 20px
        const containerWidth = document.querySelector('.table-container').offsetWidth;
        const newWidth = (containerWidth * 0.7) - 20;
        setCalculatedWidth(newWidth + 'px');
    }, []);

    const { hasBack, handleBack } = useBack();


    const handleGoBack = () => {
        // Navigate back to the previous page using React Router
        if (client) {
            goBack();
        }

    };

    const rowStyle = {
        padding: '6px',
        fontSize: '12px',
    };

    const headerStyle = {
        backgroundColor: '#ebebeb',
        padding: '8px',
        fontSize: '12px',
    };

    const [itemEditing, setItemEditing] = useState(true);
    const [addNewAccountCardDocument, setAddNewAccountCardDocument] = useState(false);
    const [companyId, setCompanyId] = useState('');
    const [accountCodeName, setAccountCodeName] = useState('');
    const [accountCodeId, setAccountCodeId] = useState('');

    const [modalVisible, setModalVisible] = useState(false);
    const [addNewAccountCard, setAddNewAccountCard] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const isClosedReportingMonthAndIsRange = !isRange ? isClosedReportingMonth : addEditableItem.isClosedReportingMonth;
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [paymentAcceptanceItems, setPaymentAcceptanceItems] = useState([]);
    const [invoiceClientCaseId, setInvoiceClientCaseId] = useState('');
    const [accountType, setAccountType] = useState(null);
    const [description, setDescription] = useState('');
    const [showAccountCardInputsEdit, setShowAccountCardInputsEdit] = useState(false);
    const [acceptedWithholdingTax, setAcceptedWithholdingTax] = useState(0);
    const [palCode, setPalCode] = useState('');
    const [paymentWithholdingTax, setPaymentWithholdingTax] = useState(0);
    const [newItem, setNewItem] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);
    const [actionType, setActionType] = useState('delete');
    const [accountCardIdToDelete, setAccountCardIdToDelete] = useState('');
    const [paymentBeingEdited, setPaymentBeingEdited] = useState(true);

    const checkIfExistingAccountCard = (accountCardOptions, cardId, accountCaseId, edit = false) => {

        const existingAccountCard = accountCardOptions.filter(card =>
            (card.accountCaseId === accountCaseId && accountCaseId) ||
            (card.cardId === cardId && cardId)
        );


        const isExist = existingAccountCard && (edit
            ? existingAccountCard.length > 1
            : existingAccountCard.length > 0);

        if (isExist) {
            toast.info(t('AccountCardExists', { accountCodeId: existingAccountCard[0].cardId }));
            return true;
        }
    }

    const handleSaveEditAccountCard = async () => {
        if (checkIfExistingAccountCard(accountCardOptions, accountCodeId, companyId, true)) {
            return;
        }
        const Item = addEditableItem;
        handleClose();
        try {
            setLoading(true)

            const response = await EnumsService.UpdateAccountCard(client.caseId, oldSelectedAccountCardItem.cardId, oldSelectedAccountCardItem.name, accountCodeId, accountCodeName, companyId, palCode, token);
            if (response.ok) {
                const newItem = {
                    ...Item,
                    accountCodeId: accountCodeId?.toString(),
                    accountCodeName: accountCodeName?.toString(),
                    accountCaseId: invoiceClientCaseId?.toString(),
                };
                setNewItem(newItem);
                let selectedAccountCard = {
                    cardId: accountCodeId,
                    caseId: client.caseId,
                    accountCaseId: companyId,
                    name: accountCodeName,
                    palCode: palCode,
                    client: null
                };
                setAccountCardOptions(prevCards => {
                    const updatedCards = prevCards.filter(card => card.cardId !== selectedAccountCard.cardId);
                    updatedCards.push(selectedAccountCard);
                    setIsUpdated(true);
                    return updatedCards;
                });
                // handleReopenEdit(editedItem);
                toast.success(t('CustomerSupplierUpdatedSuccessfully'));
                setSelectedOption(selectedAccountCard ? selectedAccountCard : null);

            } else {
                const errorText = await response.text();
                console.error('FailedToUpdateCustomerSupplier', errorText);
                toast.error(t('FailedToUpdateCustomerSupplier'));
            }
        } catch (error) {
            console.error('FailedToUpdateCustomerSupplier:', error);

            toast.error(t('FailedToUpdateCustomerSupplier'));

        }
        setLoading(false);
        setPalCode('');
        setAccountCodeId("");
        setAccountCodeName("");
        setAddNewAccountCardDocument(false);
        setShowAccountCardInputsEdit(false);
    };

    const handleAddAccountCard = async () => {
        if (checkIfExistingAccountCard(accountCardOptions, accountCodeId, companyId)) {
            return;
        }
        const Item = addEditableItem;
        handleClose();
        try {
            setLoading(true);
            const response = await EnumsService.AddAccountCard(client.caseId, accountCodeId, accountCodeName, companyId, palCode, token);
            if (response.ok) {
                const accountCodeId = await response.json();
                let selectedAccountCard = {
                    cardId: accountCodeId,
                    caseId: client.caseId,
                    accountCaseId: companyId,
                    name: accountCodeName,
                    palCode: palCode,
                    client: null
                };

                const newItem = {
                    ...Item,
                    accountCodeId: accountCodeId?.toString(),
                    accountCodeName: accountCodeName?.toString(),
                    accountCaseId: invoiceClientCaseId?.toString(),
                };
                setNewItem(newItem);
                setAccountCardOptions(prevCards => {
                    const updatedCards = [...prevCards, selectedAccountCard];
                    setIsUpdated(true);
                    return updatedCards;
                });

                toast.success(t('CustomerSupplierAddedSuccessfully'));
                setSelectedOption(selectedAccountCard ? selectedAccountCard : null);

            } else {
                const errorText = await response.text();
                console.error('Failed to edit user', errorText);
                toast.error(t('FailedToAddCustomerSupplier'));
            }
        } catch (error) {
            console.error('Error edit user:', error);
            toast.error(t('FailedToAddCustomerSupplier'));
        }
        setLoading(false);
        setPalCode('');
        setAccountCodeId("");
        setAccountCodeName("");
        setAddNewAccountCardDocument(false);
    };

    const onRefresh = async () => {
        setLoading(true);
        await fetchEnums(user, token, client);

    };

    const handleCloseAddNewAccountCardDocument = () => {
        setAccountCodeId("");
        setAccountCodeName("");
        setAddNewAccountCardDocument(false);
    };

    // const handleMuiChange = (e) => {
    //     const value = e.value;
    //     if (value.value1 === 'AddItem') {
    //         setAccountCodeName("");
    //         setAccountCodeId("");
    //         setCompanyId("");
    //         setAddNewAccountCardDocument(true);
    //         setAddNewAccountCard(true);
    //     }
    //     else {
    //         setItemEditing(true);
    //         setAccountCodeName(value.name);
    //         setCompanyId(value.accountCaseId);
    //         // const accountCodeId = accountCardOptions.find(option => option.name === selectedOption.value);
    //         setAccountCodeId(value.cardId);
    //         setInvoiceClientCaseId(value.cardId);
    //         addEditableItem.accountCaseId = value.accountCaseId;
    //         addEditableItem.accountCodeId = value.cardId;
    //         addEditableItem.accountCodeName = value.name;
    //         // Conditionally set creditAccount or debitAccount based on paymentAcceptanceType
    //         if (addEditableItem.paymentAcceptanceType === 'תקבול') {
    //             addEditableItem.creditAccount = value.name;
    //             setSelectedOption({ ...value, disableCreditAccount: true, disableDebitAccount: false });
    //         } else if (addEditableItem.paymentAcceptanceType === 'תשלום') {
    //             addEditableItem.debitAccount = value.name;
    //             setSelectedOption({ ...value, disableDebitAccount: true, disableCreditAccount: false });
    //         }
    //     }
    // };

    const handleMuiChange = (event, value) => {

        if (value?.value1 === 'AddItem') {
            setAccountCodeName("");
            setAccountCodeId("");
            setCompanyId("");
            setAddNewAccountCardDocument(true);
            setAddNewAccountCard(true);
        }
        else {
            setItemEditing(true);
            const updatedFields = {
                accountCaseId: value.accountCaseId,
                accountCodeId: value.cardId,
                accountCodeName: value.name,
            };

            setAccountCodeName(value.name);
            setCompanyId(value.accountCaseId);
            setAccountCodeId(value.cardId);
            setInvoiceClientCaseId(value.cardId);

            // Update addEditableItem state
            setAddEditableItem(prevState => ({
                ...prevState,
                ...updatedFields,
            }));
            setSelectedOption({ ...value });

            // Call the function to update items
            updateAllItems(value, updatedFields);
        }
        // else {
        //     setItemEditing(true);
        //     setAccountCodeName(value.name);
        //     setCompanyId(value.accountCaseId);
        //     // const accountCodeId = accountCardOptions.find(option => option.name === selectedOption.value);
        //     setAccountCodeId(value.cardId);
        //     setInvoiceClientCaseId(value.cardId);
        //     addEditableItem.accountCaseId = value.accountCaseId;
        //     addEditableItem.accountCodeId = value.cardId;
        //     addEditableItem.accountCodeName = value.name;
        //     // Conditionally set creditAccount or debitAccount based on paymentAcceptanceType
        //     if (addEditableItem.paymentAcceptanceType === 'תקבול') {
        //         addEditableItem.creditAccount = value.name;
        //         setSelectedOption({ ...value, disableCreditAccount: true, disableDebitAccount: false });
        //     } else if (addEditableItem.paymentAcceptanceType === 'תשלום') {
        //         addEditableItem.debitAccount = value.name;
        //         setSelectedOption({ ...value, disableDebitAccount: true, disableCreditAccount: false });
        //     }
        // }


    };

    const updateAllItems = (value, updatedFields) => {
        const updatedItems = ['checks', 'bankTransactions', 'creditCards', 'cash'];
        const paymentType = addEditableItem.paymentAcceptanceType;

        updatedItems.forEach(itemType => {
            addEditableItem[itemType]?.forEach((item, index) => {
                // Determine the field to update
                const fieldToUpdate = paymentType === 'תקבול' ? 'creditAccount' : 'debitAccount';

                handleItemChange(itemType, index, fieldToUpdate, value.cardId);
            });
        });

        // Update addEditableItem with new account data
        setAddEditableItem(prevState => ({
            ...prevState,
            ...updatedFields,
        }));
    };
    const handleAccountDelete = (option) => {
        setActionType('deleteAccountCard');
        setAccountCardIdToDelete(option.cardId);
        setIsModalVisible(true);
        // handleAccountCardDeleteClick(option.cardId);
    };

    const handleChangeAccountType = (selectedOption) => {
        setAccountType(selectedOption.value);
        setAddEditableItem((prevState) => ({
            ...prevState,
            paymentAcceptanceType: selectedOption ? selectedOption.value : ''
        }));
    };
    const customStyles = {
        valueContainer: (base, state) => ({
            ...base,
            justifyContent: "center"
        }),
    }

    const setPaymentDate = async (date) => {
        // const response1 = await ClientService.CheckIfMonthClosed(client.caseId, date, token);
        // const isClosedReportingMonth = await response1.json();
        // if (isClosedReportingMonth) {
        //     toast.error(t('MonthReportAlreadyClosedTryAgain'));
        //     return
        // }
        setAddEditableItem((prevItem) => ({
            ...prevItem,
            date: date.toISOString()
        }));
    }

    const handleDescriptionChange = (event) => {
        setDescription(event.target.value);
        setAddEditableItem((prevState) => ({
            ...prevState,
            description: event.target.value || ''
        }));
    };
    const handleChangeOriginalTaxClearance = (event) => {
        const raw = event.target.value.trim();      // always a string
        const normalised = raw === '' ? 0        // user cleared the field
            : Number(raw) // otherwise turn to number

        // Use the proper state update pattern
        handleAddEditableItemChange('withholdingTax', normalised);
        // setOriginalTaxClearance(value);
    };

    const handleRemoveItem = (type, index) => {
        let count = 0;

        // Update paymentAcceptanceItems
        const newItems = paymentAcceptanceItems.filter(item => {
            if (item.type === type) {
                if (count === index) {
                    count++;
                    return false;
                }
                count++;
            }
            return true;
        });
        setPaymentAcceptanceItems(newItems);

        // Update addEditableItem
        setAddEditableItem(prevItem => {
            if (!Array.isArray(prevItem[type])) return prevItem;
            const updatedTypeItems = prevItem[type].filter((_, idx) => idx !== index);
            return { ...prevItem, [type]: updatedTypeItems };
        });
    };

    const handleAddItem = (theType, suggestedAmount = '', accountFields = {}) => {
        const paymentType = addEditableItem.paymentAcceptanceType;

        const newItem = {
            type: theType,
            description: '',
            amount: suggestedAmount,
            paymentDate: new Date(),
            bankName: '',
            bankCode: '',
            bankBranchCode: '',
            supplierAccountNumber: '',
            bankTransactionsCode: caseSystemSettings.generalBankCardId,
            creditAccount: paymentType === 'תקבול' ? addEditableItem.accountCodeId || '' : '',
            debitAccount: paymentType === 'תשלום' ? addEditableItem.accountCodeId || '' : '',
            ...accountFields,
        };

        // Update paymentAcceptanceItems
        setPaymentAcceptanceItems(prevItems => [...prevItems, newItem]);

        // Update addEditableItem
        setAddEditableItem(prevItem => ({
            ...prevItem,
            [theType]: Array.isArray(prevItem[theType]) ? [...prevItem[theType], newItem] : [newItem]
        }));

    };

    const handleAddEditableItemChange = (name, value) => {
        let normalizedValue = value;
        if ((name === 'reportingMonthDate' || name === 'registrationMonthDate') && value instanceof Date) {
            normalizedValue = setReportingMonthToDay10(value);
        }
        setAddEditableItem(prev => ({ ...prev, [name]: normalizedValue }));
    };

    const patchAddEditableItem = useCallback((patch) => {
        setAddEditableItem(prev => ({ ...prev, ...patch }));
    }, []);

    const handleSave = async () => {


        try {
            setModalVisible(false);
            setOpenInvoiceCreatorModal(false);
            setLoading(true);
            // Prepare the data to be sent in the request body
            const updatedDocument = buildPaymentAcceptanceUpdatePayload(addEditableItem);




            // Call the UpdateDocument function from DocumentService
            const response = await DocumentService.UpdateDocument("PaymentAcceptances", token, updatedDocument);

            if (response.ok) {
                // Handle successful update
                if (addEditableItem.status === 'done') {
                    await handleDoneClick(addEditableItem.id, addEditableItem.type);
                } else if (addEditableItem.status === 'notDone') {
                    await handleNotDoneClick(addEditableItem.id, addEditableItem.type);
                }

                setWholeDataTransactions((prev) => {
                    const updated = { ...prev };

                    // Find the key where the value.id matches updatedDocument.id
                    const matchingKey = Object.keys(updated).find(
                        (key) => updated[key]?.id === updatedDocument.id
                    );

                    if (matchingKey) {
                        delete updated[matchingKey];
                    }

                    return updated;
                });
                toast.success(t('documentUpdateSuccess'));
                await FetchData();
            } else {
                // Handle any errors or display an error message
                toast.error(t('documentUpdateError'));
            }
        } catch (error) {
            console.error('documentUpdateError:', error);
            // Show an error toast message
            toast.error(t('documentUpdateError'));
        }
        await onRefresh();
        // handleClose(); // Function to revert or exit the edit mode
        setLoading(false);

    };

    // const handleItemChange = (type, index, field, value) => {



    //     setPaymentAcceptanceItems(prevItems => {
    //         let typeIndex = -1;
    //         const updatedItems = prevItems.map((item, idx) => {
    //             if (item.type === type) {
    //                 typeIndex += 1;
    //                 if (typeIndex === index) {
    //                     return { ...item, [field]: value };
    //                 }
    //             }
    //             return item;
    //         });

    //         // Update the corresponding field in addEditableItem

    //         setAddEditableItem(prevItem => {
    //             const updatedTypeItems = prevItem[type].map((item, idx) => {
    //                 if (idx === index) {
    //                     return { ...item, [field]: value };
    //                 }
    //                 return item;
    //             });

    //             return { ...prevItem, [type]: updatedTypeItems };
    //         });

    //         return updatedItems;
    //     });
    // };

    const handleItemChange = (type, index, field, value) => {
        setPaymentAcceptanceItems(prevItems => {
            let typeIndex = -1;
            const updatedItems = prevItems.map((item, idx) => {
                if (item.type === type) {
                    typeIndex += 1;
                    if (typeIndex === index) {
                        return { ...item, [field]: value };
                    }
                }
                return item;
            });

            // Update the corresponding field in addEditableItem
            setAddEditableItem(prevItem => {
                const updatedTypeItems = prevItem[type].map((item, idx) => {
                    if (idx === index) {
                        return { ...item, [field]: value };
                    }
                    return item;
                });

                // Conditionally update the fields based on payment type and field
                const paymentType = addEditableItem.paymentAcceptanceType;
                const shouldUpdateFields =
                    (paymentType === 'תקבול' && field === 'creditAccount') ||
                    (paymentType === 'תשלום' && field === 'debitAccount');

                const matchingOption = accountCardOptions.find(
                    option => option.cardId === value
                );

                const updatedFields = shouldUpdateFields && matchingOption
                    ? {
                        accountCaseId: matchingOption.accountCaseId || '',
                        accountCodeId: matchingOption.cardId || '',
                        accountCodeName: matchingOption.name || '',
                    }
                    : {};

                return { ...prevItem, ...updatedFields, [type]: updatedTypeItems };
            });

            return updatedItems;
        });
    };

    const setAccount = (field, input) => {
        //switch case on field
        switch (field) {
            case 'companyId':
                setCompanyId(input);
                setInvoiceClientCaseId(input);

                break;
            case 'accountCodeName':
                setAccountCodeName(input);

                break;
            case 'accountCodeId':
                setAccountCodeId(input);

                break;
            default:

        }
    }
    const handleClose = async (clearDocuments = true) => {
        setOpenInvoiceCreatorModal(false);
        setPaymentModal(false);
        setAddEditableItem({
            checks: [],
            creditCards: [],
            cash: [],
            bankTransactions: [],
            offsets: [],
            date: new Date()
        });
    }


    const [wholeDataTransactions, setWholeDataTransactions] = useState([]);


    const [creditOrDebitEdit, setCreditOrDebitEdit] = useState(null);
    const handleEdit = async (row) => {
        const isCredit = row.side ? row.side === 'credit' : row.creditAccount === mainCard;
        if (isCredit) {
            setCreditOrDebitEdit('credit');
        } else {
            setCreditOrDebitEdit('debit');
        }


        let currentIndex = -1;

        if (isCredit) {
            currentIndex = creditRows.findIndex(
                (transaction) => transaction.id === row.id
            );
        } else {
            currentIndex = debitRows.findIndex(
                (transaction) => transaction.id === row.id
            );
        }


        if (currentIndex === -1) {
            console.error('Transaction not found in sortedTransactions');
            return; // Exit if the transaction is not found
        }

        setCurrentIndex(currentIndex);

        // Extract the overall type from the row
        const overAllType = row.type.split('-')[0].trim();

        // Helper function to fetch data for a given row
        const getDataForRow = async (row, overAllType) => {
            // Check if the data is already cached
            if (wholeDataTransactions[row.id]) {

                setItemIdToDelete(row.id);
                setItemTypeToDelete(row.type);
                return wholeDataTransactions[row.id];
            }

            try {


                const isPaymentAcceptance = row.type !== overAllType;
                const documentId = isPaymentAcceptance ? row.paymentAcceptanceId : row.id;

                // Fetch the document data


                const response = await DocumentService.GetDocumentById(
                    overAllType,
                    client.caseId,
                    documentId,
                    token
                );

                if (!response.ok) {
                    throw new Error(`Failed to fetch data for document ID: ${documentId}`);
                }

                const data = await response.json();
                const dataWithDocType = { ...data, docType: overAllType };

                setItemIdToDelete(data.id);
                setItemTypeToDelete(overAllType);
                // Cache the fetched data
                setWholeDataTransactions((prevData) => ({
                    ...prevData,
                    [row.id]: dataWithDocType,
                }));

                return dataWithDocType;
            } catch (error) {
                console.error('Error fetching data for row:', row.id, error);
                throw error;
            }
        };

        try {
            // Fetch the data for the current row
            const data = await getDataForRow(row, overAllType);


            setEditedItem(data);
            if (!documentCount.documentIds.journalEntries.includes(data.id)) {

                setStatusCheck(true);
            } else {

                setStatusCheck(false);
            }

            // Set the selected account card
            const selectedAccountCard = {
                cardId: accountCodeId,
                caseId: client.caseId,
                accountCaseId: companyId,
                name: accountCodeName,
                palCode: palCode,
                client: null,
            };
            setSelectedOption(selectedAccountCard);

            // Handle different cases based on the overall type
            switch (overAllType) {
                case 'Incomes':
                case 'Expenses':
                    setEditedPopupItem(true);
                    setPaymentModal(false);
                    setEditedJournalItem(false);
                    break;

                case 'PaymentAcceptances':
                    handlePaymentAcceptance(row, data);
                    break;

                case 'JournalEntries':
                    setEditedPopupItem(true);
                    setPaymentModal(false);
                    setEditedJournalItem(true);
                    break;

                default:
                    // Fallback if the row type does not match any case
                    setEditedPopupItem(false);
                    setPaymentModal(false);
                    setEditedJournalItem(false);
                    break;
            }
        } catch (error) {
            console.error('Error during edit handling:', error);
            // Handle error (e.g., show a message to the user)
        }
    };

    // Helper function to handle PaymentAcceptances
    const handlePaymentAcceptance = (row, data) => {
        const itemType = row.type.split('-')[1].trim();
        const itemId = row.id;

        // Get the array corresponding to the itemType (e.g., 'checks', 'creditCards')
        const itemsArray = data[itemType];

        if (Array.isArray(itemsArray)) {
            // Find the index of the item with the matching ID
            const indexInArray = itemsArray.findIndex((item) => item.id === itemId);

            if (indexInArray !== -1) {
                setShowType({ type: itemType, index: indexInArray });
            } else {
                console.error('Item with the specified ID not found in the array.');
                setShowType({ type: itemType, index: -1 });
            }
        } else {
            console.error(`No array found for type "${itemType}" in data.`);
            setShowType({ type: itemType, index: -1 });
        }

        // Update state variables for the modal
        setOpenInvoiceCreatorModal(true);
        setAddEditableItem({ ...data });
        setPaymentModal(true);
        setEditedJournalItem(false);
        setEditedPopupItem(false);
        setItemEditing(true);
    };

    const handleRemoveMatchClick = (match) => {
        match.accountCardName = mainCard.name

        setSelectedMatch(match);
        setOpenRemoveMatchDialog(true);
    };

    // handleDeleteMatchClick = 

    const handleConfirmRemove = async () => {
        try {
            const deleteDTO = {
                CaseId: selectedMatch.caseId,
                Id: selectedMatch.id,
                Currency: selectedMatch.currency ?? null
            };

            // Call the delete service
            const response = await CardMatchService.DeleteMatch(deleteDTO, token);
            if (response.ok) {


                toast.success(t("MatchDeletedSuccessfully"));
                // Close the dialog after confirming
                await FetchData()
            }
            else {
                toast.error(t("ErrorDeletingMatch"));

            }
        } catch (error) {
            console.error("Error deleting match:", error);
            toast.error(t("ErrorDeletingMatch"));

        }
        setOpenRemoveMatchDialog(false);

    };

    const handleCloseRemoveMatchDialog = () => {
        setOpenRemoveMatchDialog(false);
    };

    /**
     * The matches the current selection belongs to. Both legs of a match are usually selected, and a
     * match can hold several rows on a side, so the rows are reduced to the matches behind them.
     */
    const selectedMatchIds = useMemo(() => {
        if (fetchType !== 'Matched') return [];
        const rowsById = new Map(
            [...creditMatchedRows, ...debitMatchedRows].map((row) => [row.id, row])
        );
        // A summary row stands for the rows it collapses, so the selection is expanded first.
        const selected = [
            ...expandSelectedIds(selectedCreditRows, creditDisplayedRows),
            ...expandSelectedIds(selectedDebitRows, debitDisplayedRows),
        ];
        const matchIds = new Set(
            selected.map(({ id }) => rowsById.get(id)?.matchId).filter(Boolean)
        );
        return matchData
            .filter((match) => matchIds.has(match.id))
            .map((match) => ({ id: match.id, caseId: match.caseId, currency: match.currency ?? null }));
    }, [fetchType, creditMatchedRows, debitMatchedRows, creditDisplayedRows, debitDisplayedRows,
        selectedCreditRows, selectedDebitRows, matchData]);

    /** Cancels every match the selection touches, one call each: the API deletes a single match. */
    const handleCancelSelectedMatches = async () => {
        if (selectedMatchIds.length === 0) return;
        const confirmed = await Swal.fire({
            title: t('AreYouSure'),
            text: `${t('CancelSelectedMatches')} (${selectedMatchIds.length})\n${t('RemoveMatchesConfirm')}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('RemoveMatch'),
            cancelButtonText: t('cancelButton'),
        });
        if (!confirmed.isConfirmed) return;

        setBottomDockBarLoading(true);
        let failed = 0;
        for (const match of selectedMatchIds) {
            try {
                // eslint-disable-next-line no-await-in-loop
                const response = await CardMatchService.DeleteMatch(
                    { CaseId: match.caseId ?? client.caseId, Id: match.id, Currency: match.currency },
                    token
                );
                if (!response.ok) failed += 1;
            } catch (error) {
                console.error('Error deleting match:', error);
                failed += 1;
            }
        }
        setSelectedCreditRows([]);
        setSelectedDebitRows([]);
        if (failed === 0) toast.success(t('MatchesDeletedSuccessfully'));
        else toast.error(`${t('ErrorDeletingMatch')} (${failed})`);
        await FetchData();
        setBottomDockBarLoading(false);
    };


    const getTitleMessage = () => {
        switch (actionType) {

            case 'closeMonth':
                return t('ConfirmCloseMonth');
            case 'openMonth':
                return t('ConfirmOpenMonth');
            default:
                return t('confirmDeleteTitle');
        }
    };
    const getConfirmMessage = () => {
        switch (actionType) {
            case 'closeMonth':
                return t('AreYouSureCloseMonth');
            case 'openMonth':
                return t('AreYouSureOpenMonth');
            default:
                return t('confirmDeleteMessage');

        }
    };
    const handleConfirmDelete = async () => {
        // Perform delete operation
        setLoading(true);
        setIsModalVisible(false);


        try {
            const response = await DocumentService.DeleteDocument(itemTypeToDelete, itemIdToDelete, token);
            if (response.ok) {

                await FetchData();
                toast.success(t("documentDeleteSuccess"), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
            } else {
                // Handle any errors or display an error toast
                const errorResponse = await response.json();
                console.error('Error deleting document:', errorResponse);

                // Show error toast
                toast.error(t("documentDeleteError"));
            }
        } catch (error) {
            console.error('Error deleting document:', error);

            // Show error toast
            toast.error(t("documentDeleteError"));
        }
        setLoading(false);
    };
    const handleConfirmDeletion = async () => {
        if (actionType === 'delete') {
            await handleConfirmDelete();
        }
    };


    // Memoize the Credit Table
    // Remount when checkboxSelection or column set changes — avoids MUI X v7 crash reading
    // computedWidth on stale column metadata (see mui/mui-x#13719 and column-count changes).
    const cardMatchingGridMountKey = `${fetchType}-${showingMatches}`;

    // On the matched tab the header search drives both grids, so the per-grid quick filter steps
    // aside; each grid still keeps its own column filters on top of it. Everywhere else the grids
    // filter themselves, as before.
    const matchedQuickFilter = useMemo(
        () => (matchedSearch.trim() ? matchedSearch.trim().split(/\s+/) : []),
        [matchedSearch]
    );
    const matchedCreditFilterModel = useMemo(
        () => ({ items: matchedCreditFilterItems, quickFilterValues: matchedQuickFilter }),
        [matchedCreditFilterItems, matchedQuickFilter]
    );
    const matchedDebitFilterModel = useMemo(
        () => ({ items: matchedDebitFilterItems, quickFilterValues: matchedQuickFilter }),
        [matchedDebitFilterItems, matchedQuickFilter]
    );
    const creditFilterProps = fetchType === 'Matched'
        ? {
            filterModel: matchedCreditFilterModel,
            onFilterModelChange: (model) => setMatchedCreditFilterItems(model.items || []),
        }
        : { onFilterModelChange: handleSortModelChange };
    const debitFilterProps = fetchType === 'Matched'
        ? {
            filterModel: matchedDebitFilterModel,
            onFilterModelChange: (model) => setMatchedDebitFilterItems(model.items || []),
        }
        : {};

    const memoizedCreditTable = useMemo(() => (
        <Box
            className={activePanel === 'credit' && fetchType === 'NotMatched' ? 'kbd-active-panel' : ''}
            sx={{ height: '100%', width: '100%', boxSizing: 'border-box', backgroundColor: "#fff" }}
        >
            <StyledDataGrid
                key={`credit-${cardMatchingGridMountKey}`}
                apiRef={apiRef}
                rows={isSummaryView ? creditDisplayedRows : (fetchType === 'Matched' ? creditMatchedRows : creditRows)}
                columns={CreditColumns}
                pageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                checkboxSelection={fetchType !== 'AllMatched'}
                disableRowSelectionOnClick
                onRowSelectionModelChange={handlePanelSelectionChange('credit')}
                getRowClassName={(params) =>
                    [
                        params.row.rowClassName || '',
                        params.row._summaryChild ? 'summary-child-row' : '',
                        params.id === focusedCreditId ? 'kbd-focused-row' : '',
                    ]
                        .filter(Boolean)
                        .join(' ')
                }
                getRowId={(row) => row.id}
                onCellEditCommit={(row) => handleEdit(row)}
                rowSelectionModel={selectedCreditRows}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: fetchType !== 'Matched',
                    },
                }}
                {...creditFilterProps}
                pagination
                onSortModelChange={handleSortModelChange}
                onCellDoubleClick={handleCellDoubleClick}
                onCellClick={handlePanelCellClick('credit')}
            />
        </Box>
    ), [displayedRows, CreditColumns, selectedCreditRows, fetchType, creditRows, debitRows, creditMatchedRows, cardMatchingGridMountKey, activePanel, focusedCreditId, creditAnchorId, rowViewMode, expandedInternalRows, matchedCreditFilterModel]); // Add dependencies as necessary

    // Memoize the Debit Table
    const memoizedDebitTable = useMemo(() => (
        <Box
            dir="rtl"
            className={activePanel === 'debit' && fetchType === 'NotMatched' ? 'kbd-active-panel' : ''}
            sx={{ height: '100%', width: '100%', boxSizing: 'border-box', backgroundColor: "#fff" }}
        >
            <StyledDataGrid
                key={`debit-${cardMatchingGridMountKey}`}
                apiRef={debitApiRef}
                rows={debitDisplayedRows}
                columns={DebitColumns}
                pageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                checkboxSelection={fetchType !== 'AllMatched'}
                disableRowSelectionOnClick
                onRowSelectionModelChange={handlePanelSelectionChange('debit')}
                getRowClassName={(params) =>
                    [
                        params.row.rowClassName || '',
                        params.row._summaryChild ? 'summary-child-row' : '',
                        params.id === focusedDebitId ? 'kbd-focused-row' : '',
                    ]
                        .filter(Boolean)
                        .join(' ')
                }
                getRowId={(row) => row.id}
                onCellEditCommit={(row) => handleEdit(row)}
                rowSelectionModel={selectedDebitRows}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: fetchType !== 'Matched',
                    },
                }}
                {...debitFilterProps}
                pagination
                onCellDoubleClick={handleCellDoubleClick}
                onCellClick={handlePanelCellClick('debit')}
            />
        </Box>
    ), [debitDisplayedRows, DebitColumns, selectedDebitRows, fetchType, creditRows, debitRows, cardMatchingGridMountKey, activePanel, focusedDebitId, debitAnchorId, rowViewMode, expandedCreditRows, matchedDebitFilterModel]); // Add dependencies as necessary

    const handleCloseItem = () => {
        setPalCode('');
        setShowAccountCardInputsEdit(false);
        setEditedAddAccountCard(false);
    };

    return (
        <>
            <AddAccountCardModal
                accountCardOptions={accountCardOptions}
                open={editedAddAccountCard}
                onClose={handleCloseItem}
                editedItem={newAccountCard}
                isEdit={isEditAccountCard}
                isRange={isRange}
                isClosedReportingMonth={isClosedReportingMonth}
                palCodes={formattedPalCodeOptions}
                propPalCode={palCode}
                setPalCode={setPalCode}
                direction={direction} // Pass direction for styling
                isAdd={!showAccountCardInputsEdit}
                client={client}
                token={token}
                setLoading={setLoading}
                handleChangeAfterAdd={handleChangeAfterAdd}
                fetchEnums={fetchEnums}
                type={addAccountCardType}
            />
            {/* adding bank transaction */}
            <AddExternalTransactionDialog
                addBankTransactionDialog={addBankTransactionDialog}
                handleCloseBankAddTransactionDialog={handleCloseBankAddTransactionDialog}
                t={t}
                newBankEditableItem={newBankEditableItem}
                changeNewBankTransaction={changeNewBankTransaction}
                handleAddBankTransaction={handleAddBankTransaction}
                // selectedTBank={selectedTBank}
            />

            <CustomDeleteConfirmationModal
                isVisible={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                onDelete={handleConfirmDeletion}
                confirmMessage={getConfirmMessage()}
                titleMessage={getTitleMessage()}
            />

            <AssetFoundDialog
                open={showAssetFoundDialog}
                asset={foundAsset}
                assetGroups={assetGroups}
                onClose={() => setShowAssetFoundDialog(false)}
                isDraggable={true}            // or false if you don't want drag
                caseId={client?.caseId}
                token={token}
                transactionId={editedItem.id}
                fetchEnums={fetchEnumsNoParams}
            />


            <AddOrEditBankDialog
                open={createBankModal}
                onClose={handleCloseCreateModal}
                isEditingBank={isEditingBank}
                selectedBankForCreate={selectedBankForCreate}
                bankOptions={bankOptions}  // Add actual bank options
                handleChangeBankForCreate={handleChangeBankForCreate}
                bankBranch={bankBranch}
                handleChangeCreateBank={handleChangeCreateBank}
                bankAccountNumber={bankAccountNumber}
                cardForNewBank={cardForNewBank}
                processedCardsData={processedCardsData}
                setCardForNewBank={setCardForNewBank}
                handleAddOrEditBank={handleAddOrEditBank}
                handleRemoveBank={handleRemoveBank}
                t={t}  // Replace with actual translation function
            />

            <>
                <>

                    {/* One header bar, in sections: what is being reconciled and over which
                        period, then what is shown and what can be exported, then the totals. */}
                    <div className="document-Dense-container" dir={direction} style={{ alignItems: 'center', flexWrap: 'wrap', position: 'relative', zIndex: 1 }}>
                        <Box
                            dir={direction}
                            sx={{
                                ...metricBarSx,
                                width: '100%',
                                rowGap: 1,
                            }}
                        >
                            <DateFilterBar
                                t={t}
                                direction={direction}
                                fetchType={fetchType}
                                isRange={isRange}
                                isMatchDate={isMatchDate}
                                startDate={startDate}
                                endDate={endDate}
                                handleEndDateChangeNew={handleEndDateChangeNew}
                                handleStartDateChangeNew={handleStartDateChangeNew}
                                handleRangeChange={handleRangeChange}
                                handleRangeSet={handleRangeSet}
                                inline
                            />
                            <Box sx={{ minWidth: 200, maxWidth: 280, flex: '0 1 240px' }}>
                            <AutocompleteSelectFilter
                                key={selectedFormattedAccountCard?.value ?? 'empty'}
                                options={processedCardsData.filter((opt) => opt.value !== 'AddItem' && opt.value1 !== 'AddItem')}
                                selectedValues={
                                    selectedFormattedAccountCard
                                        ? processedCardsData.find(
                                            (opt) => opt.value === selectedFormattedAccountCard.value
                                                || opt.cardId === selectedFormattedAccountCard.cardId
                                        ) || selectedFormattedAccountCard
                                        : null
                                }
                                onChange={handleFormattedAccountCardChange}
                                placeholder={t('Select AccountCard')}
                                isMultiple={false}
                                direction={direction}
                                searchable
                                portalMenu
                            />
                            </Box>
                            {availableCurrencies && availableCurrencies.length > 0 && (
                                <TextField
                                    select
                                    size="small"
                                    label={t('Currency')}
                                    value={selectedCurrency === null || selectedCurrency === undefined ? '' : selectedCurrency}
                                    onChange={(e) => {
                                        const raw = e.target.value;
                                        setSelectedCurrency(raw === '' ? null : Number(raw));
                                    }}
                                    sx={{
                                        // Same chrome as the account card picker beside it.
                                        width: 150,
                                        '& .MuiInputBase-root': { fontSize: '13px', height: 40, borderRadius: '8px' },
                                        '& .MuiOutlinedInput-notchedOutline': { borderWidth: '2px', borderColor: '#e5e7f6' },
                                    }}
                                >
                                    <MenuItem value="">{`${t('Shekel')} (₪)`}</MenuItem>
                                    {availableCurrencies.map((code) => (
                                        <MenuItem key={code} value={code}>{buildCurrencyLabel(code)}</MenuItem>
                                    ))}
                                </TextField>
                            )}

                            <HeaderDivider />

                            <FilterToggleGroup
                                label={t('Status')}
                                value={fetchType}
                                onChange={handleFetchTypeChange}
                                direction={direction}
                                options={[
                                    { value: 'Matched', label: t('Matched') },
                                    { value: 'NotMatched', label: t('NotMatched') },
                                ]}
                            />
                            <Tooltip title={t('SummaryViewTooltip')} arrow>
                                <span>
                                    <FilterToggleGroup
                                        label={t('DataView')}
                                        value={rowViewMode}
                                        onChange={handleRowViewModeChange}
                                        direction={direction}
                                        options={[
                                            { value: ROW_VIEW_MODES.FULL, label: t('FullView') },
                                            { value: ROW_VIEW_MODES.SUMMARY, label: t('SummaryView') },
                                        ]}
                                    />
                                </span>
                            </Tooltip>
                            {fetchType === 'NotMatched' && (
                                <Tooltip title={t('KbdGuideTitle')} arrow>
                                    <IconButton onClick={() => setShortcutsOpen(true)} sx={toolbarIconButtonSx('#304FFF')}>
                                        <KeyboardIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {/* Spelled out rather than icon-only: the three reports are easy to
                                mistake for one another at icon size. */}
                            {fetchType === 'NotMatched' && selectedCardId && (
                                <>
                                    <ActionChip
                                        label={t('DownloadPDFFile')}
                                        icon={<PictureAsPdfIcon fontSize="small" />}
                                        borderColor="#D32F2F"
                                        direction={direction}
                                        tooltip={`${t('DownloadPDFFile')} - ${t('UnmatchedReport')}`}
                                        onClick={() => handleDownloadUnmatched('pdf')}
                                    />
                                    <ActionChip
                                        label={t('DownloadExcelFile')}
                                        icon={<TableChartIcon fontSize="small" />}
                                        borderColor="#1D6F42"
                                        direction={direction}
                                        tooltip={`${t('DownloadExcelFile')} - ${t('UnmatchedReport')}`}
                                        onClick={() => handleDownloadUnmatched('excel')}
                                    />
                                </>
                            )}
                            {fetchType === 'NotMatched' && (
                                <ActionChip
                                    label={t('UnmatchedCardsReport')}
                                    icon={<SummarizeIcon fontSize="small" />}
                                    direction={direction}
                                    onClick={() => setUnmatchedCardsModalOpen(true)}
                                />
                            )}
                            {fetchType === 'Matched' && (
                                <>
                                    {/* One box over both lists: a match has a leg on each side, so
                                        searching only one of them hides half the answer. */}
                                    <TextField
                                        size="small"
                                        value={matchedSearch}
                                        onChange={(event) => setMatchedSearch(event.target.value)}
                                        placeholder={t('Search')}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon sx={{ fontSize: 18, color: '#304FFF' }} />
                                                </InputAdornment>
                                            ),
                                            endAdornment: matchedSearch ? (
                                                <InputAdornment position="end">
                                                    <IconButton size="small" onClick={() => setMatchedSearch('')}>
                                                        <FilterAltOffIcon sx={{ fontSize: 16 }} />
                                                    </IconButton>
                                                </InputAdornment>
                                            ) : null,
                                        }}
                                        sx={{
                                            width: 220,
                                            '& .MuiInputBase-root': { fontSize: '13px', height: 40, borderRadius: '8px' },
                                            '& .MuiOutlinedInput-notchedOutline': { borderWidth: '2px', borderColor: '#e5e7f6' },
                                        }}
                                    />
                                    <ActionChip
                                        label={`${t('CancelSelectedMatches')} (${selectedMatchIds.length})`}
                                        icon={<CancelRounded fontSize="small" />}
                                        borderColor="#D32F2F"
                                        direction={direction}
                                        disabled={selectedMatchIds.length === 0 || bottomDockBarLoading}
                                        onClick={handleCancelSelectedMatches}
                                    />
                                </>
                            )}

                            <Box sx={{ flex: '1 1 auto', minWidth: 0 }} />
                            <HeaderDivider />

                            {/* Card totals, read the same way as the bank side of a reconciliation:
                                the account, then its figures, with an unsettled balance called out. */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0, maxWidth: 260 }}>
                                <CreditCardIcon sx={{ fontSize: 18, color: '#304FFF' }} />
                                <Typography
                                    sx={{
                                        fontSize: '0.82rem',
                                        fontWeight: 700,
                                        color: 'var(--bank-text, #1f2437)',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {selectedFormattedAccountCard?.label || t('Select AccountCard')}
                                </Typography>
                            </Box>
                            <MetricChip label={t('Debit')} value={cardTotals.debit} />
                            <MetricChip label={t('Credit')} value={cardTotals.credit} />
                            <MetricChip
                                label={t('Balance')}
                                value={cardTotals.balance}
                                accent={cardTotals.settled ? undefined : '#D32F2F'}
                            />
                        </Box>
                    </div>
                    {/* current table */}
                    <div className='table-container' style={{ overflowX: 'visible', display: "flex", flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} >
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', marginBottom: '40px' }}>

                            <>

                                <div style={{ width: '49.7%', height: '60vh' }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '16px',
                                            backgroundColor: '#ebebeb',
                                            height: '40px'
                                        }}
                                    >

                                        <div className="table-titles">{t('Debit')}</div>
                                    </div>


                                    {memoizedDebitTable}


                                </div>

                                <div style={{ width: '49.7%', height: '60vh' }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            padding: '16px',
                                            backgroundColor: '#ebebeb',
                                            height: '40px'
                                        }}
                                    >
                                        <div className="table-titles">{t('Credit')}</div>



                                    </div>


                                    {memoizedCreditTable}


                                </div>




                            </>

                        </div>

                        {/* In the layout flow under the two lists, so it can never cover their
                            last rows the way the floating dock used to. */}
                        {(!(editedItem && paymentModal) && !(editedItem && editedPopupItem && Object.keys(editedItem).length > 0)) && (
                            <div className="bank-workspace__footer" style={{ width: '100%' }} dir={direction}>
                                <CardMatchingBottomDockBar
                                    debitColumns={DebitColumns}
                                    handleJournalEntries={withBottomDockBarLoading(handleCreateJournalEntries)}
                                    handleMatchEntries={withBottomDockBarLoading(handleMatchEntries)}
                                    handleAutoMatch={withBottomDockBarLoading(handleAutoMatchHeaders)}
                                    handleMatch={withBottomDockBarLoading(handleMatch)}
                                    handleClearMatches={withBottomDockBarLoading(handleClearMatches)}
                                    debitSum={debitSum}
                                    creditSum={creditSum}
                                    matches={matchedPairs}
                                    selectedDebitRows={selectedDebitRows}
                                    selectedCreditRows={selectedCreditRows}
                                    showMatchOptions={fetchType !== 'Matched'}
                                    loading={bottomDockBarLoading}
                                    direction={direction}
                                />
                            </div>
                        )}
                    </div>
                    <div style={{ margin: '24px 0 0 0' }}></div>
                </>

                <ToastContainer position={direction === 'rtl' ? 'top-left' : 'top-right'} rtl={direction === 'rtl'} />
                {loading && (
                    <div className="loader-container">
                        <PuffLoader
                            size={100}        // Larger size for better visibility
                            loading={loading}
                        />
                    </div>
                )}
                <ImportDialog
                    open={openImportDialog}
                    onClose={handleCloseImportDialog}
                    onImport={handleImport}
                    showXtramTemplateOption={true}
                    showIsracardTemplateOption={true}
                />
                <KeyboardShortcutsDialog
                    open={shortcutsOpen}
                    onClose={() => setShortcutsOpen(false)}
                    direction={direction}
                />
                <UnmatchedReportModal
                    open={unmatchedCardsModalOpen}
                    onClose={() => setUnmatchedCardsModalOpen(false)}
                    title={t('UnmatchedCardsReport')}
                    itemsLabel={t('AccountCards')}
                    items={accountCardsData}
                    palCodeOptions={formattedPalCodeOptions}
                    direction={direction}
                    defaultStartDate={startDate}
                    defaultEndDate={endDate}
                    onDownload={handleDownloadUnmatchedCards}
                    busy={unmatchedCardsBusy}
                />
                {/* Selection Summary - Always show when there are selections */}
                {/* <CardMatchingSelectionSummary
                    selectedDebitRows={selectedDebitRows}
                    selectedCreditRows={selectedCreditRows}
                    debitSum={debitSum}
                    creditSum={creditSum}
                    debitDisplayedRows={debitDisplayedRows}
                    displayedRows={displayedRows}
                    calculateSum={calculateSum}
                /> */}


                {/* Dialog for Create Journal Entries with Inputs */}

                <Dialog
                    open={isCreateDialogOpen}
                    onClose={handleCloseDialog}
                    maxWidth="md"
                    fullWidth
                    dir='rtl'
                    TransitionProps={{
                        // Land the keyboard on the first field as soon as the dialog opens.
                        onEntered: (node) => focusFirstField(node),
                    }}
                    onKeyDown={(e) => {
                        // Enter walks through the fields; after the last field
                        // (or with Ctrl/Cmd+Enter from anywhere) it confirms,
                        // once the required fields are filled. Skipped when an
                        // Autocomplete already consumed Enter to pick an option.
                        const canConfirm =
                            createJournalEntries === true
                                ? !!formValues.accountCard
                                : (!!formValues.debitAccount && !!formValues.creditAccount);
                        handleDialogEnterNavigation(e, {
                            canConfirm,
                            onConfirm: handleConfirm,
                        });
                    }}
                >
                    <DialogTitle style={{ textAlign: 'right !important' }}>  {t('CreateJournalEntries')}</DialogTitle>
                    <DialogContent>
                        {createJournalEntries === true ? (
                            // Case 2: Checked is true
                            <>
                                <Typography variant="body1" gutterBottom>
                                    {t('Select AccountCard')}
                                </Typography>
                                <Box component="form" noValidate autoComplete="off" sx={{ mt: 3 }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px', width: '30%', margin: '0 auto' }}>
                                        {/* <Autocomplete
                                            options={accountCardOptions}
                                            getOptionLabel={(option) => option.label}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={t('AccountCard')}
                                                    fullWidth
                                                    required
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        className: 'custom-input-box-sizing',
                                                    }}
                                                    sx={{
                                                        marginRight: '16px',
                                                        '.MuiInputBase-root': {
                                                            boxSizing: 'border-box !important', // Apply box-sizing to the desired class
                                                        }
                                                    }}
                                                />
                                            )}
                                            value={accountCardOptions.find(option => option.value === formValues.accountCard) || null}
                                            ListboxProps={{ dir: 'rtl' }}
                                            style={{ direction: "rtl", boxSizing: 'border-box !important' }}
                                            onChange={(event, newValue) => handleSelectChange('accountCard', newValue ? newValue.value : '')}
                                        /> */}
                                        <AccountAutocomplete
                                            type="accountCard"
                                            options={formattedAccountCardOptions}
                                            formValues={formValues}
                                            handleSelectChange={handleSelectChange}
                                            editedItem={editedItem}
                                            setCreditDebitSearchTerm={setCreditDebitSearchTerm}
                                            handleNoOptionCreditDebitClick={handleNoOptionCreditDebitClick}
                                            creditDebitSearchTerm={creditDebitSearchTerm}
                                            t={t}
                                            direction={direction}
                                            EditAccountCard={EditAccountCard}
                                            width="100%"
                                        />
                                    </div>
                                    <Typography variant="body1" gutterBottom>
                                        {t('Select SortCode')}
                                    </Typography>
                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px', width: '30%', margin: '0 auto' }}>
                                        <Autocomplete
                                            options={sortCodeIdOptions}
                                            getOptionLabel={(option) =>
                                                option?.sortCodeId != null || option?.sortCodeName
                                                    ? `${option.sortCodeId ?? option.value ?? ''} - ${option.sortCodeName ?? ''}`.trim()
                                                    : option?.label || ''
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={t('Code ID')}
                                                    fullWidth

                                                    InputProps={{
                                                        ...params.InputProps,
                                                        className: 'custom-input-box-sizing',
                                                    }}
                                                    sx={{
                                                        marginRight: '16px',
                                                        '.MuiInputBase-root': {
                                                            boxSizing: 'border-box !important', // Apply box-sizing to the desired class
                                                        }
                                                    }}
                                                />
                                            )}
                                            value={sortCodeIdOptions.find(option => option.value === formValues.sortCode) || null} // bind value
                                            ListboxProps={{ dir: 'rtl' }}
                                            style={{ direction: "rtl", boxSizing: 'border-box !important' }}
                                            onChange={(event, newValue) => handleSelectChange('sortCode', newValue ? newValue.value : '')}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '8px', marginBottom: '8px' }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={usePerRowReportingMonth}
                                                    onChange={(e) => setUsePerRowReportingMonth(e.target.checked)}
                                                    sx={{
                                                        color: '#E57C22',
                                                        '&.Mui-checked': { color: '#E57C22' },
                                                    }}
                                                />
                                            }
                                            label={t('UseTransactionDateAsReportingMonth')}
                                            sx={{
                                                margin: 0,
                                                '& .MuiFormControlLabel-label': {
                                                    fontSize: '14px',
                                                },
                                            }}
                                        />
                                    </div>
                                    {!usePerRowReportingMonth && (
                                        <>
                                            <Typography variant="body1" gutterBottom>
                                                {t('SelectMonthReport')}
                                            </Typography>


                                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px', width: '30%', margin: '0 auto' }}>
                                                <CustomMonthDatePickerMui
                                                    Date={setReportingMonthToDay10(
                                                        journalReportingMonthDate instanceof Date ? journalReportingMonthDate : journalReportingMonthDate ? new Date(journalReportingMonthDate) : new Date()
                                                    )}
                                                    setDate={(value) => {
                                                        const normalized = setReportingMonthToDay10(value);
                                                        setJournalReportingMonthDate(normalized);
                                                        setJournalRegistrationMonthDate(normalized);
                                                    }}
                                                    label="MonthReportDate"
                                                />
                                            </div>
                                            <Typography variant="body1" gutterBottom>
                                                {t('SelectMonthRegister')}
                                            </Typography>
                                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px', width: '30%', margin: '0 auto' }}>
                                                <CustomMonthDatePickerMui
                                                    Date={setReportingMonthToDay10(
                                                        journalRegistrationMonthDate instanceof Date ? journalRegistrationMonthDate : journalRegistrationMonthDate ? new Date(journalRegistrationMonthDate) : new Date()
                                                    )}
                                                    setDate={(value) => setJournalRegistrationMonthDate(setReportingMonthToDay10(value))}
                                                    label="MonthRegisterDate"
                                                />
                                            </div>
                                        </>
                                    )}
                                </Box>
                            </>
                        ) : (
                            <>
                                <Typography variant="body1" gutterBottom>
                                    {t('SelectedRowsTotalBankSum')} {beautifyNumber((debitSum - creditSum).toFixed(2))} {t('and')}
                                    {createJournalEntries === true
                                        ? t('CreateJournalEntryForEachRow')
                                        : t('CreateJournalEntryForAllRows')}.
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                    {t('FillDetailsToProceed')}
                                </Typography>
                                <Box component="form" noValidate autoComplete="off" sx={{ mt: 3 }}>

                                    {/* First Row: Amount (shekel) + foreign-currency amount when a currency is active) */}
                                    <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginBottom: '16px', width: (selectedCurrency !== null && selectedCurrency !== undefined) ? '60%' : '30%', margin: '0 auto' }}>
                                        <TextField
                                            fullWidth
                                            label={`${t('Amount')} (₪)`}
                                            name="amount"
                                            type="number"
                                            onChange={handleInputChange}
                                            InputProps={{
                                                className: 'custom-input-box-sizing',
                                            }}
                                            value={typeof formValues.amount === 'number' ? formValues.amount.toFixed(2) : formValues.amount}
                                        />
                                        {(selectedCurrency !== null && selectedCurrency !== undefined) && (
                                            <TextField
                                                fullWidth
                                                label={`${t('Amount')} ${buildCurrencyLabel(selectedCurrency)}`}
                                                name="foreignCurrencyAmount"
                                                type="number"
                                                onChange={handleInputChange}
                                                InputProps={{
                                                    className: 'custom-input-box-sizing',
                                                }}
                                                value={typeof formValues.foreignCurrencyAmount === 'number' ? formValues.foreignCurrencyAmount.toFixed(2) : formValues.foreignCurrencyAmount}
                                            />
                                        )}
                                    </div>

                                    {/* Second Row: Credit Account and Debit Account */}
                                    <div dir='rtl' style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '16px', marginTop: '16px' }}>

                                        {/* Debit Account Autocomplete */}
                                        {/* <Autocomplete
                                            options={debitAccountOptions}
                                            getOptionLabel={(option) => option.label}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={t('Debit Account')}
                                                    fullWidth
                                                    required
                                                    sx={{
                                                        marginRight: '16px',
                                                        '.MuiInputBase-root': {
                                                            boxSizing: 'border-box !important', // Apply box-sizing to the desired class
                                                        },
                                                    }}
                                                    InputProps={{
                                                        ...params.InputProps, // Spread the default InputProps
                                                        className: 'custom-input-box-sizing',
                                                    }}
                                                />
                                            )}
                                            value={debitAccountOptions.find(option => option.value === formValues.debitAccount) || null} // bind value
                                            ListboxProps={{ dir: 'rtl' }}
                                            style={{ direction: "rtl", boxSizing: 'border-box !important' }}
                                            sx={{ width: '30% !important' }}
                                            onChange={(event, newValue) => handleSelectChange('debitAccount', newValue ? newValue.value : '')}
                                        /> */}

                                        <AccountAutocomplete
                                            type="debitAccount"
                                            options={formattedAccountCardOptions}
                                            formValues={formValues}
                                            handleSelectChange={handleSelectChange}
                                            setCreditDebitSearchTerm={setCreditDebitSearchTerm}
                                            handleNoOptionCreditDebitClick={handleNoOptionCreditDebitClick}
                                            creditDebitSearchTerm={creditDebitSearchTerm}
                                            editedItem={editedItem}
                                            t={t}
                                            direction={direction}
                                            EditAccountCard={EditAccountCard}
                                            sx={{ width: "30% !important" }}
                                        />

                                        <AccountAutocomplete
                                            type="creditAccount"
                                            options={formattedAccountCardOptions}
                                            formValues={formValues}
                                            handleSelectChange={handleSelectChange}
                                            setCreditDebitSearchTerm={setCreditDebitSearchTerm}
                                            handleNoOptionCreditDebitClick={handleNoOptionCreditDebitClick}
                                            creditDebitSearchTerm={creditDebitSearchTerm}
                                            editedItem={editedItem}
                                            t={t}
                                            direction={direction}
                                            EditAccountCard={EditAccountCard}
                                            sx={{ width: "30% !important" }}
                                        />
                                    </div>

                                    {/* Third Row: Description and Reference */}
                                    <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '16px' }}>

                                        <TextField
                                            fullWidth
                                            label={t('Description')}
                                            name="description"
                                            onChange={handleInputChange}
                                            InputProps={{
                                                className: 'custom-input-box-sizing',
                                            }}
                                            sx={{ width: '30%' }}
                                            value={formValues.description}
                                        />
                                        <TextField
                                            fullWidth
                                            label={t('Reference')}
                                            name="reference"
                                            onChange={handleInputChange}
                                            InputProps={{
                                                className: 'custom-input-box-sizing',
                                            }}
                                            sx={{ width: '30%' }}
                                            value={formValues.reference}
                                        />
                                    </div>

                                    {/* Fourth Row: Code ID and ValueDate */}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px',gap: '8px' }}>
                                        <Autocomplete
                                            options={sortCodeIdOptions}
                                            getOptionLabel={(option) =>
                                                option?.sortCodeId != null || option?.sortCodeName
                                                    ? `${option.sortCodeId ?? option.value ?? ''} - ${option.sortCodeName ?? ''}`.trim()
                                                    : option?.label || ''
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={t('Code ID')}
                                                    fullWidth
                                                    sx={{
                                                        marginRight: '16px',
                                                        '.MuiInputBase-root': {
                                                            boxSizing: 'border-box !important', // Apply box-sizing to the desired class
                                                        }
                                                    }}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        className: 'custom-input-box-sizing',
                                                    }}
                                                />
                                            )}
                                            ListboxProps={{ dir: 'rtl' }}
                                            style={{ direction: 'rtl' }}
                                            sx={{ width: '30%' }}
                                            onChange={(event, newValue) => handleSelectChange('sortCodeId', newValue ? newValue.value : '')}
                                            value={sortCodeIdOptions.find(option => option.value === formValues.sortCodeId) || null} // bind value
                                        />
                                        <div style={{ width: '30%' }}>
                                            <TextField
                                                fullWidth
                                                label={t('ValueDate')}
                                                name="documentDate"
                                                type="date"
                                                InputLabelProps={{ shrink: true }}
                                                onChange={handleInputChange}
                                                InputProps={{
                                                    className: 'custom-input-box-sizing',
                                                }}
                                                sx={{ width: '100%' }}
                                                value={formValues.documentDate}
                                            />
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px', width: '30%', margin: '0 auto' }}>
                                            <CustomMonthDatePickerMui
                                                Date={setReportingMonthToDay10(
                                                    formValues.reportingMonthDate instanceof Date
                                                        ? formValues.reportingMonthDate
                                                        : formValues.reportingMonthDate
                                                            ? new Date(formValues.reportingMonthDate)
                                                            : new Date()
                                                )}
                                                setDate={(value) => {
                                                    const normalized = setReportingMonthToDay10(value);
                                                    setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        reportingMonthDate: normalized,
                                                        registrationMonthDate: normalized,
                                                    }));
                                                }}
                                                label="MonthReportDate"
                                            />
                                        </div>

                                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px', width: '30%', margin: '0 auto' }}>
                                            <CustomMonthDatePickerMui
                                                Date={setReportingMonthToDay10(
                                                    formValues.registrationMonthDate instanceof Date
                                                        ? formValues.registrationMonthDate
                                                        : formValues.registrationMonthDate
                                                            ? new Date(formValues.registrationMonthDate)
                                                            : new Date()
                                                )}
                                                setDate={(value) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    registrationMonthDate: setReportingMonthToDay10(value),
                                                }))}
                                                label="MonthRegisterDate"
                                            />
                                        </div>
                                    </div>

                                </Box>
                            </>
                        )}
                    </DialogContent>

                    <div className="button-row-JournalEntryMatch">
                        <button
                            className="JournalEntryMatch-create-buttons"
                            onClick={handleConfirm}
                            disabled={
                                createJournalEntries === true
                                    ? !formValues.accountCard
                                    : (!formValues.debitAccount || !formValues.creditAccount)
                            }
                        >
                            {t('Confirm')}
                        </button>
                        <button className="JournalEntryMatch-cancel-buttons" onClick={handleCloseDialog}>
                            {t('close')}
                        </button>
                    </div>
                </Dialog>

                <Dialog
                    open={isJournalEntriesListOpen}
                    onClose={() => setIsJournalEntriesListOpen(false)}
                    maxWidth="md"
                    fullWidth
                    dir='rtl'
                    onKeyDown={(e) => {
                        // Enter creates all previewed journal entries, unless the
                        // user tabbed onto a specific button (its own click applies).
                        if (e.target?.tagName === 'BUTTON') return;
                        if (e.key === 'Enter' && !e.shiftKey && !e.defaultMuiPrevented) {
                            e.preventDefault();
                            handleFinalizeEntries();
                        }
                    }}
                >
                    <DialogTitle style={{ textAlign: 'right !important' }}>{t('JournalEntriesPreview')}</DialogTitle>
                    <DialogContent>
                        {journalEntriesList.map((entry, index) => (
                            <Card key={index} sx={{
                                mb: 2,
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', // Customize the shadow to give a 3D effect
                                borderRadius: '10px', // Add rounded corners
                                transition: 'transform 0.2s', // Smooth transition on hover
                                '&:hover': {
                                    transform: 'translateY(-5px)', // Lift the card when hovered
                                }
                            }}>
                                <CardContent>
                                    <Typography variant="h6">{t('Entry')} #{index + 1}</Typography>
                                    <Typography variant="body1">{t('amount')} (₪): {beautifyNumber(Number(entry.amount).toFixed(2))}</Typography>
                                    {entry.foreignCurrencyCode !== null && entry.foreignCurrencyCode !== undefined && entry.foreignCurrencyAmount != null && (
                                        <Typography variant="body1">
                                            {t('amount')} {buildCurrencyLabel(entry.foreignCurrencyCode)}: {beautifyNumber(Number(entry.foreignCurrencyAmount).toFixed(2))}
                                        </Typography>
                                    )}
                                    <Typography variant="body1">
                                        {t('Debit Account')}: {entry.debitAccount} ({getAccountCardName(entry.debitAccount)})
                                    </Typography>
                                    <Typography variant="body1">
                                        {t('Credit Account')}: {entry.creditAccount} ({getAccountCardName(entry.creditAccount)})
                                    </Typography>
                                    <Typography variant="body1">{t('description')}: {entry.description}</Typography>
                                    <Typography variant="body1">{t('reference')}: {entry.reference}</Typography>
                                    <Typography variant="body1">{t('Document Date')}: {entry.documentDate}</Typography>
                                    <Typography variant="body1">{t('MonthReportDate')}: {formatMonthYearDate(entry.reportingMonthDate)}</Typography>
                                    <Typography variant="body1">{t('MonthRegisterDate')}: {formatMonthYearDate(entry.registrationMonthDate || entry.reportingMonthDate)}</Typography>
                                    {entry.sortCodeId && (
                                        <Typography variant="body1">{t('SortCode')}: {entry.sortCodeId} {getSortCodeName(entry.sortCodeId)}</Typography>
                                    )}
                                </CardContent>
                            </Card>
                        ))}
                    </DialogContent>


                    <div className="button-row-JournalEntryMatch">
                        <button className="JournalEntryMatch-create-buttons" onClick={handleFinalizeEntries}>
                            {t('create')}
                        </button>
                        <button className="JournalEntryMatch-cancel-buttons" onClick={() => setIsJournalEntriesListOpen(false)}>
                            {t('close')}
                        </button>
                    </div>
                </Dialog>


                {selectedMatch && (
                    <Dialog
                        open={openRemoveMatchDialog}
                        onClose={handleCloseRemoveMatchDialog}
                        aria-labelledby="confirm-dialog-title"
                        dir="rtl"
                        aria-describedby="confirm-dialog-description"
                        sx={{
                            '& .MuiDialog-paper': {
                                backgroundColor: 'white',
                                color: 'black',
                                borderRadius: '8px',
                                padding: '20px',
                            },
                        }}
                    >
                        <DialogTitle id="confirm-dialog-title" sx={{ fontSize: '20px', color: '#E57C22' }}>
                            {t("ConfirmRemoval")}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="confirm-dialog-description" sx={{ color: 'black', fontSize: '16px' }}>
                                {t("ConfirmRemoveMatch")}
                                <br />
                                <strong> {t("CaseID")}:</strong> {selectedMatch.caseId}
                                <br />
                                <strong> {t("AccountCard Name")}:</strong> {selectedMatch.accountCardName}
                                <br />
                                <strong> {t("AccountCodeID")}:</strong> {selectedMatch.accountCodeId}
                                <br />
                                <strong> {t("MatchDate")}:</strong> {formatDate(selectedMatch.matchDate)}
                                <br />
                                <strong> {t("MatchNumber")}:</strong> {selectedMatch.matchNumber}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: 'center', padding: '16px' }}>
                            <Button onClick={handleCloseRemoveMatchDialog} sx={{ color: '#E57C22', fontWeight: 'bold' }}>
                                {t('Cancel')}
                            </Button>
                            <Button
                                onClick={handleConfirmRemove}
                                sx={{
                                    backgroundColor: '#E57C22',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    padding: '8px 16px',
                                    borderRadius: '4px',
                                    '&:hover': {
                                        backgroundColor: '#d46d1e',
                                    },
                                }}
                                autoFocus
                            >
                                {t("Confirm")}
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </ >
            {editedItem && editedPopupItem && Object.keys(editedItem).length > 0 && (

                <EditModal
                    editedItem={editedItem}
                    fade={fade}
                    handlePrevious={handlePrevious}
                    handleNext={handleNext}
                    currentIndex={currentIndex}
                    filteredAndSortedData={sortedTransactions}
                    NoDocumentsPdf={NoDocumentsPdf}
                    t={t}
                    handleAccountChange={handleAccountChange}
                    isRange={isRange}
                    isClosedReportingMonth={isClosedReportingMonth}
                    accountCardOptions={editModalsAccountCardOptions}
                    handleChange={handleChange}
                    handleDateChange={handleDateChange}
                    CustomInput2={CustomInput2}
                    setReportingMonthDate={setReportingMonthDate}
                    handleVatRadioChange={handleVatRadioChange}
                    statusCheck={statusCheck}
                    handleRadioChange={handleRadioChange}
                    type={type}
                    editedAddAccountCard={editedAddAccountCard}
                    handleCloseEditAddNewAccountCardDocument={handleCloseEditAddNewAccountCardDocument}
                    handleEditAddAccountChange={handleEditAddAccountChange}
                    sortCodeIdOptions={sortCodeIdOptionsForEditModals}
                    debitAccountOptions={debitAccountOptions}
                    creditAccountOptions={creditAccountOptions}
                    handleUpdate={handleUpdate}
                    handleCancel={handleCancel}
                    handleDeleteClick={handleEditDeleteClick}
                    client={client}
                    token={token}
                    setAccountCardOptions={setAccountCardOptions}
                    setLoading={setLoading}
                    setEditedAddAccountCard={setEditedAddAccountCard}
                    setEditedItem={setEditedItem}
                    handleReopenEdit={handleReopenEdit}
                    showIframe={!editedJournalItem}
                    palCodes={formattedPalCodeOptions}
                    fetchEnums={fetchEnums}
                    RefreshPage={FetchData}
                    assets={assets}
                    assetClicked={handleAssetClicked}
                />
            )}

            {showChooseAsset && (
                <ChooseAsset
                    date={dateForAsset}
                    open={showChooseAsset}
                    onClose={() => handleAssetClose()}
                    type={editedItem?.docType} //or type
                    itemId={itemToAddToAsset}
                    client={client}
                    token={token}
                    editedItemVat={editedItem.vat}
                    onAssetChosen={(assetId) => {
                        setShowChooseAsset(false);
                    }}
                    onCreateAsset={(newAsset) => {
                        setShowChooseAsset(false);
                    }}
                    fullItem={itemForAssets}
                    saleEquipment={saleEquipment}
                    clickedAsset={clickedAsset}
                    fetchEnums={fetchEnums}
                    user={user}
                    setShowAddGroupModal={handleOpenGroudAdd}
                    assetGroups={assetGroups}

                />
            )}

            {showAddGroupModal && (
                <AddAssetGroup
                    open={showAddGroupModal}
                    onClose={() => setShowAddGroupModal(false)}
                    caseId={client.caseId}
                    token={token}
                    assetGroups={assetGroups}
                    refreshAssetGroups={() => {
                        // Refresh the list
                        fetchEnums(user, token, client);
                        setShowAddGroupModal(false);
                    }}
                />
            )}


            {(addEditableItem && paymentModal) && (
                <PaymentAcceptanceCreateEditModal
                    openInvoiceCreatorModal={openInvoiceCreatorModal}
                    handleClose={handleClose}
                    t={t}
                    itemEditing={itemEditing}
                    addNewAccountCardDocument={addNewAccountCardDocument}
                    companyId={companyId}
                    accountCodeName={accountCodeName}
                    accountCodeId={accountCodeId}
                    setAccount={setAccount}
                    Constants={Constants}
                    palCode={palCode}
                    setPalCode={setPalCode}
                    isRange={isRange}
                    addEditableItem={addEditableItem} // renamed from editedItem
                    isClosedReportingMonth={isClosedReportingMonth}
                    handleSaveEditAccountCard={handleSaveEditAccountCard}
                    handleAddAccountCard={handleAddAccountCard}
                    handleCloseAddNewAccountCardDocument={
                        handleCloseAddNewAccountCardDocument
                    }
                    accountCardOptions={originalAccountOptions}
                    selectedOption={selectedOption}
                    handleMuiChange={handleMuiChange}
                    handleEdit={handleEdit}
                    handleAccountDelete={handleAccountDelete} // renamed from handleDelete
                    handleChangeAccountType={handleChangeAccountType}
                    customStyles={customStyles}
                    setPaymentDate={setPaymentDate}
                    setReportingMonthDate={setReportingMonthDate}
                    handleDescriptionChange={handleDescriptionChange}
                    handleChangeOriginalTaxClearance={handleChangeOriginalTaxClearance}
                    handleAddEditableItemChange={handleAddEditableItemChange}
                    patchAddEditableItem={patchAddEditableItem}
                    handleItemChange={handleItemChange}
                    handleRemoveItem={handleRemoveItem}
                    showAccountCardInputsEdit={showAccountCardInputsEdit}
                    statusCheck={statusCheck}
                    handleRadioChange={handleRadioPAChange}
                    handleSave={handleSave}
                    buttonDisabled={buttonDisabled}
                    paymentBeingEdited={paymentBeingEdited}
                    CustomDropdown={CustomDropdown}
                    type={type}
                    direction={direction}
                    setAddNewAccountCardDocument={setAddNewAccountCardDocument}
                    isClosedReportingMonthAndIsRange={isClosedReportingMonthAndIsRange}
                    handleAddItem={handleAddItem}
                    CustomPalCode={CustomPalCode}
                    handleAccountEdit={handleAccountEdit}
                    handlePrevious={handlePrevious}
                    currentIndex={currentIndex}
                    filteredAndSortedData={filteredAndSortedTransactions}
                    handleNext={handleNext}
                    showType={showType}
                    handleDeleteClick={handleEditDeleteClick}
                    fetchEnums={fetchEnums}
                    client={client}
                    token={token}
                    setLoading={setLoading}
                    handleTransferRefresh={async () => {
                        await fetchEnums(user, token, client);
                    }}

                />
            )}
        </>
    );
}


export default CardMatching;